"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1391,7792],{

/***/ 10306:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ jobOffer_JobOfferComponent; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var free_solid_svg_icons = __webpack_require__(9725);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-light-svg-icons/index.mjs
var pro_light_svg_icons = __webpack_require__(38914);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(49929);
// EXTERNAL MODULE: ./components/shared/Button.js
var Button = __webpack_require__(15659);
// EXTERNAL MODULE: ./components/shared/ButtonLink.styled.tsx
var ButtonLink_styled = __webpack_require__(8536);
// EXTERNAL MODULE: ./components/TrimmedOfferLocations/index.ts + 1 modules
var TrimmedOfferLocations = __webpack_require__(63003);
// EXTERNAL MODULE: ./context/logged-user/loggeduser.context.tsx
var loggeduser_context = __webpack_require__(23357);
// EXTERNAL MODULE: ./features/job-offers/list/components/JobOffersListComponent.constants.ts
var JobOffersListComponent_constants = __webpack_require__(82324);
// EXTERNAL MODULE: ./hooks/useI18n/index.ts + 1 modules
var useI18n = __webpack_require__(39105);
// EXTERNAL MODULE: ../../node_modules/next/dist/client/router.js
var client_router = __webpack_require__(93642);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./services/service.event-tracking.ts + 1 modules
var service_event_tracking = __webpack_require__(27862);
// EXTERNAL MODULE: ./utils/app-urls.ts
var app_urls = __webpack_require__(62177);
// EXTERNAL MODULE: ./utils/job-offers-filter.ts
var job_offers_filter = __webpack_require__(55920);
// EXTERNAL MODULE: ./utils/localize.utils.ts
var localize_utils = __webpack_require__(38062);
// EXTERNAL MODULE: ./components/shared/Badge.js
var Badge = __webpack_require__(55952);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(40286);
// EXTERNAL MODULE: ./theme/index.js + 247 modules
var theme = __webpack_require__(90408);
;// CONCATENATED MODULE: ./components/jobOffer/bottomBar/OfferBottomBar.styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: sticky;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: ",
        ";\n  background-color: ",
        ";\n  color: ",
        ";\n  transform: translateY(100%);\n  animation: ShowBar 0.5s 4s forwards;\n  transition: opacity 0.2s;\n  margin-top: -3.5rem;\n  padding-top: ",
        ";\n  padding-bottom: ",
        ";\n\n  @keyframes ShowBar {\n    to {\n      transform: translateY(0);\n    }\n  }\n\n  &.is-scroll {\n    animation-delay: 1.5s;\n  }\n\n  &.is-detached {\n    opacity: 0;\n    pointer-events: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  max-width: ",
        ";\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n  margin: auto;\n  overflow: hidden;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background: transparent;\n  padding: 0;\n  border: 0;\n  color: ",
        ";\n  font-size: ",
        ";\n  margin-right: ",
        ";\n\n  svg {\n    width: 1.25rem !important;\n    height: 1.25rem;\n  }\n\n  span {\n    font-size: ",
        ";\n    text-transform: uppercase;\n    font-weight: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    display: none;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-shrink: 0;\n  display: block;\n  margin-right: ",
        ";\n  max-height: 2rem;\n  object-fit: contain;\n\n  @media (max-width: ",
        ") {\n    max-width: 8rem;\n    margin-right: 0;\n\n    .is-offer-closed & {\n      display: none;\n    }\n  }\n\n  @media (max-width: 399px) {\n    max-width: 5.5rem;\n  }\n\n  @media (max-width: 359px) {\n    display: none;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-right: ",
        ";\n  display: flex;\n  flex-direction: column;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n\n  @media (max-width: ",
        ") {\n    display: none;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-shrink: 0;\n  display: flex;\n\n  @media (max-width: ",
        ") {\n    display: none;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-right: ",
        ";\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  color: ",
        ";\n  text-transform: uppercase;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: ",
        ";\n  font-size: ",
        ";\n\n  span {\n    font-weight: ",
        ";\n    color: ",
        ";\n\n    &.extra {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-shrink: 0;\n  margin-left: auto;\n  display: flex;\n  align-items: center;\n\n  > * {\n    margin-left: ",
        ";\n  }\n\n  .share-button {\n    @media (max-width: ",
        ") {\n      svg {\n        margin-right: 0;\n        width: ",
        " !important;\n      }\n      span {\n        display: none;\n      }\n    }\n  }\n\n  .interested-button {\n    @media (max-width: ",
        ") {\n      padding: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: 3.5rem;\n  left: 0;\n  right: 0;\n  overflow: hidden;\n  background-color: ",
        ";\n  color: ",
        ";\n  transition: height 0.3s;\n\n  &:not(.is-active) {\n    height: 0 !important;\n  }\n\n  &.is-active {\n    overflow: auto;\n\n    @media (min-width: ",
        ") {\n      display: none;\n    }\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n\n  svg {\n    color: ",
        ";\n    width: ",
        " !important;\n    height: ",
        ";\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}


var StyledOfferBottomBar = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2f3afe7a-0"
})(_templateObject(), (0,theme/* zindex */.Y0)("bottomBar"), (0,theme/* color */.$_)("midnight_900"), (0,theme/* color */.$_)("text_default_inverse"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"));
var StyledOfferBottomBarContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2f3afe7a-1"
})(_templateObject1(), (0,theme/* container */.nC)("xlMax"), (0,theme/* spacing */.W0)("sm"), (0,theme/* spacing */.W0)("sm"));
var StyledOfferBottomBarNavTrigger = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-2f3afe7a-2"
})(_templateObject2(), (0,theme/* color */.$_)("midnight_500"), (0,theme/* fontSize */.JB)("xl"), (0,theme/* spacing */.W0)("md"), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* screen */.sp)("lg"));
var StyledOfferBottomBarLogo = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-2f3afe7a-3"
})(_templateObject3(), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("mdMax"));
var StyledOfferBottomBarPositionLocation = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2f3afe7a-4"
})(_templateObject4(), (0,theme/* spacing */.W0)("lg"), (0,theme/* screen */.sp)("lgMax"));
var StyledOfferBottomBarPosition = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-2f3afe7a-5"
})(_templateObject5(), (0,theme/* fontFamily */.I8)("serif"), (0,theme/* fontWeight */.Ue)("bold"));
var StyledOfferBottomBarLocation = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-2f3afe7a-6"
})(_templateObject6(), (0,theme/* fontWeight */.Ue)("bold"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* color */.$_)("text_subtle_inverse"));
var StyledOfferBottomBarSalaryGroup = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2f3afe7a-7"
})(_templateObject7(), (0,theme/* screen */.sp)("mdMax"));
var StyledOfferBottomBarSalary = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2f3afe7a-8"
})(_templateObject8(), (0,theme/* spacing */.W0)("md"));
var StyledOfferBottomBarSalaryTitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-2f3afe7a-9"
})(_templateObject9(), (0,theme/* fontWeight */.Ue)("bold"), (0,theme/* fontSize */.JB)("xs"), (0,theme/* color */.$_)("text_subtle_inverse"));
var StyledOfferBottomBarSalaryValue = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-2f3afe7a-10"
})(_templateObject10(), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* color */.$_)("text_subtle_inverse"), (0,theme/* color */.$_)("text_default_inverse"));
var StyledOfferBottomBarActions = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2f3afe7a-11"
})(_templateObject11(), (0,theme/* spacing */.W0)("sm"), (0,theme/* screen */.sp)("lgMax"), (0,theme/* spacing */.W0)("lg"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("sm"));
var StyledOfferBottomBarPageNav = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2f3afe7a-12"
})(_templateObject12(), (0,theme/* color */.$_)("midnight_900"), (0,theme/* color */.$_)("text_default_inverse"), (0,theme/* screen */.sp)("lg"));
var StyledOfferBottomBarUserApplied = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2f3afe7a-13"
})(_templateObject13(), (0,theme/* spacing */.W0)("xs"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* color */.$_)("positive_500"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"));

// EXTERNAL MODULE: ../../node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(70423);
// EXTERNAL MODULE: ./components/shared/Typography.js
var Typography = __webpack_require__(99655);
;// CONCATENATED MODULE: ./components/jobOffer/bottomBar/OfferBottomBarPageNav.styled.ts

function OfferBottomBarPageNav_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n  padding: ",
        " ",
        ";\n\n  ul {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n  }\n\n  li {\n    margin-top: 1.25rem;\n  }\n\n  a {\n    color: ",
        ";\n    display: inline-flex;\n    align-items: center;\n    transition: 0.3s;\n\n    &::before {\n      content: '';\n      display: block;\n      width: ",
        ";\n      height: ",
        ";\n      border-radius: ",
        ";\n      background-color: ",
        ";\n      border: ",
        " solid transparent;\n      background-clip: padding-box;\n      box-sizing: content-box;\n      margin-right: ",
        ";\n      transition: 0.3s;\n    }\n\n    &:hover {\n      color: ",
        ";\n      cursor: pointer;\n\n      &::before {\n        border-color: ",
        ";\n      }\n    }\n\n    &.is-active {\n      color: ",
        ";\n      font-weight: ",
        ";\n\n      &::before {\n        background-color: ",
        ";\n        border-color: ",
        ";\n      }\n    }\n  }\n"
    ]);
    OfferBottomBarPageNav_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var OfferBottomBarPageNav_styled_StyledOfferBottomBarPageNav = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2b131028-0"
})(OfferBottomBarPageNav_styled_templateObject(), (0,theme/* container */.nC)("xlMax"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("lg"), (0,theme/* color */.$_)("text_default_inverse"), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("xs"), (0,theme/* radius */.q0)("full"), (0,theme/* color */.$_)("midnight_300"), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("xs"), (0,theme/* color */.$_)("text_active"), (0,theme/* color */.$_)("midnight_700"), (0,theme/* color */.$_)("text_active"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* color */.$_)("active"), (0,theme/* color */.$_)("midnight_700"));

;// CONCATENATED MODULE: ./components/jobOffer/bottomBar/OfferBottomBarPageNav.tsx





var OfferBottomBarPageNav = function(param) {
    var sections = param.sections, togglePageNav = param.togglePageNav;
    var t = (0,useI18n/* useI18n */.Q)("job-offer").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(OfferBottomBarPageNav_styled_StyledOfferBottomBarPageNav, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading4 */.k8, {
                children: t("footer.bottomBar.index")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                children: sections === null || sections === void 0 ? void 0 : sections.map(function(s, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Link */.rU, {
                            activeClass: "is-active",
                            to: s.section || "",
                            spy: true,
                            onClick: togglePageNav,
                            children: s.tooltip
                        })
                    }, i);
                })
            })
        ]
    });
};
/* harmony default export */ var bottomBar_OfferBottomBarPageNav = (OfferBottomBarPageNav);

;// CONCATENATED MODULE: ./components/jobOffer/bottomBar/OfferBottomBar.tsx




















var OfferBottomBar = function(props) {
    var ref;
    var t = (0,useI18n/* useI18n */.Q)("job-offer").t;
    var locale = (0,client_router.useRouter)().locale;
    var ref1 = (0,react.useContext)(loggeduser_context/* LoggedUserContext */.Vi), user = ref1.user, loadingUser = ref1.loadingUser;
    var nav = (0,react.useRef)(null);
    var bottomBarRef = (0,react.useRef)(null);
    var ref2 = (0,react.useState)(""), setActive = ref2[0], setActiveState = ref2[1];
    var ref3 = (0,react.useState)(false), setAttached = ref3[0], setAttachedState = ref3[1];
    var ref4 = (0,react.useState)(false), isScroll = ref4[0], setScrollState = ref4[1];
    var hasLocations = props.jobLocationsSummary.trimmedCount > 0;
    var salaryMin = props.salaryMin || null;
    var salaryMax = props.salaryMax || null;
    var returnUrl = "/".concat(locale).concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.portalV2Dashboard */.uu.portalV2Dashboard, locale));
    var trackApplyClick = function() {
        service_event_tracking/* default.track */.Z.track({
            type: "Offers - Offer Interested",
            properties: {
                buttonName: "sectionCTA",
                offerCompany: props.companyName,
                offerName: props.internalCode,
                offerURL: window.location.href,
                pageLanguage: locale
            }
        });
    };
    var togglePageNav = function() {
        setActiveState(setActive === "" ? "is-active" : "");
    };
    var handleScroll = function() {
        var bottomBarPosition = 0;
        setScrollState(true);
        if (bottomBarRef === null || bottomBarRef === void 0 ? void 0 : bottomBarRef.current) {
            bottomBarPosition = bottomBarRef.current.getBoundingClientRect().bottom;
        }
        setAttachedState(window.innerHeight > bottomBarPosition + 150);
    };
    (0,react.useEffect)(function() {
        window.addEventListener("scroll", handleScroll);
        return function() {
            return window.removeEventListener("scroll", handleScroll);
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOfferBottomBar, {
        id: "bottom-bar",
        ref: bottomBarRef,
        className: "".concat(setAttached ? "is-detached" : "", " ").concat(isScroll ? "is-scroll" : "", " ").concat(props.closed ? "is-offer-closed" : ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOfferBottomBarContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOfferBottomBarNavTrigger, {
                        type: "button",
                        onClick: togglePageNav,
                        children: [
                            setActive === "is-active" && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: pro_light_svg_icons/* faTimes */.NBC
                            }),
                            setActive !== "is-active" && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: free_solid_svg_icons/* faListAlt */.zDS
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t("footer.bottomBar.menu")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledOfferBottomBarLogo, {
                        src: props.companyLogo,
                        alt: props.companyName
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOfferBottomBarPositionLocation, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledOfferBottomBarPosition, {
                                children: props.jobTitle
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledOfferBottomBarLocation, {
                                children: props.jobRemote === 100 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        props.jobRemote,
                                        "%",
                                        " ",
                                        props.jobRemote === 100 ? t("footer.remote") : t("footer.remotework"),
                                        hasLocations && typeof props.jobRemote !== "undefined" && props.jobRemote < 100 && props.jobRemote > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                " ",
                                                t("footer.and"),
                                                " "
                                            ]
                                        }),
                                        hasLocations && typeof props.jobRemote !== "undefined" && props.jobRemote === 100 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                " ",
                                                t("footer.or"),
                                                " "
                                            ]
                                        }),
                                        hasLocations && /*#__PURE__*/ (0,jsx_runtime.jsx)(TrimmedOfferLocations/* TrimmedOfferLocations */.J, {
                                            locationsSummary: props.jobLocationsSummary
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        hasLocations && /*#__PURE__*/ (0,jsx_runtime.jsx)(TrimmedOfferLocations/* TrimmedOfferLocations */.J, {
                                            locationsSummary: props.jobLocationsSummary
                                        }),
                                        hasLocations && typeof props.jobRemote !== "undefined" && props.jobRemote !== 0 && props.jobRemote < 100 && props.jobRemote > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                " ",
                                                t("footer.and"),
                                                " "
                                            ]
                                        }),
                                        hasLocations && typeof props.jobRemote !== "undefined" && props.jobRemote !== 0 && props.jobRemote === 100 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                " ",
                                                t("footer.or"),
                                                " "
                                            ]
                                        }),
                                        props.jobRemote !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                props.jobRemote,
                                                "%",
                                                " ",
                                                props.jobRemote === 100 ? t("footer.remote") : t("footer.remotework")
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOfferBottomBarSalaryGroup, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOfferBottomBarSalary, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledOfferBottomBarSalaryTitle, {
                                        children: props.isFreelance ? t("footer.fee") : t("footer.salary")
                                    }),
                                    props.isFreelance ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOfferBottomBarSalaryValue, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                                children: [
                                                    !!props.hourlyRateTo && !props.hourlyRateFrom && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        children: [
                                                            t("footer.up_to"),
                                                            " "
                                                        ]
                                                    }),
                                                    !!props.hourlyRateFrom && !props.hourlyRateTo && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        children: [
                                                            t("footer.from"),
                                                            " "
                                                        ]
                                                    }),
                                                    !!props.hourlyRateFrom && props.hourlyRateFrom !== props.hourlyRateTo && props.hourlyRateFrom,
                                                    !!props.hourlyRateFrom && props.hourlyRateFrom !== props.hourlyRateTo && !!props.hourlyRateTo && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "-"
                                                    }),
                                                    !!props.hourlyRateTo && props.hourlyRateTo,
                                                    props.currency
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                children: [
                                                    "/",
                                                    t("common:salary.per_hour")
                                                ]
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOfferBottomBarSalaryValue, {
                                        children: [
                                            !salaryMin && salaryMax && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                children: [
                                                    t("footer.up_to"),
                                                    " "
                                                ]
                                            }),
                                            salaryMin && !salaryMax && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                children: [
                                                    t("footer.from"),
                                                    " "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: props.currency
                                            }),
                                            salaryMin && salaryMax && salaryMin !== salaryMax && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    salaryMin,
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "-"
                                                    }),
                                                    " ",
                                                    salaryMax
                                                ]
                                            }),
                                            salaryMin && salaryMax && salaryMin === salaryMax && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: salaryMax
                                            }),
                                            !salaryMin && salaryMax && /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                children: salaryMax
                                            }),
                                            salaryMin && !salaryMax && /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                children: salaryMin
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "K"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            props.hasBonus && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOfferBottomBarSalary, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledOfferBottomBarSalaryTitle, {
                                        children: t("footer.bonus")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOfferBottomBarSalaryValue, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "extra",
                                                children: "+"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: props.currency
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: props.bonus
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "K"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            props.hasEquity && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOfferBottomBarSalary, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledOfferBottomBarSalaryTitle, {
                                        children: t("footer.equity")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOfferBottomBarSalaryValue, {
                                        children: [
                                            !props.equityInf && props.equitySup && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "extra",
                                                children: [
                                                    t("offer.up_to"),
                                                    " "
                                                ]
                                            }),
                                            props.equityInf && !props.equitySup && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "extra",
                                                children: [
                                                    t("offer.from"),
                                                    " "
                                                ]
                                            }),
                                            props.equityInf && props.equitySup && props.equityInf !== props.equitySup && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                        children: props.equityInf
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "%"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: " - "
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                        children: props.equitySup
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "%"
                                                    })
                                                ]
                                            }),
                                            props.equityInf && props.equitySup && props.equityInf === props.equitySup && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                        children: props.equitySup
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "%"
                                                    })
                                                ]
                                            }),
                                            !props.equityInf && props.equitySup && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                        children: props.equitySup
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "%"
                                                    })
                                                ]
                                            }),
                                            props.equityInf && !props.equitySup && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                        children: props.equityInf
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "%"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOfferBottomBarActions, {
                        children: [
                            props.closed && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* Badge */.C, {
                                        variant: "negative",
                                        children: t("footer.bottomBar.closedOffer")
                                    }),
                                    !props.userApplied && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.jobOffers */.uu.jobOffers, locale), "?").concat((0,job_offers_filter/* getUrlParamsFromJobOffersFilter */.Ci)(JobOffersListComponent_constants/* DEFAULT_FILTER */.XW, (0,localize_utils/* getLocale */.K)(locale))),
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonLink_styled/* default */.C, {
                                            variant: "secondaryInverse",
                                            sizes: "sm",
                                            "aria-label": t("footer.bottomBar.otherOffers"),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                    icon: free_solid_svg_icons/* faListUl */.gf$
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    "aria-hidden": "true",
                                                    children: t("footer.bottomBar.otherOffers")
                                                })
                                            ]
                                        })
                                    }),
                                    props.userApplied && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOfferBottomBarUserApplied, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                icon: free_solid_svg_icons/* faCheckCircle */.f8k
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                "aria-hidden": "true",
                                                children: t("footer.bottomBar.alreadyApplied")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            !props.closed && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* Button */.z, {
                                        variant: "tertiaryInverseLightIcon",
                                        sizes: "sm",
                                        id: "bottombar-share-button",
                                        className: "share-button",
                                        "aria-label": t("share.share"),
                                        onClick: props.openShareModal,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                icon: pro_light_svg_icons/* faShareSquare */.tFX
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                "aria-hidden": "true",
                                                children: t("share.share")
                                            })
                                        ]
                                    }),
                                    user && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            !props.userApplied && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonLink_styled/* default */.C, {
                                                variant: "brandTalent",
                                                sizes: "lg",
                                                id: "bottombar-interested-button",
                                                className: "interested-button",
                                                "aria-label": t("footer.bottomBar.interested"),
                                                href: "#",
                                                onClick: function(e) {
                                                    trackApplyClick();
                                                    if (props.handleApplyClick) {
                                                        props.handleApplyClick(e);
                                                    }
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                        icon: free_solid_svg_icons/* faCheckCircle */.f8k
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        "aria-hidden": "true",
                                                        children: t("footer.bottomBar.interested")
                                                    })
                                                ]
                                            }),
                                            props.userApplied && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOfferBottomBarUserApplied, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                        icon: free_solid_svg_icons/* faCheckCircle */.f8k
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        "aria-hidden": "true",
                                                        children: t("footer.bottomBar.alreadyApplied")
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    !user && !loadingUser && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonLink_styled/* default */.C, {
                                        variant: "brandTalent",
                                        sizes: "lg",
                                        id: "bottombar-interested-button",
                                        className: "interested-button",
                                        "aria-label": t("footer.bottomBar.interested"),
                                        onClick: function(e) {
                                            e.preventDefault();
                                            trackApplyClick();
                                            service_event_tracking/* default.trackLandingCtaClicked */.Z.trackLandingCtaClicked("footer-job");
                                            // Delay the redirect to give some time to the tracking to complete
                                            setTimeout(function() {
                                                var url = "".concat(window.location.origin, "/").concat(locale).concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.join */.uu.join, locale), "?locale=").concat(locale, "&offerId=").concat(props.id, "&source=footer-job&returnUrl=").concat(returnUrl);
                                                window.location.replace(url);
                                            }, 300);
                                        },
                                        href: "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.join */.uu.join, locale), "?locale=").concat(locale, "&offerId=").concat(props.id, "&source=footer-job&returnUrl=").concat(returnUrl),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                icon: free_solid_svg_icons/* faCheckCircle */.f8k
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                "aria-hidden": "true",
                                                children: t("footer.bottomBar.interested")
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledOfferBottomBarPageNav, {
                ref: nav,
                className: "".concat(setActive),
                style: {
                    height: (ref = nav.current) === null || ref === void 0 ? void 0 : ref.scrollHeight
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bottomBar_OfferBottomBarPageNav, {
                    sections: props.sections,
                    togglePageNav: togglePageNav
                })
            })
        ]
    });
};
/* harmony default export */ var bottomBar_OfferBottomBar = (OfferBottomBar);

;// CONCATENATED MODULE: ./components/jobOffer/JobOfferSection.styled.tsx

function JobOfferSection_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      background-color: ",
        ";\n    "
    ]);
    JobOfferSection_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function JobOfferSection_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding-top: ",
        ";\n  padding-bottom: ",
        ";\n\n  @media (min-width: ",
        ") {\n    padding-top: ",
        ";\n    padding-bottom: ",
        ";\n  }\n\n  ",
        "\n"
    ]);
    JobOfferSection_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function JobOfferSection_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: auto;\n  max-width: calc(",
        " + ",
        " * 2);\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n"
    ]);
    JobOfferSection_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function JobOfferSection_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n"
    ]);
    JobOfferSection_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function JobOfferSection_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    JobOfferSection_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function JobOfferSection_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  margin-bottom: 0;\n  margin-top: ",
        ";\n\n  @media (min-width: ",
        ") {\n    margin-top: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n    margin-top: ",
        ";\n  }\n"
    ]);
    JobOfferSection_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}



var sectionVariants = {
    alt: {
        backgroundColor: (0,theme/* color */.$_)("sand_100")
    }
};
var StyledJobOfferSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-d44be200-0"
})(JobOfferSection_styled_templateObject1(), (0,theme/* color */.$_)("white"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* screen */.sp)("lg"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("xl4"), function(param) {
    var sectionBg = param.sectionBg;
    return sectionBg && sectionVariants[sectionBg] && (0,styled_components_browser_esm/* css */.iv)(JobOfferSection_styled_templateObject(), sectionVariants[sectionBg].backgroundColor);
});
var StyledJobOfferSectionContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d44be200-1"
})(JobOfferSection_styled_templateObject2(), (0,theme/* container */.nC)("lg"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"));
var StyledJobOfferSectionHeader = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
    componentId: "sc-d44be200-2"
})(JobOfferSection_styled_templateObject3(), (0,theme/* spacing */.W0)("sm"), (0,theme/* spacing */.W0)("lg"));
var StyledJobOfferSectionTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography/* Heading2 */.XJ).withConfig({
    componentId: "sc-d44be200-3"
})(JobOfferSection_styled_templateObject4());
var StyledJobOfferSectionIntro = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d44be200-4"
})(JobOfferSection_styled_templateObject5(), (0,theme/* fontSize */.JB)("md"), (0,theme/* spacing */.W0)("lg"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* spacing */.W0)("xl3"));

;// CONCATENATED MODULE: ./components/jobOffer/JobOfferSection.tsx



var JobOfferSection = function(param) {
    var name = param.name, sectionBg = param.sectionBg, children = param.children, title = param.title, intro = param.intro;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
        name: name,
        id: name,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledJobOfferSection, {
            sectionBg: sectionBg,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledJobOfferSectionContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledJobOfferSectionHeader, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledJobOfferSectionTitle, {
                                editorial: true,
                                children: title
                            }),
                            intro && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledJobOfferSectionIntro, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    dangerouslySetInnerHTML: {
                                        __html: intro || ""
                                    }
                                })
                            })
                        ]
                    }),
                    children
                ]
            })
        })
    });
};
/* harmony default export */ var jobOffer_JobOfferSection = (JobOfferSection);

// EXTERNAL MODULE: ./components/shared/MarkdownComponent.tsx
var MarkdownComponent = __webpack_require__(57792);
// EXTERNAL MODULE: ./components/jobOffer/faqs/Faqs.styled.js
var Faqs_styled = __webpack_require__(33246);
;// CONCATENATED MODULE: ./components/jobOffer/faqs/Faqs.js






function Faqs(param) {
    var faqsItem = param.faqsItem, migratedToMarkdown = param.migratedToMarkdown;
    var toggleAccordion = function toggleAccordion() {
        setActiveState(setActive === "" ? "is-active" : "");
        setHeightState(setActive === "is-active" ? "0px" : "".concat(content.current.scrollHeight, "px"));
    };
    var ref = (0,react.useState)(""), setActive = ref[0], setActiveState = ref[1];
    var ref1 = (0,react.useState)("0px"), setHeight = ref1[0], setHeightState = ref1[1];
    var content = (0,react.useRef)(null);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Faqs_styled/* StyledFaqs */.Av, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Faqs_styled/* StyledFaqsQuestion */.qB, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Faqs_styled/* StyledFaqsButton */.LS, {
                    className: "".concat(setActive),
                    onClick: toggleAccordion,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Faqs_styled/* StyledFaqsTitle */.zP, {
                            children: faqsItem.q
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Faqs_styled/* StyledFaqsIcon */.Eq, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: free_solid_svg_icons/* faCaretDown */.eW2
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Faqs_styled/* StyledFaqsContent */.EU, {
                ref: content,
                style: {
                    maxHeight: "".concat(setHeight)
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Faqs_styled/* StyledFaqsText */.FG, {
                    children: migratedToMarkdown ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MarkdownComponent["default"], {
                        content: faqsItem.a || ""
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        dangerouslySetInnerHTML: {
                            __html: faqsItem.a || ""
                        }
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var faqs_Faqs = (Faqs);

;// CONCATENATED MODULE: ./components/jobOffer/faqs/FaqsSection.styled.js

function FaqsSection_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: auto;\n  max-width: ",
        ";\n  border-bottom: 1px solid ",
        ";\n  counter-reset: faqs;\n"
    ]);
    FaqsSection_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledFaqsSection = styled_components_browser_esm/* default.dl.withConfig */.ZP.dl.withConfig({
    componentId: "sc-66d20601-0"
})(FaqsSection_styled_templateObject(), (0,theme/* container */.nC)("md"), (0,theme/* color */.$_)("midnight_200"));

;// CONCATENATED MODULE: ./components/jobOffer/faqs/FaqsSection.tsx





var FaqsSection = function(param) {
    var faqs = param.faqs, migratedToMarkdown = param.migratedToMarkdown;
    var t = (0,useI18n/* useI18n */.Q)("job-offer").t;
    if (!faqs || faqs.length <= 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jobOffer_JobOfferSection, {
        name: "faqs",
        title: t("titles.faqs"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFaqsSection, {
            children: faqs.map(function(f, i) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(faqs_Faqs, {
                    faqsItem: f,
                    migratedToMarkdown: migratedToMarkdown
                }, i);
            })
        })
    });
};
/* harmony default export */ var faqs_FaqsSection = (FaqsSection);

// EXTERNAL MODULE: ./context/wip-features/wip-features.context.ts
var wip_features_context = __webpack_require__(84245);
// EXTERNAL MODULE: ./components/shared/Avatar.tsx
var Avatar = __webpack_require__(6937);
// EXTERNAL MODULE: ./components/jobOffer/footer/OfferFooter.styled.js
var OfferFooter_styled = __webpack_require__(6791);
;// CONCATENATED MODULE: ./components/jobOffer/footer/OfferFooter.tsx


















var OfferFooter = function(param) {
    var id = param.id, logo = param.logo, company = param.company, scout = param.scout, scoutAvatar = param.scoutAvatar, scoutUrl = param.scoutUrl, openShareModal = param.openShareModal, handleApplyClick = param.handleApplyClick, internalCode = param.internalCode, closed = param.closed, userApplied = param.userApplied;
    var t = (0,useI18n/* useI18n */.Q)("job-offer").t;
    var locale = (0,client_router.useRouter)().locale;
    var user = (0,react.useContext)(loggeduser_context/* LoggedUserContext */.Vi).user;
    var showWIPFeatures = (0,react.useContext)(wip_features_context/* default */.Z);
    var ref = (0,react.useState)(false), loaded = ref[0], setLoaded = ref[1];
    var imgRef = (0,react.useRef)(null);
    var returnUrl = "/".concat(locale).concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.portalV2Dashboard */.uu.portalV2Dashboard, locale));
    var trackApplyClick = function() {
        service_event_tracking/* default.track */.Z.track({
            type: "Offers - Offer Interested",
            properties: {
                buttonName: "footer",
                offerCompany: company,
                offerName: internalCode,
                offerURL: window.location.href,
                pageLanguage: locale
            }
        });
    };
    (0,react.useEffect)(function() {
        var ref;
        if ((ref = imgRef.current) === null || ref === void 0 ? void 0 : ref.complete) {
            setLoaded(true);
        }
    }, [
        imgRef
    ]);
    (0,react.useEffect)(function() {
        if (loaded) {
            window.dispatchEvent(new Event("resize"));
        }
    }, [
        loaded
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferFooter_styled/* StyledOfferFooter */.WD, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(OfferFooter_styled/* StyledOfferFooterContainer */.D, {
            children: [
                logo && /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferFooter_styled/* StyledOfferFooterLogo */.xh, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        ref: imgRef,
                        src: logo,
                        alt: company,
                        onLoad: function() {
                            setLoaded(true);
                        }
                    })
                }),
                !closed && /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferFooter_styled/* StyledOfferFooterTitle */.V6, {
                    children: t("footer.convinced")
                }),
                closed && /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferFooter_styled/* StyledOfferFooterTitle */.V6, {
                    children: t("footer.closed")
                }),
                closed && /*#__PURE__*/ (0,jsx_runtime.jsxs)(OfferFooter_styled/* StyledOfferFooterActions */.re, {
                    children: [
                        showWIPFeatures && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* Button */.z, {
                            variant: "secondaryInverse",
                            sizes: "lg",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    icon: free_solid_svg_icons/* faCheckCircle */.f8k
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: t("footer.register")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.jobOffers */.uu.jobOffers, locale), "?").concat((0,job_offers_filter/* getUrlParamsFromJobOffersFilter */.Ci)(JobOffersListComponent_constants/* DEFAULT_FILTER */.XW, (0,localize_utils/* getLocale */.K)(locale))),
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonLink_styled/* default */.C, {
                                variant: "secondaryInverse",
                                sizes: "lg",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: free_solid_svg_icons/* faList */.Zrf
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: t("footer.viewMoreOffers")
                                    })
                                ]
                            })
                        })
                    ]
                }),
                !closed && /*#__PURE__*/ (0,jsx_runtime.jsxs)(OfferFooter_styled/* StyledOfferFooterActions */.re, {
                    children: [
                        !userApplied && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonLink_styled/* default */.C, {
                            variant: "brandTalent",
                            sizes: "lg",
                            id: "footer-interested-button",
                            className: "interested-button",
                            href: !user ? "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.join */.uu.join, locale), "?locale=").concat(locale, "&offerId=").concat(id, "&source=footer-job&returnUrl=").concat(returnUrl) : "#",
                            onClick: function(e) {
                                e.preventDefault();
                                trackApplyClick();
                                service_event_tracking/* default.trackLandingCtaClicked */.Z.trackLandingCtaClicked("footer-job");
                                if (user && !!handleApplyClick) {
                                    handleApplyClick(e);
                                }
                                if (!user) {
                                    // Delay the redirect to give some time to the tracking to complete
                                    setTimeout(function() {
                                        var url = "".concat(window.location.origin, "/").concat(locale).concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.join */.uu.join, locale), "?locale=").concat(locale, "&offerId=").concat(id, "&source=footer-job&returnUrl=").concat(returnUrl);
                                        window.location.replace(url);
                                    }, 300);
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    icon: free_solid_svg_icons/* faCheckCircle */.f8k
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: t("footer.interested")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* Button */.z, {
                            variant: "tertiaryInverse",
                            sizes: "lg",
                            onClick: openShareModal,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    icon: free_solid_svg_icons/* faShareSquare */.tFX
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: t("footer.share")
                                })
                            ]
                        })
                    ]
                }),
                !closed && /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferFooter_styled/* StyledOfferFooterText */.Vj, {
                    dangerouslySetInnerHTML: {
                        __html: t("footer.manfred_text")
                    }
                }),
                closed && /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferFooter_styled/* StyledOfferFooterText */.Vj, {
                    dangerouslySetInnerHTML: {
                        __html: t("footer.manfred_text_closed")
                    }
                }),
                scout && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferFooter_styled/* StyledOfferFooterScoutTitle */.O9, {
                            children: t("footer.needHelp")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(OfferFooter_styled/* StyledOfferFooterScout */.iP, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                    avatarImg: scoutAvatar,
                                    avatarAlt: scout
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferFooter_styled/* StyledOfferFooterScoutName */.NN, {
                                            href: "mailto:".concat(scoutUrl),
                                            target: "_blank",
                                            rel: "noreferrer noopener",
                                            children: scout
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferFooter_styled/* StyledOfferFooterScoutLabel */.U9, {
                                            children: t("footer.scout")
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var footer_OfferFooter = (OfferFooter);

;// CONCATENATED MODULE: ./components/jobOffer/hero/HeroCompany.styled.js

function HeroCompany_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: company;\n  display: none;\n  flex-direction: column;\n  background-color: ",
        ";\n  color: ",
        ";\n  border-radius: ",
        ";\n\n  @media (min-width: ",
        ") {\n    display: flex;\n  }\n"
    ]);
    HeroCompany_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function HeroCompany_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  padding: ",
        ";\n"
    ]);
    HeroCompany_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function HeroCompany_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  max-height: 4rem;\n  object-fit: contain;\n"
    ]);
    HeroCompany_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function HeroCompany_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  line-height: 1.2;\n  border-left: 1px solid ",
        ";\n  padding-left: ",
        ";\n  margin-left: ",
        ";\n\n  a {\n    font-family: ",
        ";\n    font-size: ",
        ";\n    font-weight: ",
        ";\n  }\n  span {\n    font-size: ",
        ";\n    font-weight: ",
        ";\n    text-transform: uppercase;\n  }\n"
    ]);
    HeroCompany_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function HeroCompany_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  img {\n    display: block;\n    max-width: none;\n    width: 100%;\n  }\n"
    ]);
    HeroCompany_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function HeroCompany_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: ",
        ";\n"
    ]);
    HeroCompany_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function HeroCompany_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  span {\n    color: ",
        ";\n    font-size: ",
        ";\n    font-weight: ",
        ";\n    line-height: 1.33;\n  }\n  img {\n    display: block;\n    max-height: 1.25rem;\n  }\n"
    ]);
    HeroCompany_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function HeroCompany_styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n\n  .scout-avatar {\n    margin-right: ",
        ";\n  }\n"
    ]);
    HeroCompany_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function HeroCompany_styled_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  span {\n    color: ",
        ";\n    font-size: ",
        ";\n    font-weight: ",
        ";\n    line-height: 1.14;\n    text-transform: uppercase;\n  }\n  a {\n    font-size: ",
        ";\n    font-weight: ",
        ";\n    line-height: 1.14;\n  }\n"
    ]);
    HeroCompany_styled_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}


var StyledHeroCompany = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-1a753b19-0"
})(HeroCompany_styled_templateObject(), (0,theme/* color */.$_)("white"), (0,theme/* color */.$_)("text_default"), (0,theme/* radius */.q0)("md"), (0,theme/* screen */.sp)("md"));
var StyledHeroCompanyHeader = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
    componentId: "sc-1a753b19-1"
})(HeroCompany_styled_templateObject1(), (0,theme/* spacing */.W0)("md"));
var StyledHeroCompanyLogo = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-1a753b19-2"
})(HeroCompany_styled_templateObject2());
var StyledHeroCompanyInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1a753b19-3"
})(HeroCompany_styled_templateObject3(), (0,theme/* color */.$_)("midnight_200"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* fontFamily */.I8)("serif"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* fontWeight */.Ue)("bold"), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontWeight */.Ue)("medium"));
var StyledHeroCompanyPhoto = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1a753b19-4"
})(HeroCompany_styled_templateObject4());
var StyledHeroCompanyFooter = styled_components_browser_esm/* default.footer.withConfig */.ZP.footer.withConfig({
    componentId: "sc-1a753b19-5"
})(HeroCompany_styled_templateObject5(), (0,theme/* spacing */.W0)("md"));
var StyledHeroCompanyManagement = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1a753b19-6"
})(HeroCompany_styled_templateObject6(), (0,theme/* color */.$_)("text_subtle"), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontWeight */.Ue)("medium"));
var StyledHeroCompanyScout = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1a753b19-7"
})(HeroCompany_styled_templateObject7(), (0,theme/* spacing */.W0)("xs"));
var StyledHeroCompanyScoutInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1a753b19-8"
})(HeroCompany_styled_templateObject8(), (0,theme/* color */.$_)("text_subtle"), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontWeight */.Ue)("bold"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* fontWeight */.Ue)("bold"));

;// CONCATENATED MODULE: ./components/jobOffer/hero/HeroCompany.tsx






var HeroCompany = function(props) {
    var t = (0,useI18n/* useI18n */.Q)("job-offer").t;
    var showWIPFeatures = (0,react.useContext)(wip_features_context/* default */.Z);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeroCompany, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeroCompanyHeader, {
                children: [
                    props.companyLogo && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeroCompanyLogo, {
                        src: props.companyLogo,
                        alt: props.companyName
                    }),
                    showWIPFeatures && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeroCompanyInfo, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: props.companyUrl,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: props.companyName
                            }),
                            props.companyArea && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: props.companyArea
                            })
                        ]
                    })
                ]
            }),
            props.companyPhoto && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeroCompanyPhoto, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: props.companyPhoto,
                    alt: props.companyPhotoAlt
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeroCompanyFooter, {
                children: [
                    props.companyManagementLogo && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeroCompanyManagement, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t("hero.offerHandledBy")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                width: 110,
                                height: 20,
                                src: props.companyManagementLogo,
                                alt: props.companyManagementLogoAlt
                            })
                        ]
                    }),
                    props.companyScout !== "" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeroCompanyScout, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                className: "scout-avatar",
                                avatarImg: props.companyScoutAvatar,
                                avatarAlt: props.companyScout
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeroCompanyScoutInfo, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "mailto:".concat(props.companyScoutUrl),
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        children: props.companyScout
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: t("hero.scout")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var hero_HeroCompany = (HeroCompany);

// EXTERNAL MODULE: ../../node_modules/polished/dist/polished.esm.js + 4 modules
var polished_esm = __webpack_require__(28870);
// EXTERNAL MODULE: ./utils/paths.tsx
var paths = __webpack_require__(64516);
;// CONCATENATED MODULE: ./components/jobOffer/hero/HeroInfo.styled.js

function HeroInfo_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: info;\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n\n  @media (min-width: ",
        ") and (max-width: ",
        ") {\n    max-width: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    text-align: left;\n  }\n"
    ]);
    HeroInfo_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function HeroInfo_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  line-height: 1.2;\n  margin: 0;\n  @media (max-width: ",
        ") {\n    font-size: ",
        ";\n    font-weight: ",
        ";\n  }\n\n  a {\n    color: ",
        ";\n    &:hover {\n      color: ",
        ";\n    }\n    &:active {\n      color: ",
        ";\n    }\n  }\n\n  ul,\n  ol {\n    padding-left: 1em;\n    text-align: left;\n  }\n\n  li {\n    list-style: inherit;\n    &:not(:last-child) {\n      margin-bottom: ",
        ";\n    }\n  }\n\n  ol li::marker {\n    color: ",
        ";\n    font-weight: ",
        ";\n  }\n"
    ]);
    HeroInfo_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function HeroInfo_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: -",
        ";\n  margin-bottom: ",
        ";\n  margin-left: -",
        ";\n  margin-right: -",
        ";\n  padding-top: ",
        ";\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n  background-color: ",
        ";\n  position: relative;\n\n  > * {\n    z-index: 1;\n    position: relative;\n  }\n\n  @media (min-width: ",
        ") {\n    background-color: transparent;\n    margin: 0;\n    padding: 0;\n    z-index: 0;\n\n    > * {\n      position: static;\n    }\n  }\n\n  &::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-image: linear-gradient(\n      147deg,\n      ",
        " 0%,\n      ",
        " 70%,\n      transparent 100%\n    );\n    mix-blend-mode: hard-light;\n    z-index: 1;\n    @media (min-width: ",
        ") {\n      display: none;\n    }\n  }\n"
    ]);
    HeroInfo_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function HeroInfo_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  opacity: 0.2;\n  z-index: 0;\n\n  &::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: ",
        ";\n    mix-blend-mode: darken;\n  }\n\n  &::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: black;\n    mix-blend-mode: lighten;\n  }\n\n  div {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-image: ",
        ";\n    background-size: cover;\n    background-position: center center;\n    filter: grayscale(100%);\n    z-index: -1;\n  }\n  @media (min-width: ",
        ") {\n    display: none;\n  }\n"
    ]);
    HeroInfo_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function HeroInfo_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  padding-bottom: ",
        ";\n  margin-bottom: ",
        ";\n  border-bottom: 1px solid ",
        ";\n\n  @media (min-width: ",
        ") {\n    display: none;\n  }\n"
    ]);
    HeroInfo_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function HeroInfo_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  max-height: 3rem;\n  object-fit: contain;\n\n  @media (min-width: ",
        ") {\n    max-height: 4.5rem;\n  }\n"
    ]);
    HeroInfo_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function HeroInfo_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  text-transform: uppercase;\n  margin-left: ",
        ";\n  padding-left: ",
        ";\n  border-left: 1px solid ",
        ";\n  display: flex;\n  align-items: center;\n"
    ]);
    HeroInfo_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function HeroInfo_styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  padding-top: ",
        ";\n  margin-top: ",
        ";\n  border-top: 1px solid ",
        ";\n\n  @media (min-width: ",
        ") {\n    display: none;\n  }\n"
    ]);
    HeroInfo_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function HeroInfo_styled_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  span {\n    color: ",
        ";\n    font-size: ",
        ";\n    font-weight: ",
        ";\n    line-height: 1.33;\n  }\n  img {\n    display: block;\n    max-height: 1.25rem;\n  }\n"
    ]);
    HeroInfo_styled_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function HeroInfo_styled_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n\n  .scout-avatar {\n    margin-right: ",
        ";\n  }\n"
    ]);
    HeroInfo_styled_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function HeroInfo_styled_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  span {\n    color: ",
        ";\n    font-size: ",
        ";\n    font-weight: ",
        ";\n    line-height: 1.33;\n    text-transform: uppercase;\n  }\n  a {\n    font-size: ",
        ";\n    font-weight: ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    HeroInfo_styled_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function HeroInfo_styled_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: ",
        ";\n"
    ]);
    HeroInfo_styled_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function HeroInfo_styled_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: ",
        ";\n  \n  span {\n    display: inline-block;\n    color: ",
        ";\n    background-color: ",
        ";\n    padding: ",
        ";\n    font-size: ",
        ";\n    font-weight: ",
        ";\n  }\n"
    ]);
    HeroInfo_styled_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}




var StyledHeroInfo = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-81fb91b0-0"
})(HeroInfo_styled_templateObject(), (0,theme/* screen */.sp)("md"), (0,theme/* screen */.sp)("lgMax"), (0,theme/* container */.nC)("md"), (0,theme/* screen */.sp)("lg"));
var StyledHeroInfoDescription = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-81fb91b0-1"
})(HeroInfo_styled_templateObject1(), (0,theme/* fontFamily */.I8)("serif"), (0,theme/* fontSize */.JB)("xl"), (0,theme/* fontWeight */.Ue)("light"), (0,theme/* screen */.sp)("mdMax"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* fontWeight */.Ue)("regular"), (0,theme/* color */.$_)("link_inverse"), (0,theme/* color */.$_)("link_inverse_hover"), (0,theme/* color */.$_)("link_inverse_active"), (0,theme/* spacing */.W0)("sm"), (0,theme/* color */.$_)("text_subtle_inverse"), (0,theme/* fontWeight */.Ue)("black"));
var StyledHeroInfoContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-81fb91b0-2"
})(HeroInfo_styled_templateObject2(), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* color */.$_)("midnight_900"), (0,theme/* screen */.sp)("md"), (0,theme/* color */.$_)("purple_900"), (0,polished_esm/* rgba */.m4)("#1e076e", 0.6), (0,theme/* screen */.sp)("md"));
var StyledHeroInfoBg = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-81fb91b0-3"
})(HeroInfo_styled_templateObject3(), (0,theme/* color */.$_)("emerald_500"), function() {
    return "url('".concat((0,paths/* getPublicPath */.A)("/images/jobOffer/heroBg.jpg"), "')");
}, (0,theme/* screen */.sp)("md"));
var StyledHeroInfoCompany = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-81fb91b0-4"
})(HeroInfo_styled_templateObject4(), (0,theme/* spacing */.W0)("sm"), (0,theme/* spacing */.W0)("md"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* screen */.sp)("md"));
var StyledHeroInfoCompanyLogo = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-81fb91b0-5"
})(HeroInfo_styled_templateObject5(), (0,theme/* screen */.sp)("md"));
var StyledHeroInfoCompanyArea = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-81fb91b0-6"
})(HeroInfo_styled_templateObject6(), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,polished_esm/* rgba */.m4)("white", 0.5));
var StyledHeroInfoFooter = styled_components_browser_esm/* default.footer.withConfig */.ZP.footer.withConfig({
    componentId: "sc-81fb91b0-7"
})(HeroInfo_styled_templateObject7(), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* color */.$_)("midnight_700"), (0,theme/* screen */.sp)("md"));
var StyledHeroInfoManagement = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-81fb91b0-8"
})(HeroInfo_styled_templateObject8(), (0,theme/* color */.$_)("text_subtle"), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontWeight */.Ue)("medium"));
var StyledHeroInfoScout = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-81fb91b0-9"
})(HeroInfo_styled_templateObject9(), (0,theme/* spacing */.W0)("xs"));
var StyledHeroInfoScoutInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-81fb91b0-10"
})(HeroInfo_styled_templateObject10(), (0,theme/* color */.$_)("text_subtle"), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontWeight */.Ue)("bold"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* fontWeight */.Ue)("bold"), (0,theme/* color */.$_)("link_inverse"));
var StyledHeroClosedBadge = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-81fb91b0-11"
})(HeroInfo_styled_templateObject11(), (0,theme/* spacing */.W0)("xs"));
var StyledHeroLanguageBadge = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-81fb91b0-12"
})(HeroInfo_styled_templateObject12(), (0,theme/* spacing */.W0)("md"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* color */.$_)("midnight_900"), (0,theme/* spacing */.W0)("xs"), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontWeight */.Ue)("extraBold"));

;// CONCATENATED MODULE: ./components/jobOffer/hero/HeroInfoData.styled.tsx

function HeroInfoData_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n  padding-bottom: ",
        ";\n  padding-top: ",
        ";\n  border-top: 1px solid ",
        ";\n\n  @media (min-width: ",
        ") {\n    border-top: 1px solid rgba(255, 255, 255, 0.5);\n    border-bottom: 1px solid rgba(255, 255, 255, 0.5);\n  }\n\n  @media (min-width: ",
        ") {\n    align-items: flex-start;\n  }\n"
    ]);
    HeroInfoData_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function HeroInfoData_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n    align-items: flex-start;\n  }\n"
    ]);
    HeroInfoData_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function HeroInfoData_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  text-transform: uppercase;\n  color: ",
        ";\n\n  &:hover {\n    color: ",
        ";\n  }\n\n  &:active {\n    color: ",
        ";\n  }\n\n  strong {\n    font-weight: ",
        ";\n  }\n  span {\n    color: ",
        ";\n\n    &.extra-value {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    HeroInfoData_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function HeroInfoData_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  margin-left: ",
        ";\n  margin-right: ",
        ";\n\n  @media (min-width: ",
        ") {\n    &:first-child {\n      margin-left: 0;\n    }\n  }\n\n  &.is-salary {\n    @media (max-width: ",
        ") {\n      margin-bottom: ",
        ";\n      ",
        " {\n        font-size: ",
        ";\n      }\n    }\n  }\n"
    ]);
    HeroInfoData_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function HeroInfoData_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  margin-left: 0;\n  width: 100%;\n  align-items: center;\n\n  @media (min-width: ",
        ") {\n    width: unset;\n    margin-left: ",
        ";\n    justify-content: flex-start;\n  }\n"
    ]);
    HeroInfoData_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function HeroInfoData_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  text-transform: uppercase;\n"
    ]);
    HeroInfoData_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function HeroInfoData_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-self: center;\n  font-family: ",
        ";\n  font-style: italic;\n  font-size: ",
        ";\n  color: ",
        ";\n"
    ]);
    HeroInfoData_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function HeroInfoData_styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  margin-top: ",
        ";\n\n  @media (min-width: ",
        ") {\n    justify-content: flex-start;\n  }\n\n  > * {\n    margin-bottom: ",
        ";\n  }\n  > *:not(:last-child) {\n    margin-right: ",
        ";\n  }\n"
    ]);
    HeroInfoData_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}



var StyledHeroInfoData = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6d3685c2-0"
})(HeroInfoData_styled_templateObject(), (0,theme/* spacing */.W0)("sm"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("md"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* screen */.sp)("md"), (0,theme/* screen */.sp)("lg"));
var StyledHeroInfoDataItems = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6d3685c2-1"
})(HeroInfoData_styled_templateObject1(), (0,theme/* screen */.sp)("md"));
var StyledHeroInfoDataItemValue = (0,styled_components_browser_esm/* default */.ZP)(modules/* Link */.rU).withConfig({
    componentId: "sc-6d3685c2-2"
})(HeroInfoData_styled_templateObject2(), (0,theme/* fontFamily */.I8)("display"), (0,theme/* fontWeight */.Ue)("light"), (0,theme/* fontSize */.JB)("xl4"), (0,theme/* color */.$_)("link_inverse"), (0,theme/* color */.$_)("link_inverse_hover"), (0,theme/* color */.$_)("link_inverse_active"), (0,theme/* fontWeight */.Ue)("semiBold"), (0,theme/* color */.$_)("text_subtle_inverse"), (0,theme/* color */.$_)("text_default_inverse"));
var StyledHeroInfoDataItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6d3685c2-3"
})(HeroInfoData_styled_templateObject3(), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("md"), (0,theme/* screen */.sp)("mdMax"), (0,theme/* spacing */.W0)("lg"), StyledHeroInfoDataItemValue, (0,theme/* fontSize */.JB)("xl6"));
var StyledHeroInfoDataItemGroup = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6d3685c2-4"
})(HeroInfoData_styled_templateObject4(), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("md"));
var StyledHeroInfoDataItemTitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-6d3685c2-5"
})(HeroInfoData_styled_templateObject5(), (0,theme/* color */.$_)("text_white"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* fontSize */.JB)("sm"));
var StyledHeroInfoDataItemSeparator = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-6d3685c2-6"
})(HeroInfoData_styled_templateObject6(), (0,theme/* fontFamily */.I8)("serif"), (0,theme/* fontSize */.JB)("xl2"), (0,theme/* color */.$_)("text_subtle_inverse"));
var StyledHeroInfoDataBadges = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6d3685c2-7"
})(HeroInfoData_styled_templateObject7(), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("xs"));

;// CONCATENATED MODULE: ./components/jobOffer/hero/HeroInfoData.tsx





var HeroInfoData = function(props) {
    var t = (0,useI18n/* useI18n */.Q)("job-offer").t;
    var salaryMin = props.salaryMin || null;
    var salaryMax = props.salaryMax || null;
    var hasLocations = props.jobLocationsSummary.trimmedCount > 0;
    var isRemote = props.jobRemote === 100;
    var isFreelance = props.isFreelance;
    var hourlyRateFrom = props.hourlyRateFrom || 0;
    var hourlyRateTo = props.hourlyRateTo || 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeroInfoData, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeroInfoDataItems, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeroInfoDataItem, {
                        className: "is-salary",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeroInfoDataItemTitle, {
                                children: isFreelance ? t("hero.fee") : t("hero.salary")
                            }),
                            isFreelance ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeroInfoDataItemValue, {
                                to: "oferta",
                                href: "#oferta",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                        children: [
                                            !!hourlyRateTo && !hourlyRateFrom && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                children: [
                                                    t("hero.up_to"),
                                                    " "
                                                ]
                                            }),
                                            !!hourlyRateFrom && !hourlyRateTo && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                children: [
                                                    t("hero.from"),
                                                    " "
                                                ]
                                            }),
                                            !!hourlyRateFrom && hourlyRateFrom !== hourlyRateTo && hourlyRateFrom,
                                            !!hourlyRateFrom && hourlyRateFrom !== hourlyRateTo && !!hourlyRateTo && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "-"
                                            }),
                                            !!hourlyRateTo && hourlyRateTo,
                                            props.currency
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            "/",
                                            t("common:salary.per_hour")
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeroInfoDataItemValue, {
                                to: "oferta",
                                href: "#oferta",
                                children: [
                                    !salaryMin && salaryMax && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            children: [
                                                t("hero.up_to"),
                                                " "
                                            ]
                                        })
                                    }),
                                    salaryMin && !salaryMax && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            children: [
                                                t("hero.from"),
                                                " "
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: props.currency
                                    }),
                                    salaryMin && salaryMax && salaryMin !== salaryMax && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                children: salaryMin
                                            }),
                                            "-",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                children: salaryMax
                                            })
                                        ]
                                    }),
                                    salaryMin && salaryMax && salaryMin === salaryMax && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            children: salaryMax
                                        })
                                    }),
                                    !salaryMin && salaryMax && /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: salaryMax
                                    }),
                                    salaryMin && !salaryMax && /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: salaryMin
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "K"
                                    })
                                ]
                            })
                        ]
                    }),
                    props.bonus && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeroInfoDataItem, {
                        className: "is-salary",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeroInfoDataItemTitle, {
                                children: t("hero.bonus")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeroInfoDataItemValue, {
                                to: "oferta",
                                href: "#oferta",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "extra-value",
                                        children: "+"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: props.currency
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: props.bonus
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "K"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeroInfoDataItemGroup, {
                        children: props.jobRemote === 100 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeroInfoDataItem, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeroInfoDataItemTitle, {
                                            children: isRemote ? t("hero.remote") : t("hero.remotework")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeroInfoDataItemValue, {
                                            to: "donde",
                                            href: "#donde",
                                            children: [
                                                props.jobRemote,
                                                "%"
                                            ]
                                        })
                                    ]
                                }),
                                hasLocations && props.jobRemote < 100 && props.jobRemote > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeroInfoDataItemSeparator, {
                                    children: t("hero.and")
                                }),
                                hasLocations && isRemote && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeroInfoDataItemSeparator, {
                                    children: t("hero.or")
                                }),
                                hasLocations && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeroInfoDataItem, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeroInfoDataItemTitle, {
                                            children: t("hero.presential")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeroInfoDataItemValue, {
                                            to: "donde",
                                            href: "#donde",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TrimmedOfferLocations/* TrimmedOfferLocations */.J, {
                                                locationsSummary: props.jobLocationsSummary
                                            })
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                hasLocations && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeroInfoDataItem, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeroInfoDataItemTitle, {
                                            children: t("hero.presential")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeroInfoDataItemValue, {
                                            to: "donde",
                                            href: "#donde",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TrimmedOfferLocations/* TrimmedOfferLocations */.J, {
                                                locationsSummary: props.jobLocationsSummary
                                            })
                                        })
                                    ]
                                }),
                                hasLocations && props.jobRemote !== 0 && props.jobRemote < 100 && props.jobRemote > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeroInfoDataItemSeparator, {
                                    children: t("hero.and")
                                }),
                                hasLocations && props.jobRemote !== 0 && isRemote && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeroInfoDataItemSeparator, {
                                    children: t("hero.or")
                                }),
                                props.jobRemote !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeroInfoDataItem, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeroInfoDataItemTitle, {
                                            children: isRemote ? t("hero.remote") : t("hero.remotework")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeroInfoDataItemValue, {
                                            to: "donde",
                                            href: "#donde",
                                            children: [
                                                props.jobRemote,
                                                "%"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            props.badges && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeroInfoDataBadges, {
                children: props.badges.map(function(b) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* Badge */.C, {
                        variant: "".concat(b.highlight ? "primaryInverse" : "secondaryInverse"),
                        children: b.item
                    }, b.id);
                })
            })
        ]
    });
};
/* harmony default export */ var hero_HeroInfoData = (HeroInfoData);

;// CONCATENATED MODULE: ./components/jobOffer/hero/HeroInfo.tsx












var HeroInfo = function(props) {
    var t = (0,useI18n/* useI18n */.Q)("job-offer").t;
    var locale = (0,client_router.useRouter)().locale;
    var showWIPFeatures = (0,react.useContext)(wip_features_context/* default */.Z);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeroInfo, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeroInfoContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeroInfoBg, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeroInfoCompany, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeroInfoCompanyLogo, {
                                src: props.companyLogoDark,
                                alt: props.companyName
                            }),
                            showWIPFeatures && props.companyArea && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeroInfoCompanyArea, {
                                children: props.companyArea
                            })
                        ]
                    }),
                    props.onlyAvailableInLang && (locale === null || locale === void 0 ? void 0 : locale.toLowerCase()) !== props.onlyAvailableInLang.toLowerCase() && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeroLanguageBadge, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: t("hero.onlyAvailable".concat(props.onlyAvailableInLang))
                        })
                    }),
                    props.closed && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeroClosedBadge, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* Badge */.C, {
                            variant: "negative",
                            children: props.closedDate ? t("hero.offerClosed", {
                                date: new Intl.DateTimeFormat(locale, {
                                    month: "2-digit",
                                    day: "2-digit",
                                    year: "numeric"
                                }).format(new Date(props.closedDate || ""))
                            }) : t("hero.offerClosedWithoutDate")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading1 */.nL, {
                        children: props.jobTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(hero_HeroInfoData, (0,_object_spread/* default */.Z)({}, props))
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeroInfoDescription, {
                children: props.migratedToMarkdown ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MarkdownComponent["default"], {
                        content: props.jobDescription || ""
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: props.jobDescription || ""
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeroInfoFooter, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeroInfoManagement, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t("hero.offerHandledBy")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                width: 110,
                                height: 20,
                                src: props.companyManagementLogoDark,
                                alt: props.companyManagementLogoAlt
                            })
                        ]
                    }),
                    props.companyScout !== "" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeroInfoScout, {
                        children: [
                            props.companyScoutAvatar && /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                className: "scout-avatar",
                                avatarImg: props.companyScoutAvatar,
                                avatarAlt: props.companyScout
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeroInfoScoutInfo, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: t("hero.scout")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "mailto:".concat(props.companyScoutUrl),
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        children: props.companyScout
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var hero_HeroInfo = (HeroInfo);

;// CONCATENATED MODULE: ./components/jobOffer/hero/HeroSection.styled.tsx

function HeroSection_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding-bottom: ",
        ";\n  color: ",
        ";\n  position: relative;\n  justify-content: center;\n\n  @media (min-width: ",
        ") {\n    min-height: calc(100vh - ",
        ");\n  }\n\n  @media (min-height: 1200px) {\n    min-height: 1000px;\n  }\n\n  &::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: ",
        ";\n    background-color: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    &::before {\n      content: '';\n      position: absolute;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      background-image: linear-gradient(\n        147deg,\n        ",
        " 0%,\n        ",
        " 70%,\n        transparent 100%\n      );\n      mix-blend-mode: hard-light;\n      z-index: ",
        ";\n    }\n  }\n"
    ]);
    HeroSection_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function HeroSection_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media (min-width: ",
        ") {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    opacity: 0.2;\n    z-index: ",
        ";\n\n    &::before {\n      content: '';\n      position: absolute;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      background-color: ",
        ";\n      mix-blend-mode: darken;\n    }\n\n    &::after {\n      content: '';\n      position: absolute;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      background-color: black;\n      mix-blend-mode: lighten;\n    }\n\n    div {\n      position: absolute;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      background-image: ",
        ";\n      background-size: cover;\n      background-position: center center;\n      filter: grayscale(100%);\n      z-index: ",
        ";\n    }\n  }\n"
    ]);
    HeroSection_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function HeroSection_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: ",
        ";\n  width: 100%;\n  max-width: calc(",
        " + ",
        " * 2);\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n  height: min-content;\n  margin-top: ",
        ";\n\n  @media (min-width: ",
        ") {\n    display: flex;\n    flex-direction: column-reverse;\n    align-items: center;\n  }\n\n  @media (min-width: ",
        ") {\n    display: grid;\n    grid-template-columns: [company] minmax(19rem, 25rem) [info] 1fr [sliderNav] ",
        ";\n    column-gap: ",
        ";\n    align-items: start;\n    margin-top: ",
        ";\n  }\n"
    ]);
    HeroSection_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var StyledHeroSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c2aaa4a-0"
})(HeroSection_styled_templateObject(), (0,theme/* spacing */.W0)("xl"), (0,theme/* color */.$_)("text_white"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* zindex */.Y0)("heroBg"), (0,theme/* color */.$_)("midnight_900"), (0,theme/* screen */.sp)("md"), (0,theme/* color */.$_)("purple_900"), (0,polished_esm/* rgba */.m4)("#1e076e", 0.6), (0,theme/* zindex */.Y0)("heroBgGradient"));
var StyledHeroSectionBg = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c2aaa4a-1"
})(HeroSection_styled_templateObject1(), (0,theme/* screen */.sp)("md"), (0,theme/* zindex */.Y0)("heroSectionBg"), (0,theme/* color */.$_)("emerald_500"), function(param) {
    var bgImage = param.bgImage;
    return bgImage ? "url('".concat(bgImage, "')") : "url('".concat((0,paths/* getPublicPath */.A)("/images/jobOffer/heroBg.jpg"), "')");
}, (0,theme/* zindex */.Y0)("heroSectionBgImg"));
var StyledHeroContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c2aaa4a-2"
})(HeroSection_styled_templateObject2(), (0,theme/* zindex */.Y0)("heroContent"), (0,theme/* container */.nC)("xl"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("lg"), (0,theme/* screen */.sp)("md"), (0,theme/* screen */.sp)("lg"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl"));

;// CONCATENATED MODULE: ./components/jobOffer/hero/HeroSection.tsx






var HeroSection = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
        name: "inicio",
        id: "hero",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeroSection, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeroSectionBg, {
                    bgImage: props.companyPhoto,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeroContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(hero_HeroCompany, (0,_object_spread/* default */.Z)({}, props)),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(hero_HeroInfo, (0,_object_spread/* default */.Z)({}, props))
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var hero_HeroSection = (HeroSection);

;// CONCATENATED MODULE: ./components/jobOffer/JobOfferLongText.styled.tsx

function JobOfferLongText_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.6;\n  margin-top: ",
        ";\n  margin-left: auto;\n  margin-right: auto;\n  text-align: left;\n\n  @media (min-width: ",
        ") {\n    margin-top: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  ul {\n    padding-left: 0 !important;\n  }\n\n  li {\n    padding-left: 2rem !important;\n    margin-left: 0 !important;\n    margin-bottom: ",
        ";\n    position: relative;\n    list-style-type: none !important;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    &::before {\n      content: '';\n      position: absolute;\n      left: 0;\n      width: 1.25rem;\n      height: 1.25rem;\n      background-image: url(\"data:image/svg+xml,%3Csvg aria-hidden='true' focusable='false' data-prefix='fal' data-icon='check-circle' class='svg-inline--fa fa-check-circle fa-w-16 ' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' width='24px' height='24px'%3E%3Cpath fill='%23C0BEC9' d='M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 464c-118.664 0-216-96.055-216-216 0-118.663 96.055-216 216-216 118.664 0 216 96.055 216 216 0 118.663-96.055 216-216 216zm141.63-274.961L217.15 376.071c-4.705 4.667-12.303 4.637-16.97-.068l-85.878-86.572c-4.667-4.705-4.637-12.303.068-16.97l8.52-8.451c4.705-4.667 12.303-4.637 16.97.068l68.976 69.533 163.441-162.13c4.705-4.667 12.303-4.637 16.97.068l8.451 8.52c4.668 4.705 4.637 12.303-.068 16.97z'%3E%3C/path%3E%3C/svg%3E%0A\");\n      background-size: contain;\n      background-repeat: no-repeat;\n      margin-right: ",
        ";\n      margin-top: 0.1em;\n\n      @media (min-width: ",
        ") {\n        width: ",
        ";\n        height: ",
        ";\n      }\n    }\n  }\n\n  img {\n    display: block;\n    margin: 1rem auto;\n    border: ",
        " solid ",
        ";\n    border-radius: ",
        ";\n  }\n"
    ]);
    JobOfferLongText_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledJobOfferLongText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-214bca8a-0"
})(JobOfferLongText_styled_templateObject(), (0,theme/* container */.nC)("md"), (0,theme/* fontSize */.JB)("md"), (0,theme/* spacing */.W0)("lg"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("sm"), (0,theme/* screen */.sp)("lg"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("md"), (0,theme/* color */.$_)("text_default"), (0,theme/* radius */.q0)("md"));

;// CONCATENATED MODULE: ./components/jobOffer/JobOfferLongText.tsx



var JobOfferLongText = function(param) {
    var children = param.children, isMarkdown = param.isMarkdown;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: isMarkdown ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledJobOfferLongText, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MarkdownComponent["default"], {
                content: children || ""
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledJobOfferLongText, {
            dangerouslySetInnerHTML: {
                __html: children || ""
            }
        })
    });
};
/* harmony default export */ var jobOffer_JobOfferLongText = (JobOfferLongText);

;// CONCATENATED MODULE: ./components/jobOffer/how/HowItem.styled.js

function HowItem_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  break-inside: avoid;\n  page-break-inside: avoid;\n  color: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.43;\n  margin-bottom: ",
        ";\n  position: relative;\n\n  &::before {\n    counter-increment: howItem;\n    content: '0' counter(howItem);\n    display: inline-block;\n    color: ",
        ";\n    font-size: ",
        ";\n    line-height: 1;\n    font-weight: ",
        ";\n    margin-bottom: ",
        ";\n  }\n\n  &::after {\n    content: '';\n    display: block;\n    position: absolute;\n    top: 22px;\n    left: 0;\n    width: 15px;\n    height: ",
        ";\n    background-color: ",
        ";\n  }\n\n  p {\n    margin: 0;\n  }\n"
    ]);
    HowItem_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function HowItem_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  color: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  text-transform: uppercase;\n  line-height: 1;\n  margin-top: 0;\n  margin-bottom: ",
        ";\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    HowItem_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var StyledHowItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-a9fe3e2-0"
})(HowItem_styled_templateObject(), (0,theme/* color */.$_)("text_subtle"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* spacing */.W0)("xl"), (0,theme/* color */.$_)("navy_500"), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontWeight */.Ue)("extraBold"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* color */.$_)("navy_200"));
var StyledHowItemTitle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    componentId: "sc-a9fe3e2-1"
})(HowItem_styled_templateObject1(), (0,theme/* fontFamily */.I8)("display"), (0,theme/* color */.$_)("text_default"), (0,theme/* fontSize */.JB)("xl3"), (0,theme/* fontWeight */.Ue)("light"), (0,theme/* spacing */.W0)("xs"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("xl4"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("xl6"));

;// CONCATENATED MODULE: ./components/jobOffer/how/HowItem.js


var HowItem = function(param) {
    var howItemKey = param.howItemKey, howItemTitle = param.howItemTitle, howItemText = param.howItemText;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHowItem, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHowItemTitle, {
                children: howItemTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: howItemText
            })
        ]
    }, howItemKey);
};
/* harmony default export */ var how_HowItem = (HowItem);

;// CONCATENATED MODULE: ./components/jobOffer/how/HowSection.styled.js

function HowSection_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  counter-reset: howItem;\n  margin-top: ",
        ";\n  margin-bottom: 0;\n  padding-left: 0;\n\n  @media (min-width: ",
        ") {\n    margin-top: ",
        ";\n    column-count: 2;\n    column-gap: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    margin-top: ",
        ";\n    column-count: 3;\n  }\n"
    ]);
    HowSection_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledHowSection = styled_components_browser_esm/* default.ol.withConfig */.ZP.ol.withConfig({
    componentId: "sc-b60814c7-0"
})(HowSection_styled_templateObject(), (0,theme/* spacing */.W0)("lg"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl"), (0,theme/* screen */.sp)("lg"), (0,theme/* spacing */.W0)("xl4"));

;// CONCATENATED MODULE: ./components/jobOffer/how/HowSection.tsx








var HowSection = function(param) {
    var howIntro = param.howIntro, howItems = param.howItems, migratedToMarkdown = param.migratedToMarkdown;
    var t = (0,useI18n/* useI18n */.Q)("job-offer").t;
    var showWIPFeatures = (0,react.useContext)(wip_features_context/* default */.Z);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jobOffer_JobOfferSection, {
        name: "como",
        title: t("titles.how"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(jobOffer_JobOfferLongText, {
                isMarkdown: migratedToMarkdown,
                children: howIntro
            }),
            showWIPFeatures && (howItems === null || howItems === void 0 ? void 0 : howItems.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHowSection, {
                children: howItems.map(function(i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(how_HowItem, {
                        howItemKey: i.id,
                        howItemTitle: i.title,
                        howItemText: i.text
                    }, i.id);
                })
            })
        ]
    });
};
/* harmony default export */ var how_HowSection = (HowSection);

;// CONCATENATED MODULE: ./components/jobOffer/JobOfferSubsection.styled.js

function JobOfferSubsection_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        ";\n"
    ]);
    JobOfferSubsection_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function JobOfferSubsection_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  && {\n    padding-top: ",
        ";\n    margin-bottom: ",
        ";\n    text-align: center;\n  }\n"
    ]);
    JobOfferSubsection_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var StyledJobOfferSubsection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-4b1c4ab8-0"
})(JobOfferSubsection_styled_templateObject(), (0,theme/* spacing */.W0)("lg"));
var StyledJobOfferSubsectionTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography/* Heading3 */.aC).withConfig({
    componentId: "sc-4b1c4ab8-1"
})(JobOfferSubsection_styled_templateObject1(), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("md"));

;// CONCATENATED MODULE: ./components/jobOffer/JobOfferSubsection.js


var JobOfferSubsection = function(param) {
    var children = param.children, title = param.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledJobOfferSubsection, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledJobOfferSubsectionTitle, {
                editorial: true,
                children: title
            }),
            children
        ]
    });
};
/* harmony default export */ var jobOffer_JobOfferSubsection = (JobOfferSubsection);

;// CONCATENATED MODULE: ./components/jobOffer/offer/OfferPerks.styled.js

function OfferPerks_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: auto;\n  max-width: ",
        ";\n"
    ]);
    OfferPerks_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function OfferPerks_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border-radius: ",
        ";\n  padding: ",
        ";\n  box-shadow: ",
        ";\n"
    ]);
    OfferPerks_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function OfferPerks_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  font-weight: ",
        ";\n  color: ",
        ";\n  text-transform: uppercase;\n  font-size: ",
        ";\n  line-height: 1;\n  margin-top: 0;\n  margin-bottom: ",
        ";\n"
    ]);
    OfferPerks_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function OfferPerks_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media (min-width: ",
        ") {\n    display: flex;\n  }\n\n  > * {\n    @media (min-width: ",
        ") {\n      padding-left: ",
        ";\n      padding-right: ",
        ";\n      width: calc(50% - ",
        ");\n      flex-grow: 1;\n    }\n  }\n"
    ]);
    OfferPerks_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function OfferPerks_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        ";\n\n  > * {\n    @media (min-width: ",
        ") {\n      padding-left: ",
        ";\n      padding-right: ",
        ";\n      margin-top: ",
        ";\n    }\n  }\n"
    ]);
    OfferPerks_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var StyledOfferPerks = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-722cd338-0"
})(OfferPerks_styled_templateObject(), (0,theme/* container */.nC)("xs"));
var StyledOfferPerksMain = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-722cd338-1"
})(OfferPerks_styled_templateObject1(), (0,theme/* color */.$_)("white"), (0,theme/* radius */.q0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* shadow */.AF)("md"));
var StyledOfferPerksMainTitle = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-722cd338-2"
})(OfferPerks_styled_templateObject2(), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* color */.$_)("text_subtle"), (0,theme/* fontSize */.JB)("xs"), (0,theme/* spacing */.W0)("md"));
var StyledOfferPerksMainPerks = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-722cd338-3"
})(OfferPerks_styled_templateObject3(), (0,theme/* screen */.sp)("md"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("md"));
var StyledOfferPerksExtra = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-722cd338-4"
})(OfferPerks_styled_templateObject4(), (0,theme/* spacing */.W0)("lg"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("lg"));

// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./utils/config.ts
var config = __webpack_require__(75339);
;// CONCATENATED MODULE: ./components/jobOffer/offer/OfferPerksItem.styled.js

function OfferPerksItem_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n\n  &:not(:last-child) {\n    @media (max-width: ",
        ") {\n      padding-bottom: ",
        ";\n      margin-bottom: ",
        ";\n      border-bottom: 1px solid ",
        ";\n    }\n  }\n"
    ]);
    OfferPerksItem_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function OfferPerksItem_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  margin-right: ",
        ";\n"
    ]);
    OfferPerksItem_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function OfferPerksItem_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  text-transform: uppercase;\n  line-height: 1.33;\n  margin: 0;\n"
    ]);
    OfferPerksItem_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function OfferPerksItem_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        ";\n  margin-bottom: 0;\n  color: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.25;\n"
    ]);
    OfferPerksItem_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var StyledOfferPerksItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6083f280-0"
})(OfferPerksItem_styled_templateObject(), (0,theme/* screen */.sp)("mdMax"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* color */.$_)("midnight_200"));
var StyledOfferPerksItemIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6083f280-1"
})(OfferPerksItem_styled_templateObject1(), (0,theme/* spacing */.W0)("md"));
var StyledOfferPerksItemTitle = styled_components_browser_esm/* default.h5.withConfig */.ZP.h5.withConfig({
    componentId: "sc-6083f280-2"
})(OfferPerksItem_styled_templateObject2(), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontWeight */.Ue)("black"));
var StyledOfferPerksItemDesc = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-6083f280-3"
})(OfferPerksItem_styled_templateObject3(), (0,theme/* spacing */.W0)("xs2"), (0,theme/* color */.$_)("text_subtle"), (0,theme/* fontSize */.JB)("md"));

;// CONCATENATED MODULE: ./components/jobOffer/offer/OfferPerksItem.tsx




var OfferPerksItem = function(param) {
    var perksItem = param.perksItem;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: perksItem && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOfferPerksItem, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOfferPerksItemIcon, {
                    children: [
                        perksItem.icon && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            width: 48,
                            height: 48,
                            layout: "fixed",
                            src: perksItem.icon,
                            alt: ""
                        }),
                        !perksItem.icon && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            width: 48,
                            height: 48,
                            layout: "fixed",
                            src: config/* config.defaultPerkIcon */.v.defaultPerkIcon,
                            alt: ""
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledOfferPerksItemTitle, {
                            children: perksItem.perk
                        }),
                        perksItem.desc && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledOfferPerksItemDesc, {
                            children: perksItem.desc
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var offer_OfferPerksItem = (OfferPerksItem);

;// CONCATENATED MODULE: ./components/jobOffer/offer/OfferPerks.tsx






var OfferPerks = function(param) {
    var perks = param.perks;
    var t = (0,useI18n/* useI18n */.Q)("job-offer").t;
    var showWIPFeatures = (0,react.useContext)(wip_features_context/* default */.Z);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOfferPerks, {
        children: [
            showWIPFeatures && perks.compensation && perks.compensation.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOfferPerksMain, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledOfferPerksMainTitle, {
                        children: t("offer.flexRetribution")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledOfferPerksMainPerks, {
                        children: perks.compensation.map(function(p, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(offer_OfferPerksItem, {
                                perksItem: p
                            }, i);
                        })
                    })
                ]
            }),
            perks.extra && perks.extra.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledOfferPerksExtra, {
                children: perks.extra.map(function(p, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(offer_OfferPerksItem, {
                        perksItem: p
                    }, i);
                })
            })
        ]
    });
};
/* harmony default export */ var offer_OfferPerks = (OfferPerks);

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react-intersection-observer/react-intersection-observer.modern.mjs
var react_intersection_observer_modern = __webpack_require__(30299);
;// CONCATENATED MODULE: ./components/jobOffer/offer/OfferSection.constants.ts
var MIN_READING_TIME_IN_SECONDS = 30;

;// CONCATENATED MODULE: ./components/jobOffer/offer/OfferSection.utils.ts

var sendOfferViewedEntirelyEvent = function(param) {
    var companyName = param.companyName, offerCode = param.offerCode, locale = param.locale;
    var offerURL = window.location.href;
    var urlParams = new URLSearchParams(window.location.search);
    service_event_tracking/* default.track */.Z.track({
        type: "Offers - Offer Viewed Entirely",
        properties: {
            offerCompany: companyName,
            offerName: offerCode,
            offerURL: offerURL,
            urlParams: urlParams.toString(),
            pageLanguage: locale,
            utmCampaign: urlParams.get("utm_campaign") || undefined,
            utmContent: urlParams.get("utm_content") || undefined,
            utmId: urlParams.get("utm_id") || undefined,
            utmMedium: urlParams.get("utm_medium") || undefined,
            utmSource: urlParams.get("utm_source") || undefined
        }
    });
};

;// CONCATENATED MODULE: ./components/jobOffer/offer/OfferSection.hooks.ts







var useOfferSection = function(param) {
    var companyName = param.companyName, offerCode = param.offerCode;
    var t = (0,useI18n/* useI18n */.Q)("job-offer").t;
    var locale = (0,router.useRouter)().locale;
    var ref = (0,_sliced_to_array/* default */.Z)((0,react_intersection_observer_modern/* useInView */.YD)({
        // 50% of the element must be visible
        threshold: 0.5
    }), 2), ref1 = ref[0], inView = ref[1];
    var startReadingTime = (0,react.useRef)(undefined);
    var readTrackingEventSent = (0,react.useRef)(false);
    (0,react.useEffect)(function() {
        if (!inView || !startReadingTime.current) {
            return;
        }
        var now = Date.now();
        var readingTimeInSeconds = (now - startReadingTime.current) / 1000;
        var minReadingTimeReached = readingTimeInSeconds >= MIN_READING_TIME_IN_SECONDS;
        if (minReadingTimeReached && !readTrackingEventSent.current) {
            sendOfferViewedEntirelyEvent({
                companyName: companyName,
                offerCode: offerCode,
                locale: locale
            });
            readTrackingEventSent.current = true;
        }
    }, [
        inView,
        companyName,
        offerCode,
        locale
    ]);
    (0,react.useEffect)(function() {
        startReadingTime.current = Date.now();
    }, []);
    return {
        t: t,
        ref: ref1
    };
};

;// CONCATENATED MODULE: ./components/jobOffer/offer/OfferSection.styled.js

function OfferSection_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: auto;\n"
    ]);
    OfferSection_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function OfferSection_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: auto;\n  max-width: ",
        ";\n  text-align: center;\n  font-size: ",
        ";\n  line-height: 1.6;\n\n  ul,\n  ol,\n  p {\n    &:not(::first-child) {\n      margin-bottom: 0;\n      margin-top: ",
        ";\n    }\n  }\n"
    ]);
    OfferSection_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var StyledOfferSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ae3ca844-0"
})(OfferSection_styled_templateObject());
var StyledOfferInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ae3ca844-1"
})(OfferSection_styled_templateObject1(), (0,theme/* container */.nC)("md"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* spacing */.W0)("xl"));

// EXTERNAL MODULE: ./components/shared/TooltipMF.tsx
var TooltipMF = __webpack_require__(83885);
;// CONCATENATED MODULE: ./components/jobOffer/offer/OfferSummary.styled.js

function OfferSummary_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n  padding-top: ",
        ";\n  padding-bottom: ",
        ";\n  border-top: 1px solid ",
        ";\n  border-bottom: 1px solid ",
        ";\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n"
    ]);
    OfferSummary_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function OfferSummary_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-right: ",
        ";\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  text-align: center;\n\n  @media (min-width: ",
        ") {\n    margin-top: ",
        ";\n    margin-bottom: ",
        ";\n    padding-left: ",
        ";\n    padding-right: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    padding-left: ",
        ";\n    padding-right: ",
        ";\n  }\n"
    ]);
    OfferSummary_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function OfferSummary_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: flex-start;\n  flex-wrap: wrap;\n  justify-content: center;\n\n  @media (min-width: ",
        ") {\n    flex-wrap: nowrap;\n  }\n\n  ",
        ":first-child {\n    @media (max-width: ",
        ") {\n      padding-left: 0;\n    }\n  }\n"
    ]);
    OfferSummary_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function OfferSummary_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n  text-transform: uppercase;\n  line-height: 1;\n  margin-top: 0;\n  margin-bottom: ",
        ";\n"
    ]);
    OfferSummary_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function OfferSummary_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  text-transform: uppercase;\n  line-height: 1;\n  white-space: nowrap;\n  span {\n    color: ",
        ";\n\n    &.extra {\n      color: ",
        ";\n    }\n  }\n  strong {\n    font-weight: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    OfferSummary_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function OfferSummary_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n  margin-top: ",
        ";\n"
    ]);
    OfferSummary_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}



var StyledOfferSummary = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9da21258-0"
})(OfferSummary_styled_templateObject(), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("sm"), (0,theme/* spacing */.W0)("sm"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* color */.$_)("midnight_200"));
var StyledOfferSummaryItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9da21258-1"
})(OfferSummary_styled_templateObject1(), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("xs"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("sm"), (0,theme/* spacing */.W0)("sm"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("lg"), (0,theme/* screen */.sp)("lg"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl"));
var StyledOfferSummaryBlock = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9da21258-2"
})(OfferSummary_styled_templateObject2(), (0,theme/* screen */.sp)("md"), StyledOfferSummaryItem, (0,theme/* screen */.sp)("mdMax"));
var StyledOfferSummaryItemTitle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    componentId: "sc-9da21258-3"
})(OfferSummary_styled_templateObject3(), (0,theme/* fontSize */.JB)("md"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* color */.$_)("text_subtle"), (0,theme/* spacing */.W0)("xs"));
var StyledOfferSummaryItemValue = (0,styled_components_browser_esm/* default */.ZP)(modules/* Link */.rU).withConfig({
    componentId: "sc-9da21258-4"
})(OfferSummary_styled_templateObject4(), (0,theme/* fontFamily */.I8)("display"), (0,theme/* fontSize */.JB)("xl4"), (0,theme/* fontWeight */.Ue)("light"), (0,theme/* color */.$_)("text_placeholder"), (0,theme/* color */.$_)("text_default"), (0,theme/* fontWeight */.Ue)("semiBold"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("xl6"));
var StyledOfferSummaryItemExtra = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-9da21258-5"
})(OfferSummary_styled_templateObject5(), (0,theme/* fontSize */.JB)("sm"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* color */.$_)("text_subtle"), (0,theme/* spacing */.W0)("xs2"));

;// CONCATENATED MODULE: ./components/jobOffer/offer/OfferSummary.tsx






var OfferSummary = function(param) {
    var offer = param.offer, perks = param.perks, migratedToMarkdown = param.migratedToMarkdown;
    var ref;
    var t = (0,useI18n/* useI18n */.Q)("job-offer").t;
    var showWIPFeatures = (0,react.useContext)(wip_features_context/* default */.Z);
    var salaryMin = offer.salaryMin || null;
    var salaryMax = offer.salaryMax || null;
    var isFreelance = offer.isFreelance;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOfferSummary, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOfferSummaryBlock, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOfferSummaryItem, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledOfferSummaryItemTitle, {
                                children: isFreelance ? t("offer.fee") : t("offer.salary")
                            }),
                            isFreelance ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOfferSummaryItemValue, {
                                as: "span",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                        children: [
                                            !!offer.hourlyRateTo && !offer.hourlyRateFrom && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                children: [
                                                    t("offer.up_to"),
                                                    " "
                                                ]
                                            }),
                                            !!offer.hourlyRateFrom && !offer.hourlyRateTo && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                children: [
                                                    t("offer.from"),
                                                    " "
                                                ]
                                            }),
                                            !!offer.hourlyRateFrom && offer.hourlyRateFrom !== offer.hourlyRateTo && offer.hourlyRateFrom,
                                            !!offer.hourlyRateFrom && offer.hourlyRateFrom !== offer.hourlyRateTo && !!offer.hourlyRateTo && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "-"
                                            }),
                                            !!offer.hourlyRateTo && offer.hourlyRateTo,
                                            offer.currency
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            "/",
                                            t("common:salary.per_hour")
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOfferSummaryItemValue, {
                                as: "span",
                                children: [
                                    !salaryMin && salaryMax && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            t("offer.up_to"),
                                            " "
                                        ]
                                    }),
                                    salaryMin && !salaryMax && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            t("offer.from"),
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: offer.currency
                                    }),
                                    salaryMin && salaryMax && salaryMin !== salaryMax && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                children: salaryMin
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "-"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                children: salaryMax
                                            })
                                        ]
                                    }),
                                    salaryMin && salaryMax && salaryMin === salaryMax && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: salaryMax
                                    }),
                                    !salaryMin && salaryMax && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: salaryMax
                                    }),
                                    salaryMin && !salaryMax && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: salaryMin
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "K"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledOfferSummaryItemExtra, {
                                children: showWIPFeatures && ((ref = perks.compensation) === null || ref === void 0 ? void 0 : ref.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        " ",
                                        t("offer.plusPerks")
                                    ]
                                })
                            })
                        ]
                    }),
                    offer.bonus && /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipMF/* default */.Z, {
                        content: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            dangerouslySetInnerHTML: {
                                __html: t(offer.bonusInfo) || ""
                            }
                        }),
                        direction: "down",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOfferSummaryItem, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledOfferSummaryItemTitle, {
                                    children: t("offer.bonus")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOfferSummaryItemValue, {
                                    as: "span",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "extra",
                                            children: "+"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: offer.currency
                                        }),
                                        offer.bonus,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "K"
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    (offer.equityInf !== null || offer.equitySup !== null) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOfferSummaryItem, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledOfferSummaryItemTitle, {
                                children: t("offer.equity")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOfferSummaryItemValue, {
                                as: "span",
                                children: [
                                    !offer.equityInf && offer.equitySup && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            t("offer.up_to"),
                                            " "
                                        ]
                                    }),
                                    offer.equityInf && !offer.equitySup && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            t("offer.from"),
                                            " "
                                        ]
                                    }),
                                    offer.equityInf && offer.equitySup && offer.equityInf !== offer.equitySup && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            offer.equityInf,
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "%"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: " - "
                                            }),
                                            offer.equitySup,
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "%"
                                            })
                                        ]
                                    }),
                                    offer.equityInf && offer.equitySup && offer.equityInf === offer.equitySup && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            offer.equitySup,
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "%"
                                            })
                                        ]
                                    }),
                                    !offer.equityInf && offer.equitySup && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            offer.equitySup,
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "%"
                                            })
                                        ]
                                    }),
                                    offer.equityInf && !offer.equitySup && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            offer.equityInf,
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "%"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            (offer.contract || offer.hours || offer.remote) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOfferSummaryBlock, {
                children: [
                    !isFreelance && offer.contract && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOfferSummaryItem, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledOfferSummaryItemTitle, {
                                children: t("offer.contract")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledOfferSummaryItemValue, {
                                as: "span",
                                children: offer.contract
                            })
                        ]
                    }),
                    !isFreelance && offer.hours && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOfferSummaryItem, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledOfferSummaryItemTitle, {
                                children: t("offer.schedule")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledOfferSummaryItemValue, {
                                to: "horario",
                                href: "#horario",
                                children: t("offer.flex")
                            })
                        ]
                    }),
                    offer.remote && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOfferSummaryItem, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledOfferSummaryItemTitle, {
                                children: t("offer.remote")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledOfferSummaryItemValue, {
                                to: "donde",
                                href: "#donde",
                                children: offer.remote
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var offer_OfferSummary = (OfferSummary);

;// CONCATENATED MODULE: ./components/jobOffer/offer/OfferSection.tsx








var OfferSection = function(param) {
    var companyName = param.companyName, offerCode = param.offerCode, offer = param.offer, offerInfo = param.offerInfo, perks = param.perks, migratedToMarkdown = param.migratedToMarkdown;
    var ref = useOfferSection({
        companyName: companyName,
        offerCode: offerCode
    }), t = ref.t, ref1 = ref.ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jobOffer_JobOfferSection, {
        name: "oferta",
        sectionBg: "alt",
        title: t("titles.offer"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOfferSection, {
            ref: ref1,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(offer_OfferSummary, {
                    offer: offer,
                    perks: perks,
                    migratedToMarkdown: migratedToMarkdown
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(jobOffer_JobOfferLongText, {
                    isMarkdown: migratedToMarkdown,
                    children: offerInfo
                }),
                perks && perks.extra.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jobOffer_JobOfferSubsection, {
                    title: t("offer.perks"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(offer_OfferPerks, {
                        perks: perks
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var offer_OfferSection = (OfferSection);

// EXTERNAL MODULE: ./components/shared/levelLadder/LevelLadder.tsx
var LevelLadder = __webpack_require__(18962);
// EXTERNAL MODULE: ./model/index.ts + 29 modules
var model = __webpack_require__(41400);
;// CONCATENATED MODULE: ./components/jobOffer/skills/SkillsItem.styled.js

function SkillsItem_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: 3.5rem 1fr;\n  column-gap: ",
        ";\n  text-align: left;\n  border-top: 1px solid ",
        ";\n  padding-top: ",
        ";\n  padding-bottom: ",
        ";\n\n  &:first-child {\n    margin-top: ",
        ";\n  }\n\n  &:last-child {\n    padding-bottom: 0;\n  }\n\n  @media (min-width: ",
        ") {\n    height: 3.5rem + ",
        " * 2;\n\n    &:last-child {\n      height: 3.5rem + ",
        ";\n    }\n  }\n"
    ]);
    SkillsItem_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SkillsItem_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-row: span 2;\n  display: block;\n  width: 3.5rem;\n  max-height: 3.5rem;\n  align-self: center;\n  filter: grayscale(100%);\n"
    ]);
    SkillsItem_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SkillsItem_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  margin-top: 0;\n  margin-bottom: ",
        ";\n"
    ]);
    SkillsItem_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SkillsItem_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  margin: 0;\n"
    ]);
    SkillsItem_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SkillsItem_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  --level1: ",
        ";\n  --level2: ",
        ";\n  --level3: ",
        ";\n  --level-gradient: linear-gradient(\n    to right,\n    var(--level1),\n    var(--level1) ",
        ",\n    transparent ",
        ",\n    transparent calc(",
        " + ",
        "),\n    var(--level2) calc(",
        " + ",
        "),\n    var(--level2) calc(",
        " + ",
        " + ",
        "),\n    transparent calc(",
        " + ",
        " + ",
        "),\n    transparent\n      calc(\n        ",
        " + ",
        " + ",
        " +\n          ",
        "\n      ),\n    var(--level3)\n      calc(\n        ",
        " + ",
        " + ",
        " +\n          ",
        "\n      )\n  );\n  width: 3.5rem;\n  height: ",
        ";\n  margin-right: ",
        ";\n  clip-path: polygon(0 100%, 100% 0, 100% 100%);\n  background-image: var(--level-gradient);\n  &.level_1 {\n    --level1: ",
        ";\n  }\n  &.level_2 {\n    --level1: ",
        ";\n    --level2: ",
        ";\n  }\n  &.level_3 {\n    --level1: ",
        ";\n    --level2: ",
        ";\n    --level3: ",
        ";\n  }\n"
    ]);
    SkillsItem_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function SkillsItem_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  text-transform: uppercase;\n  line-height: 1;\n  color: ",
        ";\n\n  @media (max-width: ",
        ") {\n    margin-top: ",
        ";\n  }\n"
    ]);
    SkillsItem_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var StyledSkillsItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-e4487fe1-0"
})(SkillsItem_styled_templateObject(), (0,theme/* spacing */.W0)("md"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("lg"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"));
var StyledSkillsItemIcon = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-e4487fe1-1"
})(SkillsItem_styled_templateObject1());
var StyledSkillsItemTitle = styled_components_browser_esm/* default.h5.withConfig */.ZP.h5.withConfig({
    componentId: "sc-e4487fe1-2"
})(SkillsItem_styled_templateObject2(), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* fontSize */.JB)("md"), (0,theme/* spacing */.W0)("xs2"));
var StyledSkillsItemLevel = styled_components_browser_esm/* default.figure.withConfig */.ZP.figure.withConfig({
    componentId: "sc-e4487fe1-3"
})(SkillsItem_styled_templateObject3());
var StyledSkillsItemLevelLadder = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e4487fe1-4"
})(SkillsItem_styled_templateObject4(), (0,theme/* color */.$_)("sand_150"), (0,theme/* color */.$_)("sand_150"), (0,theme/* color */.$_)("sand_150"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xs"), (0,theme/* color */.$_)("positive_500"), (0,theme/* color */.$_)("positive_500"), (0,theme/* color */.$_)("positive_500"), (0,theme/* color */.$_)("positive_500"), (0,theme/* color */.$_)("positive_500"), (0,theme/* color */.$_)("positive_500"));
var StyledSkillsItemLevelCaption = styled_components_browser_esm/* default.figcaption.withConfig */.ZP.figcaption.withConfig({
    componentId: "sc-e4487fe1-5"
})(SkillsItem_styled_templateObject5(), (0,theme/* fontSize */.JB)("xs"), (0,theme/* color */.$_)("text_subtle"), (0,theme/* screen */.sp)("mdMax"), (0,theme/* spacing */.W0)("xs"));

;// CONCATENATED MODULE: ./components/jobOffer/skills/SkillsItem.tsx




var SkillsItem = function(param) {
    var skillsItem = param.skillsItem;
    var t = (0,useI18n/* useI18n */.Q)("job-offer").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSkillsItem, {
        children: [
            skillsItem.icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSkillsItemIcon, {
                src: skillsItem.icon,
                alt: skillsItem.desc
            }),
            !skillsItem.icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSkillsItemIcon, {
                src: config/* config.defaultTechIcon */.v.defaultTechIcon,
                alt: skillsItem.skill
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSkillsItemTitle, {
                children: skillsItem.skill
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSkillsItemLevel, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSkillsItemLevelLadder, {
                        className: "level_" + skillsItem.level
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSkillsItemLevelCaption, {
                        children: [
                            skillsItem.level === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: t("skills.basic")
                            }),
                            skillsItem.level === 2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: t("skills.intermediate")
                            }),
                            skillsItem.level === 3 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: t("skills.expert")
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var skills_SkillsItem = (SkillsItem);

;// CONCATENATED MODULE: ./components/jobOffer/skills/SkillsList.styled.tsx

function SkillsList_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid ",
        ";\n  border-radius: ",
        ";\n  padding: ",
        ";\n  box-shadow: ",
        ";\n"
    ]);
    SkillsList_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SkillsList_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        display: ",
        ";\n        overflow: ",
        ";\n        flex-wrap: ",
        ";\n      "
    ]);
    SkillsList_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SkillsList_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n  padding: 0;\n  list-style: none;\n\n  @media (min-width: ",
        ") {\n    margin-bottom: 0;\n    padding-bottom: 0;\n  }\n\n  @media (max-width: ",
        ") {\n    ",
        "\n  }\n"
    ]);
    SkillsList_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var StyledSkillsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3ba36b48-0"
})(SkillsList_styled_templateObject(), (0,theme/* color */.$_)("midnight_200"), (0,theme/* radius */.q0)("lg"), (0,theme/* spacing */.W0)("lg"), (0,theme/* shadow */.AF)("md"));
var variants = {
    isMobileScroll: {
        overflow: "auto",
        flexWrap: "nowrap",
        display: "flex"
    }
};
var StyledSkillsList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-3ba36b48-1"
})(SkillsList_styled_templateObject2(), (0,theme/* screen */.sp)("md"), (0,theme/* screen */.sp)("mdMax"), function(param) {
    var variant = param.variant;
    return variant && variants[variant] && (0,styled_components_browser_esm/* css */.iv)(SkillsList_styled_templateObject1(), variants[variant].display, variants[variant].overflow, variants[variant].flexWrap);
});

;// CONCATENATED MODULE: ./components/jobOffer/skills/SkillsList.tsx



var SkillsList = function(param) {
    var skillsListTitle = param.skillsListTitle, children = param.children, variant = param.variant;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSkillsContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading4 */.k8, {
                children: skillsListTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSkillsList, {
                variant: variant,
                children: children
            })
        ]
    });
};
/* harmony default export */ var skills_SkillsList = (SkillsList);

;// CONCATENATED MODULE: ./components/jobOffer/skills/SkillsNoStack.styled.tsx

function SkillsNoStack_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n  padding: ",
        ";\n  background-color: ",
        ";\n  border-radius: ",
        ";\n  display: flex;\n  text-align: left;\n"
    ]);
    SkillsNoStack_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SkillsNoStack_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  width: ",
        ";\n  height: ",
        ";\n  margin-right: ",
        ";\n"
    ]);
    SkillsNoStack_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SkillsNoStack_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  color: ",
        ";\n\n  p {\n    margin: 0;\n  }\n"
    ]);
    SkillsNoStack_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SkillsNoStack_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  line-height: 1.25;\n  color: ",
        ";\n  font-weight: ",
        ";\n  margin-top: 0;\n  margin-bottom: ",
        ";\n"
    ]);
    SkillsNoStack_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var StyledSkillsNoStack = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-15c88991-0"
})(SkillsNoStack_styled_templateObject(), (0,theme/* container */.nC)("xs"), (0,theme/* spacing */.W0)("lg"), (0,theme/* color */.$_)("emerald_100"), (0,theme/* radius */.q0)("md"));
var StyledSkillsNoStackImg = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-15c88991-1"
})(SkillsNoStack_styled_templateObject1(), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("md"));
var StyledSkillsNoStackContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-15c88991-2"
})(SkillsNoStack_styled_templateObject2(), (0,theme/* fontSize */.JB)("sm"), (0,theme/* color */.$_)("text_subtle"));
var StyledSkillsNoStackTitle = styled_components_browser_esm/* default.h5.withConfig */.ZP.h5.withConfig({
    componentId: "sc-15c88991-3"
})(SkillsNoStack_styled_templateObject3(), (0,theme/* fontSize */.JB)("md"), (0,theme/* color */.$_)("text_default"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* spacing */.W0)("xs2"));

;// CONCATENATED MODULE: ./components/jobOffer/skills/SkillsNoStack.tsx




var SkillsNoStack = function() {
    var t = (0,useI18n/* useI18n */.Q)("job-offer").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSkillsNoStack, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSkillsNoStackImg, {
                src: (0,paths/* getPublicPath */.A)("/images/jobOffer/technologies/no-stack.svg"),
                alt: t("skills.noStack")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSkillsNoStackContent, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSkillsNoStackTitle, {
                        children: t("skills.noStack")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: t("skills.noStackDesc")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var skills_SkillsNoStack = (SkillsNoStack);

;// CONCATENATED MODULE: ./components/jobOffer/skills/SkillsSection.styled.ts

function SkillsSection_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n\n  @media (min-width: ",
        ") {\n    ",
        " {\n      margin-top: ",
        ";\n    }\n  }\n"
    ]);
    SkillsSection_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SkillsSection_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: ",
        ";\n  margin-top: ",
        ";\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: ",
        ";\n\n  > * {\n    width: 21rem;\n  }\n\n  @media (min-width: ",
        ") {\n    flex-wrap: nowrap;\n    margin-left: -",
        ";\n    margin-right: -",
        ";\n\n    > * {\n      width: 33.3%;\n      max-width: unset;\n    }\n  }\n"
    ]);
    SkillsSection_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SkillsSection_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  gap: ",
        ";\n  flex-direction: row;\n  justify-content: center;\n"
    ]);
    SkillsSection_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SkillsSection_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid ",
        ";\n  border-radius: ",
        ";\n  padding: ",
        ";\n  box-shadow: ",
        ";\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n  font-weight: ",
        ";\n  line-height: 1.25;\n  width: 100%;\n\n  @media (min-width: ",
        ") {\n    width: ",
        ";\n  }\n"
    ]);
    SkillsSection_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SkillsSection_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: ",
        ";\n  flex: 1 1 auto;\n"
    ]);
    SkillsSection_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var StyledSkillsSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-24e58b35-0"
})(SkillsSection_styled_templateObject(), (0,theme/* container */.nC)("lg"), (0,theme/* screen */.sp)("lg"), StyledJobOfferSubsection, (0,theme/* spacing */.W0)("xl4"));
var StyledSkillsLists = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-24e58b35-1"
})(SkillsSection_styled_templateObject1(), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl"), (0,theme/* screen */.sp)("lg"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl"));
var StyledLanguages = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-24e58b35-2"
})(SkillsSection_styled_templateObject2(), (0,theme/* spacing */.W0)("md"));
var StyledLanguage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-24e58b35-3"
})(SkillsSection_styled_templateObject3(), (0,theme/* color */.$_)("midnight_200"), (0,theme/* radius */.q0)("lg"), (0,theme/* spacing */.W0)("lg"), (0,theme/* shadow */.AF)("md"), (0,theme/* spacing */.W0)("xl"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* screen */.sp)("lg"), (0,theme/* container */.nC)("xs2"));
var StyledLanguageName = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-24e58b35-4"
})(SkillsSection_styled_templateObject4(), (0,theme/* fontWeight */.Ue)("medium"));

;// CONCATENATED MODULE: ./components/jobOffer/skills/SkillsSoftItem.styled.js

function SkillsSoftItem_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        ";\n  display: flex;\n  align-items: center;\n  text-align: left;\n  font-size: ",
        ";\n  color: ",
        ";\n  p {\n    margin: 0;\n  }\n"
    ]);
    SkillsSoftItem_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SkillsSoftItem_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  width: 3.5rem;\n  max-height: 3.5rem;\n  align-self: center;\n  margin-right: ",
        ";\n"
    ]);
    SkillsSoftItem_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SkillsSoftItem_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  margin: 0;\n  color: ",
        ";\n"
    ]);
    SkillsSoftItem_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var StyledSkillsSoftItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-22385303-0"
})(SkillsSoftItem_styled_templateObject(), (0,theme/* spacing */.W0)("lg"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* color */.$_)("text_subtle"));
var StyledSkillsSoftItemImg = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-22385303-1"
})(SkillsSoftItem_styled_templateObject1(), (0,theme/* spacing */.W0)("md"));
var StyledSkillsSoftItemTitle = styled_components_browser_esm/* default.h5.withConfig */.ZP.h5.withConfig({
    componentId: "sc-22385303-2"
})(SkillsSoftItem_styled_templateObject2(), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* fontSize */.JB)("md"), (0,theme/* color */.$_)("text_default"));

;// CONCATENATED MODULE: ./components/jobOffer/skills/SkillsSoftItem.tsx



var SkillsSoftItem = function(param) {
    var softSkills = param.softSkills;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSkillsSoftItem, {
        children: [
            softSkills.icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSkillsSoftItemImg, {
                src: softSkills.icon,
                alt: ""
            }),
            !softSkills.icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSkillsSoftItemImg, {
                src: config/* config.defaultSoftSkillIcon */.v.defaultSoftSkillIcon,
                alt: ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSkillsSoftItemTitle, {
                        children: softSkills.skill
                    }),
                    softSkills.desc && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: softSkills.desc
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var skills_SkillsSoftItem = (SkillsSoftItem);

;// CONCATENATED MODULE: ./components/jobOffer/skills/SkillsSection.tsx












var SkillsSection = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
    var t = (0,useI18n/* useI18n */.Q)("job-offer").t;
    var showTechsList = props.skills && props.skills.must && ((ref = props.skills.must) === null || ref === void 0 ? void 0 : ref.length) > 0 || props.skills.nice && ((ref1 = props.skills.nice) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 || props.skills.extra && ((ref2 = props.skills.extra) === null || ref2 === void 0 ? void 0 : ref2.length) > 0;
    var showTechs = showTechsList || props.noStack;
    var showSoftSkills = props.softSkills && props.softSkills.must && ((ref3 = props.softSkills.must) === null || ref3 === void 0 ? void 0 : ref3.length) > 0 || props.softSkills.nice && ((ref4 = props.softSkills.nice) === null || ref4 === void 0 ? void 0 : ref4.length) > 0 || props.softSkills.extra && ((ref5 = props.softSkills.extra) === null || ref5 === void 0 ? void 0 : ref5.length) > 0;
    var showMinLanguages = props.minLanguages && props.minLanguages.length > 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jobOffer_JobOfferSection, {
        name: "skills",
        title: t("titles.skills"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSkillsSection, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(jobOffer_JobOfferLongText, {
                    isMarkdown: props.migratedToMarkdown,
                    children: props.intro
                }),
                showTechs && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jobOffer_JobOfferSubsection, {
                        title: t("skills.tech"),
                        children: [
                            props.noStack && /*#__PURE__*/ (0,jsx_runtime.jsx)(skills_SkillsNoStack, {}),
                            showTechsList && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSkillsLists, {
                                children: [
                                    props.skills.must && props.skills.must.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(skills_SkillsList, {
                                        skillsListTitle: t("skills.mustHave"),
                                        children: (ref6 = props.skills.must) === null || ref6 === void 0 ? void 0 : ref6.map(function(s, i) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(skills_SkillsItem, {
                                                skillsItem: s
                                            }, i);
                                        })
                                    }),
                                    props.skills.nice && props.skills.nice.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(skills_SkillsList, {
                                        skillsListTitle: t("skills.niceToHave"),
                                        children: (ref7 = props.skills.nice) === null || ref7 === void 0 ? void 0 : ref7.map(function(s, i) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(skills_SkillsItem, {
                                                skillsItem: s
                                            }, i);
                                        })
                                    }),
                                    props.skills.extra && props.skills.extra.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(skills_SkillsList, {
                                        skillsListTitle: t("skills.extraPoints"),
                                        children: (ref8 = props.skills.extra) === null || ref8 === void 0 ? void 0 : ref8.map(function(s, i) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(skills_SkillsItem, {
                                                skillsItem: s
                                            }, i);
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }),
                showSoftSkills && /*#__PURE__*/ (0,jsx_runtime.jsx)(jobOffer_JobOfferSubsection, {
                    title: t("skills.skills"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSkillsLists, {
                        children: [
                            props.softSkills.must && props.softSkills.must.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(skills_SkillsList, {
                                skillsListTitle: t("skills.mustHave"),
                                children: (ref9 = props.softSkills.must) === null || ref9 === void 0 ? void 0 : ref9.map(function(s, i) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(skills_SkillsSoftItem, {
                                        softSkills: s
                                    }, i);
                                })
                            }),
                            props.softSkills.nice && props.softSkills.nice.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(skills_SkillsList, {
                                skillsListTitle: t("skills.niceToHave"),
                                children: (ref10 = props.softSkills.nice) === null || ref10 === void 0 ? void 0 : ref10.map(function(s, i) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(skills_SkillsSoftItem, {
                                        softSkills: s
                                    }, i);
                                })
                            }),
                            props.softSkills.extra && props.softSkills.extra.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(skills_SkillsList, {
                                skillsListTitle: t("skills.extraPoints"),
                                children: (ref11 = props.softSkills.extra) === null || ref11 === void 0 ? void 0 : ref11.map(function(s, i) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(skills_SkillsSoftItem, {
                                        softSkills: s
                                    }, i);
                                })
                            })
                        ]
                    })
                }),
                showMinLanguages && /*#__PURE__*/ (0,jsx_runtime.jsx)(jobOffer_JobOfferSubsection, {
                    title: t("skills.minLanguages"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLanguages, {
                        children: (ref12 = props.minLanguages) === null || ref12 === void 0 ? void 0 : ref12.map(function(l, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLanguage, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLanguageName, {
                                        children: l.name
                                    }),
                                    l.level !== "not-defined" && /*#__PURE__*/ (0,jsx_runtime.jsx)(LevelLadder/* default */.Z, {
                                        level: model/* LANGUAGES_LEVELS.indexOf */.TV.indexOf(l.level)
                                    })
                                ]
                            }, i);
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var skills_SkillsSection = (SkillsSection);

// EXTERNAL MODULE: ../../node_modules/react-slick/lib/index.js
var lib = __webpack_require__(23467);
;// CONCATENATED MODULE: ./components/jobOffer/team/TeamMember.styled.js

function TeamMember_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  margin: 0;\n  width: 18rem;\n  border-radius: ",
        ";\n  text-align: left;\n  overflow: hidden;\n  margin-left: ",
        ";\n  margin-right: ",
        ";\n  margin-bottom: ",
        ";\n  box-shadow: ",
        ";\n"
    ]);
    TeamMember_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TeamMember_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n"
    ]);
    TeamMember_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function TeamMember_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding: ",
        ";\n  font-size: ",
        ";\n  color: ",
        ";\n\n  p {\n    margin: 0;\n  }\n"
    ]);
    TeamMember_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function TeamMember_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  color: ",
        ";\n  margin-top: 0;\n  margin-bottom: ",
        ";\n  font-weight: ",
        ";\n"
    ]);
    TeamMember_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var StyledTeamMember = styled_components_browser_esm/* default.figure.withConfig */.ZP.figure.withConfig({
    componentId: "sc-397eaa27-0"
})(TeamMember_styled_templateObject(), (0,theme/* color */.$_)("white"), (0,theme/* radius */.q0)("lg"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xs"), (0,theme/* shadow */.AF)("md"));
var StyledTeamMemberImg = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-397eaa27-1"
})(TeamMember_styled_templateObject1());
var StyledTeamMemberCaption = styled_components_browser_esm/* default.figcaption.withConfig */.ZP.figcaption.withConfig({
    componentId: "sc-397eaa27-2"
})(TeamMember_styled_templateObject2(), (0,theme/* color */.$_)("white"), (0,theme/* spacing */.W0)("md"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* color */.$_)("text_subtle"));
var StyledTeamMemberTitle = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-397eaa27-3"
})(TeamMember_styled_templateObject3(), (0,theme/* fontSize */.JB)("md"), (0,theme/* color */.$_)("text_default"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* fontWeight */.Ue)("black"));

;// CONCATENATED MODULE: ./components/jobOffer/team/TeamMember.js


var TeamMember = function(param) {
    var members = param.members;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTeamMember, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTeamMemberImg, {
                src: members.img,
                alt: ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTeamMemberCaption, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTeamMemberTitle, {
                        children: members.fullName
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: members.desc
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var team_TeamMember = (TeamMember);

;// CONCATENATED MODULE: ./components/jobOffer/team/TeamMembers.styled.tsx

function TeamMembers_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  margin-top: ",
        ";\n"
    ]);
    TeamMembers_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TeamMembers_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n  margin-top: ",
        ";\n\n  p {\n    margin-bottom: 0;\n    margin-top: ",
        ";\n    line-height: 1.5;\n\n    &:first-child {\n      margin-top: 0;\n    }\n  }\n"
    ]);
    TeamMembers_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function TeamMembers_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        ";\n\n  .slick-track {\n    display: flex;\n    justify-content: flex-end;\n  }\n\n  &.is-centered {\n    padding-bottom: 0;\n\n    .slick-track {\n      justify-content: center;\n    }\n\n    .slick-slide {\n      max-width: 20rem;\n    }\n  }\n"
    ]);
    TeamMembers_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function TeamMembers_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: -",
        ";\n  margin-right: -",
        ";\n\n  @media (min-width: ",
        ") {\n    margin-left: calc(-100vw / 2 + ",
        " / 2);\n    margin-right: calc(-100vw / 2 + ",
        " / 2);\n  }\n"
    ]);
    TeamMembers_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var StyledTeamMembers = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8085fb82-0"
})(TeamMembers_styled_templateObject(), (0,theme/* spacing */.W0)("xl3"));
var StyledTeamMembersInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8085fb82-1"
})(TeamMembers_styled_templateObject1(), (0,theme/* container */.nC)("md"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("xl"));
var StyledTeamMembersList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8085fb82-2"
})(TeamMembers_styled_templateObject2(), (0,theme/* spacing */.W0)("lg"));
var StyledTeamMembersListContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8085fb82-3"
})(TeamMembers_styled_templateObject3(), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* container */.nC)("lg"), (0,theme/* container */.nC)("lg"), (0,theme/* container */.nC)("lg"));

;// CONCATENATED MODULE: ./components/jobOffer/team/TeamMembers.tsx









var TeamMembers = function(props) {
    var totalSlides = function totalSlides() {
        var ref;
        var slideWidth = 320;
        var width = ((ref = slider.current) === null || ref === void 0 ? void 0 : ref.clientWidth) || slideWidth;
        var slides;
        if (width > slideWidth) {
            slides = width / slideWidth;
            if (slides > props.members.length) {
                slides = props.members.length;
                setAllSlidesvisible(true);
            } else {
                setAllSlidesvisible(false);
            }
        } else {
            slides = 1;
        }
        setSlides(slides);
    };
    var t = (0,useI18n/* useI18n */.Q)("job-offer").t;
    var slider = (0,react.useRef)(null);
    var ref = (0,react.useState)(1), slides = ref[0], setSlides = ref[1];
    var ref1 = (0,react.useState)(false), allSlidesVisible = ref1[0], setAllSlidesvisible = ref1[1];
    var membersInfo = props.membersInfo, members = props.members;
    var settings = {
        dots: true,
        arrows: false,
        speed: 300,
        slidesToShow: slides,
        slidesToScroll: slides
    };
    (0,react.useEffect)(function() {
        totalSlides();
        window.addEventListener("resize", totalSlides);
        return function() {
            window.removeEventListener("resize", totalSlides);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTeamMembers, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jobOffer_JobOfferSubsection, {
            title: t("team.team"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTeamMembersInfo, {
                    children: props.migratedToMarkdown ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledJobOfferLongText, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MarkdownComponent["default"], {
                            content: membersInfo || ""
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: membersInfo || ""
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTeamMembersListContainer, {
                    ref: slider,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTeamMembersList, {
                        className: "".concat(allSlidesVisible ? "is-centered" : ""),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                            dots: settings.dots,
                            arrows: settings.arrows,
                            speed: settings.speed,
                            slidesToShow: settings.slidesToShow,
                            slidesToScroll: settings.slidesToScroll,
                            children: members.map(function(m, i) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(team_TeamMember, {
                                    members: m
                                }, i);
                            })
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var team_TeamMembers = (TeamMembers);

;// CONCATENATED MODULE: ./components/jobOffer/team/TeamPicture.styled.js

function TeamPicture_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding: ",
        ";\n  border-radius: ",
        ";\n  margin: 0;\n  margin-bottom: ",
        ";\n\n  @media (min-width: ",
        ") {\n    margin-bottom: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    TeamPicture_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TeamPicture_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n"
    ]);
    TeamPicture_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function TeamPicture_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  color: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.14;\n  margin-top: ",
        ";\n\n  svg {\n    color: ",
        ";\n    margin-right: ",
        ";\n    width: ",
        ";\n    height: ",
        ";\n  }\n"
    ]);
    TeamPicture_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var StyledTeamPicture = styled_components_browser_esm/* default.figure.withConfig */.ZP.figure.withConfig({
    componentId: "sc-3d4266a6-0"
})(TeamPicture_styled_templateObject(), (0,theme/* color */.$_)("midnight_850"), (0,theme/* spacing */.W0)("md"), (0,theme/* radius */.q0)("md"), (0,theme/* spacing */.W0)("lg"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl"), (0,theme/* screen */.sp)("lg"), (0,theme/* spacing */.W0)("xl3"));
var StyledTeamPictureImg = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-3d4266a6-1"
})(TeamPicture_styled_templateObject1());
var StyledTeamPictureCaption = styled_components_browser_esm/* default.figcaption.withConfig */.ZP.figcaption.withConfig({
    componentId: "sc-3d4266a6-2"
})(TeamPicture_styled_templateObject2(), (0,theme/* color */.$_)("text_default_inverse"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* spacing */.W0)("md"), (0,theme/* color */.$_)("emerald_600"), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"));

;// CONCATENATED MODULE: ./components/jobOffer/team/TeamPicture.js




var TeamPicture = function(param) {
    var teamImage = param.teamImage, teamImageCaption = param.teamImageCaption;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTeamPicture, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTeamPictureImg, {
                src: teamImage,
                alt: ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTeamPictureCaption, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                        icon: free_solid_svg_icons/* faInfoCircle */.sqG
                    }),
                    teamImageCaption
                ]
            })
        ]
    });
};
/* harmony default export */ var team_TeamPicture = (TeamPicture);

;// CONCATENATED MODULE: ./components/jobOffer/team/TeamSection.styled.js

function TeamSection_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: auto;\n  margin-top: ",
        ";\n  max-width: ",
        ";\n\n  @media (min-width: ",
        ") {\n    margin-top: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    margin-top: ",
        ";\n  }\n\n  ul,\n  ol,\n  p {\n    margin-top: 0;\n    margin-bottom: ",
        ";\n    line-height: 1.5;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n"
    ]);
    TeamSection_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledTeamSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-79f49919-0"
})(TeamSection_styled_templateObject(), (0,theme/* spacing */.W0)("md"), (0,theme/* container */.nC)("sm"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl"), (0,theme/* screen */.sp)("lg"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* spacing */.W0)("xl"));

;// CONCATENATED MODULE: ./components/jobOffer/team/TeamSection.tsx









var TeamSection = function(param) {
    var teamImage = param.teamImage, teamImageCaption = param.teamImageCaption, teamInfo = param.teamInfo, membersInfo = param.membersInfo, members = param.members, migratedToMarkdown = param.migratedToMarkdown, isFreelance = param.isFreelance;
    var t = (0,useI18n/* useI18n */.Q)("job-offer").t;
    var showWIPFeatures = (0,react.useContext)(wip_features_context/* default */.Z);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jobOffer_JobOfferSection, {
        name: "equipo",
        sectionBg: "alt",
        title: t(isFreelance ? "titles.team_freelance" : "titles.team"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTeamSection, {
                children: [
                    showWIPFeatures && /*#__PURE__*/ (0,jsx_runtime.jsx)(team_TeamPicture, {
                        teamImage: teamImage,
                        teamImageCaption: teamImageCaption
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(jobOffer_JobOfferLongText, {
                        isMarkdown: migratedToMarkdown,
                        children: teamInfo
                    })
                ]
            }),
            showWIPFeatures && /*#__PURE__*/ (0,jsx_runtime.jsx)(team_TeamMembers, {
                membersInfo: membersInfo,
                members: members,
                migratedToMarkdown: migratedToMarkdown
            })
        ]
    });
};
/* harmony default export */ var team_TeamSection = (TeamSection);

;// CONCATENATED MODULE: ./components/jobOffer/when/WhenHighlights.styled.js

function WhenHighlights_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-bottom: ",
        ";\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n\n  @media (min-width: ",
        ") {\n    border-bottom: 1px solid ",
        ";\n    border-top: 1px solid ",
        ";\n  }\n"
    ]);
    WhenHighlights_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function WhenHighlights_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  text-align: center;\n  max-width: ",
        ";\n  margin: ",
        " auto ",
        ";\n  \n"
    ]);
    WhenHighlights_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function WhenHighlights_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  gap: ",
        ";\n  margin-top: ",
        ";\n  margin-left: auto;\n  margin-right: auto;\n\n  @media (min-width: ",
        ") {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: flex-start;\n    gap: ",
        " ",
        ";\n    margin-top: ",
        ";\n  }\n"
    ]);
    WhenHighlights_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var StyledWhenHighlights = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6dba944f-0"
})(WhenHighlights_styled_templateObject(), (0,theme/* spacing */.W0)("lg"), (0,theme/* screen */.sp)("md"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* color */.$_)("midnight_200"));
var StyledWhenHighlightsIntro = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6dba944f-1"
})(WhenHighlights_styled_templateObject1(), (0,theme/* fontSize */.JB)("sm"), (0,theme/* container */.nC)("sm"), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("sm"));
var StyledWhenHighlightsList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6dba944f-2"
})(WhenHighlights_styled_templateObject2(), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* spacing */.W0)("md"));

;// CONCATENATED MODULE: ./components/jobOffer/when/WhenHighlightsItem.styled.tsx

function WhenHighlightsItem_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  //margin-bottom: ",
        ";\n"
    ]);
    WhenHighlightsItem_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function WhenHighlightsItem_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  width: ",
        ";\n"
    ]);
    WhenHighlightsItem_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function WhenHighlightsItem_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-grow: 1;\n  margin-left: ",
        ";\n"
    ]);
    WhenHighlightsItem_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function WhenHighlightsItem_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-weight: ",
        ";\n  text-transform: uppercase;\n  font-size: ",
        ";\n  line-height: 1.25;\n  margin-top: 0;\n  margin-bottom: ",
        ";\n"
    ]);
    WhenHighlightsItem_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function WhenHighlightsItem_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1;\n  text-transform: uppercase;\n"
    ]);
    WhenHighlightsItem_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function WhenHighlightsItem_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1;\n  text-transform: uppercase;\n  margin-top: ",
        ";\n"
    ]);
    WhenHighlightsItem_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}



var StyledWhenHighlightsItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c51cd5df-0"
})(WhenHighlightsItem_styled_templateObject(), (0,theme/* spacing */.W0)("xl3"));
var StyledWhenHighlightsItemIcon = (0,styled_components_browser_esm/* default */.ZP)((image_default())).withConfig({
    componentId: "sc-c51cd5df-1"
})(WhenHighlightsItem_styled_templateObject1(), (0,theme/* spacing */.W0)("xl4"));
var StyledWhenHighlightsItemContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c51cd5df-2"
})(WhenHighlightsItem_styled_templateObject2(), (0,theme/* spacing */.W0)("md"));
var StyledWhenHighlightsItemTitle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    componentId: "sc-c51cd5df-3"
})(WhenHighlightsItem_styled_templateObject3(), (0,theme/* color */.$_)("text_subtle"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* fontSize */.JB)("md"), (0,theme/* spacing */.W0)("xs"));
var StyledWhenHighlightsItemValue = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-c51cd5df-4"
})(WhenHighlightsItem_styled_templateObject4(), (0,theme/* fontFamily */.I8)("display"), (0,theme/* fontWeight */.Ue)("light"), (0,theme/* fontSize */.JB)("xl4"));
var StyledWhenHighlightsItemExtra = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-c51cd5df-5"
})(WhenHighlightsItem_styled_templateObject5(), (0,theme/* fontFamily */.I8)("display"), (0,theme/* fontWeight */.Ue)("light"), (0,theme/* fontSize */.JB)("xl2"), (0,theme/* spacing */.W0)("xs"));

;// CONCATENATED MODULE: ./components/jobOffer/when/WhenHighlightsItem.tsx





var WhenHighlightsItem = function(param) {
    var highlights = param.highlights, migratedToMarkdown = param.migratedToMarkdown;
    var HighlightsItem = /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWhenHighlightsItem, {
        tabIndex: 0,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWhenHighlightsItemIcon, {
                src: highlights.icon,
                width: 64,
                height: 64
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWhenHighlightsItemContent, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWhenHighlightsItemTitle, {
                        children: highlights.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWhenHighlightsItemValue, {
                        children: highlights.value
                    }),
                    highlights.extra && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWhenHighlightsItemExtra, {
                        children: highlights.extra
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            highlights.tooltip && /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipMF/* default */.Z, {
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: migratedToMarkdown ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledJobOfferLongText, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MarkdownComponent["default"], {
                            content: highlights.tooltip || ""
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        dangerouslySetInnerHTML: {
                            __html: highlights.tooltip || ""
                        }
                    })
                }),
                children: HighlightsItem
            }),
            !highlights.tooltip && HighlightsItem
        ]
    });
};
/* harmony default export */ var when_WhenHighlightsItem = (WhenHighlightsItem);

;// CONCATENATED MODULE: ./components/jobOffer/when/WhenHighlights.tsx





var WhenHighlights = function(param) {
    var highlightsIntro = param.highlightsIntro, highlights = param.highlights, migratedToMarkdown = param.migratedToMarkdown;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWhenHighlights, {
        children: [
            highlightsIntro && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: migratedToMarkdown ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWhenHighlightsIntro, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledJobOfferLongText, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MarkdownComponent["default"], {
                            content: highlightsIntro || ""
                        })
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWhenHighlightsIntro, {
                    dangerouslySetInnerHTML: {
                        __html: highlightsIntro || ""
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWhenHighlightsList, {
                children: highlights && highlights.map(function(h, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(when_WhenHighlightsItem, {
                        highlights: h,
                        migratedToMarkdown: migratedToMarkdown
                    }, i);
                })
            })
        ]
    });
};
/* harmony default export */ var when_WhenHighlights = (WhenHighlights);

// EXTERNAL MODULE: ./components/shared/RadioButton.tsx
var RadioButton = __webpack_require__(73273);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
;// CONCATENATED MODULE: ./components/jobOffer/when/WhenInfographic.styled.tsx
/* eslint-disable @typescript-eslint/no-explicit-any */ 
function WhenInfographic_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  --hour-width: ",
        ";\n  max-width: ",
        ";\n  margin: 0;\n  margin-top: ",
        ";\n\n  @media (max-width: ",
        ") {\n    display: none;\n  }\n"
    ]);
    WhenInfographic_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function WhenInfographic_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: repeat(var(--total-hours), var(--hour-width));\n  column-gap: ",
        ";\n  margin-bottom: ",
        ";\n  align-items: end;\n"
    ]);
    WhenInfographic_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function WhenInfographic_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      color: ",
        ";\n      background-color: ",
        ";\n    "
    ]);
    WhenInfographic_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function WhenInfographic_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  background-color: ",
        ";\n  color: ",
        ";\n  height: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  line-height: 1;\n  vertical-align: text-bottom;\n  clip-path: polygon(\n    ",
        " 0,\n    calc(100% - ",
        ") 0,\n    100% 50%,\n    calc(100% - ",
        ") 100%,\n    ",
        " 100%,\n    0 50%\n  );\n  grid-column: span var(--time-span);\n\n  ",
        "\n\n  &.is-free {\n    margin-top: 1.2em;\n  }\n"
    ]);
    WhenInfographic_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function WhenInfographic_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: repeat(var(--total-hours), var(--hour-width));\n  column-gap: ",
        ";\n"
    ]);
    WhenInfographic_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function WhenInfographic_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      ",
        " {\n        background-color: ",
        ";\n      }\n    "
    ]);
    WhenInfographic_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function WhenInfographic_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  column-gap: ",
        ";\n  grid-column: span var(--time-span);\n  grid-template-columns: repeat(var(--time-span), 1fr);\n  position: relative;\n\n  ",
        "\n"
    ]);
    WhenInfographic_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function WhenInfographic_styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  height: ",
        ";\n"
    ]);
    WhenInfographic_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function WhenInfographic_styled_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-grow: 1;\n  margin-left: ",
        ";\n  margin-right: ",
        ";\n  height: 1px;\n  background-color: ",
        ";\n  position: relative;\n\n  &::after,\n  &::before {\n    content: '';\n    display: block;\n    width: 4px;\n    height: 4px;\n    border: solid ",
        ";\n    border-width: 0 1px 1px 0;\n    position: absolute;\n    top: -2px;\n  }\n\n  &::after {\n    transform: rotate(-45deg);\n    right: 0;\n  }\n\n  &::before {\n    transform: rotate(135deg);\n    left: 0;\n  }\n"
    ]);
    WhenInfographic_styled_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function WhenInfographic_styled_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-column-start: 1;\n  grid-column-end: -1;\n  min-height: ",
        ";\n  margin-top: ",
        ";\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  line-height: 1;\n\n  &.is-free {\n    justify-content: center;\n    position: relative;\n    color: ",
        ";\n\n    > span {\n      position: absolute;\n      top: -5.4em;\n    }\n  }\n\n  &.flex-in {\n    > span {\n      margin-left: -1.25em;\n    }\n    ",
        " {\n      margin-right: 1.25em;\n    }\n  }\n\n  &.flex-out {\n    > span {\n      margin-right: -1.25em;\n    }\n    ",
        " {\n      margin-left: 1.25em;\n    }\n  }\n\n  &.fixed {\n    .fixed-in {\n      margin-left: -1.25em;\n    }\n    .fixed-out {\n      margin-right: -1.25em;\n    }\n  }\n\n  @media (max-width: ",
        ") {\n    display: none;\n  }\n"
    ]);
    WhenInfographic_styled_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function WhenInfographic_styled_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: repeat(var(--total-hours), var(--hour-width));\n  align-items: center;\n  column-gap: ",
        ";\n  margin-bottom: ",
        ";\n"
    ]);
    WhenInfographic_styled_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function WhenInfographic_styled_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      grid-column: ",
        ";\n      color: ",
        ";\n    "
    ]);
    WhenInfographic_styled_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function WhenInfographic_styled_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  text-transform: uppercase;\n  color: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  line-height: 1.15;\n  grid-column: span var(--time-span);\n\n  ",
        "\n\n  &.flex-in {\n    margin-left: -1em;\n    text-align: left;\n  }\n\n  &.flex-out {\n    margin-right: -1em;\n    text-align: right;\n  }\n\n  .fixed {\n    padding-left: 1em;\n    padding-right: 1em;\n  }\n\n  ",
        " {\n    margin-top: ",
        ";\n  }\n"
    ]);
    WhenInfographic_styled_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function WhenInfographic_styled_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: ",
        ";\n  margin-top: ",
        ";\n  padding-left: 1em;\n  padding-right: 1em;\n"
    ]);
    WhenInfographic_styled_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}


var StyledWhenInfographic = styled_components_browser_esm/* default.figure.attrs */.ZP.figure.attrs(function(props) {
    return {
        "aria-hidden": props.ariaHidden
    };
}).withConfig({
    componentId: "sc-388d66e0-0"
})(WhenInfographic_styled_templateObject(), (0,theme/* spacing */.W0)("xl3"), (0,theme/* container */.nC)("sm"), (0,theme/* spacing */.W0)("xl"), (0,theme/* screen */.sp)("mdMax"));
var StyledWhenInfographicDuration = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-388d66e0-1"
})(WhenInfographic_styled_templateObject1(), (0,theme/* spacing */.W0)("xs2"), (0,theme/* spacing */.W0)("xs"));
var durationVariants = {
    free: {
        color: (0,theme/* color */.$_)("emerald_500"),
        backgroundColor: (0,theme/* color */.$_)("emerald_150"),
        backgroundColorHour: (0,theme/* color */.$_)("emerald_150")
    },
    flexible: {
        color: (0,theme/* color */.$_)("emerald_500"),
        backgroundColor: (0,theme/* color */.$_)("emerald_150"),
        backgroundColorHour: (0,theme/* color */.$_)("emerald_150"),
        gridColumn: "span var(--flexible-hours)"
    },
    fixed: {
        gridColumn: "span var(--fixed-hours)"
    }
};
var StyledWhenInfographicDurationItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-388d66e0-2"
})(WhenInfographic_styled_templateObject3(), (0,theme/* color */.$_)("navy_500"), (0,theme/* color */.$_)("white"), (0,theme/* spacing */.W0)("lg"), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontWeight */.Ue)("extraBold"), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("xs"), function(param) {
    var schedule = param.schedule;
    return schedule && durationVariants[schedule] && (0,styled_components_browser_esm/* css */.iv)(WhenInfographic_styled_templateObject2(), durationVariants[schedule].color, durationVariants[schedule].backgroundColor);
});
var StyledWhenInfographicHours = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-388d66e0-3"
})(WhenInfographic_styled_templateObject4(), (0,theme/* spacing */.W0)("xs2"));
var StyledWhenInfographicHoursSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-388d66e0-4"
})(WhenInfographic_styled_templateObject6(), (0,theme/* spacing */.W0)("xs2"), function(param) {
    var schedule = param.schedule;
    return schedule && durationVariants[schedule] && (0,styled_components_browser_esm/* css */.iv)(WhenInfographic_styled_templateObject5(), StyledWhenInfographicHourItem, durationVariants[schedule].backgroundColorHour);
});
var StyledWhenInfographicHourItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-388d66e0-5"
})(WhenInfographic_styled_templateObject7(), (0,theme/* color */.$_)("navy_300"), (0,theme/* spacing */.W0)("xs"));
var StyledWhenInfographicHourSeparator = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-388d66e0-6"
})(WhenInfographic_styled_templateObject8(), (0,theme/* spacing */.W0)("xs2"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* color */.$_)("sand_200"), (0,theme/* color */.$_)("sand_200"));
var StyledWhenInfographicHourInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-388d66e0-7"
})(WhenInfographic_styled_templateObject9(), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xs"), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontWeight */.Ue)("extraBold"), (0,theme/* color */.$_)("emerald_500"), StyledWhenInfographicHourSeparator, StyledWhenInfographicHourSeparator, (0,theme/* screen */.sp)("mdMax"));
var StyledWhenInfographicLabels = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-388d66e0-8"
})(WhenInfographic_styled_templateObject10(), (0,theme/* spacing */.W0)("xs2"), (0,theme/* spacing */.W0)("sm"));
var StyledWhenInfographicLabelItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-388d66e0-9"
})(WhenInfographic_styled_templateObject12(), (0,theme/* color */.$_)("text_subtle"), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontWeight */.Ue)("black"), function(param) {
    var schedule = param.schedule;
    return schedule && durationVariants[schedule] && (0,styled_components_browser_esm/* css */.iv)(WhenInfographic_styled_templateObject11(), durationVariants[schedule].gridColumn, durationVariants[schedule].color);
}, StyledWhenInfographicHourSeparator, (0,theme/* spacing */.W0)("xs2"));
var StyledWhenInfographicLabelItemExtra = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-388d66e0-10"
})(WhenInfographic_styled_templateObject13(), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* spacing */.W0)("xs2"));

;// CONCATENATED MODULE: ./components/jobOffer/when/WhenInfographic.tsx





var WhenInfographic = function(param) {
    var ranges = param.ranges, title = param.title, subtitle = param.subtitle, inOutFlexibleMinutes = param.inOutFlexibleMinutes, caption = param.caption;
    var getSchedule = function getSchedule(flexible, free) {
        if (flexible) {
            return "flexible";
        } else if (free) {
            return "free";
        } else {
            return "";
        }
    };
    var t = (0,useI18n/* useI18n */.Q)("job-offer").t;
    var totalHours = 0;
    ranges.forEach(function(range) {
        return totalHours = totalHours + Math.ceil(range.totalTime);
    });
    var flexibleHours = 0;
    ranges.forEach(function(range) {
        if (range.flexibleTime) {
            flexibleHours = flexibleHours + range.totalTime;
        }
    });
    var fixedHours = totalHours - Math.ceil(flexibleHours / 2) * 2;
    var totalHoursVar = {
        "--total-hours": totalHours,
        "--flexible-hours": Math.ceil(flexibleHours / 2),
        "--fixed-hours": fixedHours
    };
    var Hours = function(param) {
        var hours = param.hours;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                hours < 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        hours * 60,
                        " ",
                        t("when.minutes")
                    ]
                }),
                hours >= 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        hours,
                        " ",
                        t("when.hours")
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWhenInfographic, {
        style: totalHoursVar,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                "aria-hidden": "true",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWhenInfographicLabels, {
                        children: [
                            inOutFlexibleMinutes > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWhenInfographicLabelItem, {
                                schedule: "flexible",
                                className: "flex-in",
                                children: t("when.schedules.flexIn")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWhenInfographicLabelItem, {
                                schedule: "fixed",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "fixed",
                                        children: title
                                    }),
                                    inOutFlexibleMinutes > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWhenInfographicHourSeparator, {}),
                                    subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWhenInfographicLabelItemExtra, {
                                        children: subtitle
                                    })
                                ]
                            }),
                            inOutFlexibleMinutes > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWhenInfographicLabelItem, {
                                schedule: "flexible",
                                className: "flex-out",
                                children: t("when.schedules.flexOut")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWhenInfographicDuration, {
                        children: ranges && ranges.map(function(range, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWhenInfographicDurationItem, {
                                schedule: getSchedule(range.flexibleTime, range.freeTime),
                                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                style: (0,_define_property/* default */.Z)({}, "--time-span", Math.ceil(range.totalTime)),
                                className: "".concat(range.freeTime ? "is-free" : ""),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Hours, {
                                    hours: range.totalTime
                                })
                            }, i);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWhenInfographicHours, {
                        children: ranges && ranges.map(function(range, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWhenInfographicHoursSection, {
                                schedule: getSchedule(range.flexibleTime, range.freeTime),
                                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                style: (0,_define_property/* default */.Z)({}, "--time-span", Math.ceil(range.totalTime)),
                                children: [
                                    (0,_to_consumable_array/* default */.Z)(Array(Math.ceil(range.totalTime))).map(function(h, i) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWhenInfographicHourItem, {}, i);
                                    }),
                                    i === 0 && range.flexibleTime && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWhenInfographicHourInfo, {
                                        className: "flex-in",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: range.startTime
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWhenInfographicHourSeparator, {})
                                        ]
                                    }),
                                    !range.freeTime && (range.flexibleTime && i > 1 || !range.flexibleTime) && (range.flexibleTime && i < ranges.length - 1 || !range.flexibleTime) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWhenInfographicHourInfo, {
                                        className: "fixed",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "fixed-in",
                                                children: range.startTime
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWhenInfographicHourSeparator, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "fixed-out",
                                                children: range.endTime
                                            })
                                        ]
                                    }),
                                    range.freeTime && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWhenInfographicHourInfo, {
                                        className: "is-free",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            children: [
                                                "(",
                                                t("when.schedules.freeTime"),
                                                ")"
                                            ]
                                        })
                                    }),
                                    i === ranges.length - 1 && range.flexibleTime && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWhenInfographicHourInfo, {
                                        className: "flex-out",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWhenInfographicHourSeparator, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: range.endTime
                                            })
                                        ]
                                    })
                                ]
                            }, i);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("figcaption", {
                className: "sr-only",
                children: caption
            })
        ]
    });
};
/* harmony default export */ var when_WhenInfographic = (WhenInfographic);

;// CONCATENATED MODULE: ./components/jobOffer/when/WhenInfographicMobile.styled.tsx
/* eslint-disable @typescript-eslint/no-explicit-any */ 
function WhenInfographicMobile_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        ";\n  @media (min-width: ",
        ") {\n    display: none;\n  }\n"
    ]);
    WhenInfographicMobile_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function WhenInfographicMobile_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: ",
        ";\n"
    ]);
    WhenInfographicMobile_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function WhenInfographicMobile_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: ",
        ";\n  margin-bottom: ",
        ";\n"
    ]);
    WhenInfographicMobile_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function WhenInfographicMobile_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  text-align: center;\n  font-family: ",
        ";\n  text-transform: uppercase;\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  color: ",
        ";\n  margin-bottom: ",
        ";\n"
    ]);
    WhenInfographicMobile_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function WhenInfographicMobile_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  line-height: 1;\n  .separator {\n    color: ",
        ";\n  }\n"
    ]);
    WhenInfographicMobile_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function WhenInfographicMobile_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n  display: block;\n"
    ]);
    WhenInfographicMobile_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function WhenInfographicMobile_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      color: ",
        ";\n      background-color: ",
        ";\n      padding: ",
        " ",
        ";\n      .separator {\n        color: ",
        ";\n      }\n      ",
        " {\n        color: ",
        ";\n      }\n      ",
        " {\n        color: ",
        ";\n      }\n    "
    ]);
    WhenInfographicMobile_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function WhenInfographicMobile_styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        " ",
        ";\n  border-radius: ",
        ";\n\n  ",
        "\n"
    ]);
    WhenInfographicMobile_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}



var WhenInfographicMobile_styled_StyledWhenInfographic = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ad93a777-0"
})(WhenInfographicMobile_styled_templateObject(), (0,theme/* spacing */.W0)("xl"), (0,theme/* screen */.sp)("md"));
var StyledWhenInfographicTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography/* Heading4 */.k8).withConfig({
    componentId: "sc-ad93a777-1"
})(WhenInfographicMobile_styled_templateObject1(), (0,theme/* spacing */.W0)("sm"));
var StyledWhenInfographicBlock = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ad93a777-2"
})(WhenInfographicMobile_styled_templateObject2(), (0,theme/* spacing */.W0)("xs2"), (0,theme/* spacing */.W0)("sm"));
var WhenInfographicMobile_styled_variants = {
    flexible: {
        color: (0,theme/* color */.$_)("emerald_700"),
        backgroundColor: (0,theme/* color */.$_)("emerald_150"),
        colorSeparator: (0,theme/* color */.$_)("emerald_500"),
        colorLabel: (0,theme/* color */.$_)("emerald_500"),
        paddingV: (0,theme/* spacing */.W0)("xs")
    },
    free: {
        color: (0,theme/* color */.$_)("emerald_700"),
        backgroundColor: (0,theme/* color */.$_)("white"),
        colorSeparator: (0,theme/* color */.$_)("emerald_500"),
        colorLabel: (0,theme/* color */.$_)("emerald_500"),
        paddingV: (0,theme/* spacing */.W0)("xs")
    }
};
var StyledWhenInfographicItemLabel = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-ad93a777-3"
})(WhenInfographicMobile_styled_templateObject3(), (0,theme/* fontFamily */.I8)("sans"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* color */.$_)("text_subtle"), (0,theme/* spacing */.W0)("xs2"));
var StyledWhenInfographicItemValue = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-ad93a777-4"
})(WhenInfographicMobile_styled_templateObject4(), (0,theme/* fontFamily */.I8)("display"), (0,theme/* fontSize */.JB)("xl4"), (0,theme/* fontWeight */.Ue)("light"), (0,theme/* color */.$_)("text_placeholder"));
var StyledWhenInfographicItemExtra = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-ad93a777-5"
})(WhenInfographicMobile_styled_templateObject5(), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontWeight */.Ue)("extraBold"), (0,theme/* color */.$_)("text_subtle"));
var StyledWhenInfographicItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ad93a777-6"
})(WhenInfographicMobile_styled_templateObject7(), (0,theme/* spacing */.W0)("xs2"), (0,theme/* spacing */.W0)("sm"), (0,theme/* radius */.q0)("md"), function(param) {
    var schedule = param.schedule;
    return schedule && WhenInfographicMobile_styled_variants[schedule] && (0,styled_components_browser_esm/* css */.iv)(WhenInfographicMobile_styled_templateObject6(), WhenInfographicMobile_styled_variants[schedule].color, WhenInfographicMobile_styled_variants[schedule].backgroundColor, WhenInfographicMobile_styled_variants[schedule].paddingV, (0,theme/* spacing */.W0)("sm"), WhenInfographicMobile_styled_variants[schedule].colorSeparator, StyledWhenInfographicItemLabel, WhenInfographicMobile_styled_variants[schedule].colorLabel, StyledWhenInfographicItemExtra, WhenInfographicMobile_styled_variants[schedule].colorLabel);
});

;// CONCATENATED MODULE: ./components/jobOffer/when/WhenInfographicMobile.tsx



var WhenInfographicMobile = function(param) {
    var ranges = param.ranges, title = param.title, subtitle = param.subtitle;
    var getSchedule = function getSchedule(flexible, free) {
        if (flexible) {
            return "flexible";
        } else if (free) {
            return "free";
        } else {
            return "";
        }
    };
    var t = (0,useI18n/* useI18n */.Q)("job-offer").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(WhenInfographicMobile_styled_StyledWhenInfographic, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWhenInfographicTitle, {
                children: [
                    title,
                    " "
                ]
            }),
            ranges && ranges.map(function(range, i) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWhenInfographicBlock, {
                    children: [
                        i === 0 && range.flexibleTime && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWhenInfographicItem, {
                            schedule: getSchedule(range.flexibleTime, range.freeTime),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWhenInfographicItemLabel, {
                                    children: t("when.schedules.flexIn")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWhenInfographicItemValue, {
                                    children: [
                                        range.startTime,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "separator",
                                            children: " - "
                                        }),
                                        range.endTime
                                    ]
                                })
                            ]
                        }),
                        !range.freeTime && (range.flexibleTime && i > 1 || !range.flexibleTime) && (range.flexibleTime && i < ranges.length - 1 || !range.flexibleTime) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWhenInfographicItem, {
                            schedule: getSchedule(range.flexibleTime, range.freeTime),
                            children: [
                                (i === 0 || i === 1) && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWhenInfographicItemLabel, {
                                    children: subtitle
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWhenInfographicItemValue, {
                                    children: [
                                        range.startTime,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "separator",
                                            children: " - "
                                        }),
                                        range.endTime
                                    ]
                                })
                            ]
                        }),
                        range.freeTime && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWhenInfographicItem, {
                            schedule: getSchedule(range.flexibleTime, range.freeTime),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWhenInfographicItemExtra, {
                                children: t("when.schedules.freeTimeMobile", {
                                    total: range.totalTime < 1 ? "".concat(range.totalTime * 60).concat(t("when.minutes")) : "".concat(range.totalTime).concat(t("when.hours")),
                                    start: range.startTime,
                                    end: range.endTime
                                })
                            })
                        }),
                        i === ranges.length - 1 && range.flexibleTime && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWhenInfographicItem, {
                            schedule: getSchedule(range.flexibleTime, range.freeTime),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWhenInfographicItemLabel, {
                                    children: t("when.schedules.flexOut")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWhenInfographicItemValue, {
                                    children: [
                                        range.startTime,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "separator",
                                            children: " - "
                                        }),
                                        range.endTime
                                    ]
                                })
                            ]
                        })
                    ]
                }, i);
            })
        ]
    });
};
/* harmony default export */ var when_WhenInfographicMobile = (WhenInfographicMobile);

;// CONCATENATED MODULE: ./components/jobOffer/when/WhenSchedule.styled.js

function WhenSchedule_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: ",
        ";\n"
    ]);
    WhenSchedule_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function WhenSchedule_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  \n\n  @media (max-width: ",
        ") {\n    //width: 100%;\n    min-width: ",
        ";\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    padding: ",
        " ",
        " calc(",
        " + ",
        ") ",
        ";\n    clip-path: polygon(\n      0 0,\n      100% 0,\n      100% calc(100% - ",
        "),\n      50% 100%,\n      0 calc(100% - ",
        ")\n    );\n    margin-bottom: 0;\n    gap: ",
        ";\n    \n  }\n\n  @media (min-width: ",
        ") {\n    display: flex;\n    align-items: center;\n    border-radius: ",
        ";\n    gap: ",
        ";\n    padding: ",
        " ",
        ";\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    WhenSchedule_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function WhenSchedule_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n"
    ]);
    WhenSchedule_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function WhenSchedule_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-weight: ",
        ";\n  text-transform: uppercase;\n  font-size: ",
        ";\n  line-height: 1.25;\n  margin-top: 0;\n  margin-bottom: ",
        ";\n"
    ]);
    WhenSchedule_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function WhenSchedule_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  margin-bottom: ",
        ";\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1;\n  text-transform: uppercase;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  span {\n    color: ",
        ";\n  }\n\n  .separator {\n    color: ",
        ";\n\n    @media (max-width: ",
        ") {\n      display: block;\n      height: 0;\n      overflow: hidden;\n    }\n  }\n"
    ]);
    WhenSchedule_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function WhenSchedule_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  margin-top: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.15;\n  text-align: center;\n  max-width: ",
        ";\n"
    ]);
    WhenSchedule_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var StyledWhenSchedule = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d60f4fa7-0"
})(WhenSchedule_styled_templateObject(), (0,theme/* spacing */.W0)("xl4"));
var StyledWhenScheduleSwitcher = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d60f4fa7-1"
})(WhenSchedule_styled_templateObject1(), (0,theme/* color */.$_)("white"), (0,theme/* screen */.sp)("mdMax"), (0,theme/* container */.nC)("xs2"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("md"), (0,theme/* radius */.q0)("full"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("md"));
var StyledWhenScheduleContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d60f4fa7-2"
})(WhenSchedule_styled_templateObject2());
var StyledWhenScheduleTitle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    componentId: "sc-d60f4fa7-3"
})(WhenSchedule_styled_templateObject3(), (0,theme/* color */.$_)("text_subtle"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* fontSize */.JB)("md"), (0,theme/* spacing */.W0)("xs"));
var StyledWhenScheduleHours = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-d60f4fa7-4"
})(WhenSchedule_styled_templateObject4(), (0,theme/* spacing */.W0)("lg"), (0,theme/* fontFamily */.I8)("display"), (0,theme/* fontWeight */.Ue)("light"), (0,theme/* fontSize */.JB)("xl4"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("xl6"), (0,theme/* color */.$_)("text_placeholder"), (0,theme/* color */.$_)("emerald_700"), (0,theme/* screen */.sp)("mdMax"));
var StyledWhenScheduleExtra = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d60f4fa7-5"
})(WhenSchedule_styled_templateObject5(), (0,theme/* spacing */.W0)("xl"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* container */.nC)("xs"));

;// CONCATENATED MODULE: ./components/jobOffer/when/WhenSchedule.tsx








var WhenSchedule = function(props) {
    var ref, ref1, ref2, ref3;
    var ref4 = (0,react.useState)(0), activeSchedule = ref4[0], setActiveSchedule = ref4[1];
    var ref5, ref6;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWhenSchedule, {
        children: [
            props.schedules && props.schedules.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWhenScheduleSwitcher, {
                children: props.schedules.map(function(schedule, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioButton/* default */.Z, {
                        name: "scheduleSwitcher",
                        id: "scheduleSwitcher" + i,
                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: schedule.name
                            })
                        }),
                        checked: i === activeSchedule,
                        onClick: function() {
                            return setActiveSchedule(i);
                        }
                    }, i);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWhenScheduleContent, {
                children: [
                    props.schedules && ((ref = props.schedules[activeSchedule]) === null || ref === void 0 ? void 0 : ref.bars.map(function(bar, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(when_WhenInfographic, {
                                    ranges: bar.ranges,
                                    title: bar.title,
                                    subtitle: bar.subtitle,
                                    caption: bar.caption,
                                    inOutFlexibleMinutes: bar.inOutFlexibleMinutes
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(when_WhenInfographicMobile, {
                                    ranges: bar.ranges,
                                    title: bar.title,
                                    subtitle: bar.subtitle
                                })
                            ]
                        }, i);
                    })),
                    ((ref1 = props.schedules[activeSchedule]) === null || ref1 === void 0 ? void 0 : ref1.text) && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWhenScheduleExtra, {
                        children: props.migratedToMarkdown ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledJobOfferLongText, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MarkdownComponent["default"], {
                                content: (ref5 = (ref2 = props.schedules[activeSchedule]) === null || ref2 === void 0 ? void 0 : ref2.text) !== null && ref5 !== void 0 ? ref5 : ""
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            dangerouslySetInnerHTML: {
                                __html: (ref6 = (ref3 = props.schedules[activeSchedule]) === null || ref3 === void 0 ? void 0 : ref3.text) !== null && ref6 !== void 0 ? ref6 : ""
                            }
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var when_WhenSchedule = (WhenSchedule);

;// CONCATENATED MODULE: ./components/jobOffer/when/WhenSection.styled.js

function WhenSection_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        ";\n"
    ]);
    WhenSection_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledWhenSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bcfff378-0"
})(WhenSection_styled_templateObject(), (0,theme/* spacing */.W0)("xl3"));

;// CONCATENATED MODULE: ./components/jobOffer/when/WhenWatch.styled.tsx

function WhenWatch_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    WhenWatch_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function WhenWatch_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n  height: ",
        ";\n  margin: auto;\n  margin-bottom: -",
        ";\n  margin-top: ",
        ";\n"
    ]);
    WhenWatch_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function WhenWatch_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n  margin-bottom: ",
        ";\n  text-align: center;\n  font-size: ",
        ";\n"
    ]);
    WhenWatch_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function WhenWatch_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: auto;\n  max-width: ",
        ";\n  border-bottom: 1px solid ",
        ";\n  counter-reset: faqs;\n"
    ]);
    WhenWatch_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var StyledWhenWatch = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-976d7596-0"
})(WhenWatch_styled_templateObject());
var StyledWhenWatchIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-976d7596-1"
})(WhenWatch_styled_templateObject1(), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("xl"));
var StyledWhenWatchIntro = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-976d7596-2"
})(WhenWatch_styled_templateObject2(), (0,theme/* container */.nC)("sm"), (0,theme/* spacing */.W0)("md"), (0,theme/* fontSize */.JB)("sm"));
var StyledWhenWatchFaqs = styled_components_browser_esm/* default.dl.withConfig */.ZP.dl.withConfig({
    componentId: "sc-976d7596-3"
})(WhenWatch_styled_templateObject3(), (0,theme/* container */.nC)("md"), (0,theme/* color */.$_)("midnight_200"));

;// CONCATENATED MODULE: ./components/jobOffer/when/WhenWatchFaqs.tsx






var WhenWatchFaqs = function(param) {
    var watchFaqs = param.watchFaqs, migratedToMarkdown = param.migratedToMarkdown;
    var toggleAccordion = function toggleAccordion() {
        setActiveState(setActive === "" ? "is-active" : "");
        if (content !== null) {
            if (content.current !== null) {
                setHeightState(setActive === "is-active" ? "0px" : "".concat(content.current.scrollHeight, "px"));
            }
        }
    };
    var ref = (0,react.useState)(""), setActive = ref[0], setActiveState = ref[1];
    var ref1 = (0,react.useState)("0px"), setHeight = ref1[0], setHeightState = ref1[1];
    var content = (0,react.useRef)(null);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Faqs_styled/* StyledFaqs */.Av, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Faqs_styled/* StyledFaqsQuestion */.qB, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Faqs_styled/* StyledFaqsButton */.LS, {
                    className: "".concat(setActive),
                    onClick: toggleAccordion,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Faqs_styled/* StyledFaqsTitle */.zP, {
                            children: watchFaqs.q
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Faqs_styled/* StyledFaqsIcon */.Eq, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: free_solid_svg_icons/* faCaretDown */.eW2
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Faqs_styled/* StyledFaqsContent */.EU, {
                ref: content,
                style: {
                    maxHeight: "".concat(setHeight)
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Faqs_styled/* StyledFaqsText */.FG, {
                    children: migratedToMarkdown ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MarkdownComponent["default"], {
                        content: watchFaqs.a || ""
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: watchFaqs.a || ""
                        }
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var when_WhenWatchFaqs = (WhenWatchFaqs);

;// CONCATENATED MODULE: ./components/jobOffer/when/WhenWatch.tsx








var WhenWatch = function(param) {
    var watchIntro = param.watchIntro, watchFaqs = param.watchFaqs, migratedToMarkdown = param.migratedToMarkdown;
    var t = (0,useI18n/* useI18n */.Q)("job-offer").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWhenWatch, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWhenWatchIcon, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: (0,paths/* getPublicPath */.A)("/images/icons/watch-duty.svg"),
                    width: 64,
                    height: 64
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(jobOffer_JobOfferSubsection, {
                title: t("when.watches"),
                children: [
                    watchIntro && /*#__PURE__*/ (0,jsx_runtime.jsx)(jobOffer_JobOfferLongText, {
                        isMarkdown: migratedToMarkdown,
                        children: watchIntro
                    }),
                    watchFaqs && watchFaqs.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWhenWatchFaqs, {
                        children: watchFaqs.map(function(f, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(when_WhenWatchFaqs, {
                                watchFaqs: f,
                                migratedToMarkdown: migratedToMarkdown
                            }, i);
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var when_WhenWatch = (WhenWatch);

;// CONCATENATED MODULE: ./components/jobOffer/when/WhenSection.tsx









var WhenSection = function(param) {
    var whenIntro = param.whenIntro, highlightsIntro = param.highlightsIntro, highlights = param.highlights, schedules = param.schedules, watchIntro = param.watchIntro, watchFaqs = param.watchFaqs, migratedToMarkdown = param.migratedToMarkdown, isFreelance = param.isFreelance;
    var t = (0,useI18n/* useI18n */.Q)("job-offer").t;
    var showHighlights = highlights && highlights.length > 0;
    var showSchedules = schedules && schedules.length > 0;
    var showSection = showHighlights || showSchedules;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jobOffer_JobOfferSection, {
        name: "horario",
        sectionBg: "alt",
        title: t(isFreelance ? "titles.schedule_freelance" : "titles.schedule"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(jobOffer_JobOfferLongText, {
                isMarkdown: migratedToMarkdown,
                children: whenIntro
            }),
            showSection && !isFreelance && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWhenSection, {
                children: [
                    showHighlights && /*#__PURE__*/ (0,jsx_runtime.jsx)(when_WhenHighlights, {
                        migratedToMarkdown: migratedToMarkdown,
                        highlightsIntro: highlightsIntro,
                        highlights: highlights,
                        isFreelance: isFreelance
                    }),
                    showSchedules && /*#__PURE__*/ (0,jsx_runtime.jsx)(jobOffer_JobOfferSubsection, {
                        title: t("when.schedule"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(when_WhenSchedule, {
                            schedules: schedules,
                            migratedToMarkdown: migratedToMarkdown
                        })
                    }),
                    (watchFaqs && watchFaqs.length > 0 || watchIntro) && /*#__PURE__*/ (0,jsx_runtime.jsx)(when_WhenWatch, {
                        watchIntro: watchIntro,
                        watchFaqs: watchFaqs,
                        migratedToMarkdown: migratedToMarkdown,
                        isFreelance: isFreelance
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var when_WhenSection = (WhenSection);

// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var pro_solid_svg_icons = __webpack_require__(54933);
;// CONCATENATED MODULE: ./components/jobOffer/where/WhereOffice.styled.js

function WhereOffice_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: ",
        " ",
        ";\n  background-color: ",
        ";\n  border-radius: ",
        ";\n  color: ",
        ";\n  background-image: ",
        ";\n  background-size: 250px 250px;\n  background-repeat: repeat;\n  background-blend-mode: screen;\n  margin-bottom: ",
        ";\n\n  @media (min-width: ",
        ") {\n    margin-bottom: 0;\n  }\n"
    ]);
    WhereOffice_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function WhereOffice_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  height: ",
        ";\n  margin-bottom: ",
        ";\n"
    ]);
    WhereOffice_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function WhereOffice_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  margin: 0;\n"
    ]);
    WhereOffice_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function WhereOffice_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-style: normal;\n  line-height: 1.5;\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n  padding-top: ",
        ";\n  padding-bottom: ",
        ";\n  position: relative;\n\n  &::before,\n  &::after {\n    content: '';\n    display: block;\n    height: 1px;\n    width: ",
        ";\n    background-color: ",
        ";\n    position: absolute;\n    left: 50%;\n    transform: translateX(-50%);\n  }\n\n  &::before {\n    top: 0;\n  }\n\n  &::after {\n    bottom: 0;\n  }\n"
    ]);
    WhereOffice_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function WhereOffice_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: ",
        ";\n  display: inline-flex;\n  align-items: center;\n\n  &:hover {\n    color: ",
        ";\n  }\n  &:focus,\n  &:active {\n    color: ",
        ";\n  }\n\n  svg {\n    height: ",
        ";\n    margin-right: ",
        ";\n\n    .fa-secondary {\n      opacity: 1;\n    }\n    .fa-primary {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    WhereOffice_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var StyledWhereOffice = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5a8cab3f-0"
})(WhereOffice_styled_templateObject(), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("lg"), (0,theme/* color */.$_)("midnight_900"), (0,theme/* radius */.q0)("lg"), (0,theme/* color */.$_)("text_default_inverse"), function() {
    return(// eslint-disable-next-line no-undef
    "url('".concat((0,paths/* getPublicPath */.A)("/images/jobOffer/officeBg.png"), "')"));
}, (0,theme/* spacing */.W0)("xl"), (0,theme/* screen */.sp)("md"));
var StyledWhereOfficeLogo = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-5a8cab3f-1"
})(WhereOffice_styled_templateObject1(), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("sm"));
var StyledWhereOfficeTitle = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-5a8cab3f-2"
})(WhereOffice_styled_templateObject2(), (0,theme/* fontFamily */.I8)("serif"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* fontWeight */.Ue)("bold"));
var StyledWhereOfficeAddress = styled_components_browser_esm/* default.address.withConfig */.ZP.address.withConfig({
    componentId: "sc-5a8cab3f-3"
})(WhereOffice_styled_templateObject3(), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* color */.$_)("midnight_700"));
var StyledWhereOfficeLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-5a8cab3f-4"
})(WhereOffice_styled_templateObject4(), (0,theme/* color */.$_)("link_inverse"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* color */.$_)("link_inverse_hover"), (0,theme/* color */.$_)("link_inverse_active"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xs"), (0,theme/* color */.$_)("navy_500"));

;// CONCATENATED MODULE: ./components/jobOffer/where/WhereOffice.tsx







var WhereOffice = function(param) {
    var companyLogo = param.companyLogo, companyAddress = param.companyAddress, googleMaps = param.googleMaps, migratedToMarkdown = param.migratedToMarkdown;
    var t = (0,useI18n/* useI18n */.Q)("job-offer").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWhereOffice, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWhereOfficeLogo, {
                src: companyLogo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWhereOfficeTitle, {
                children: t("where.officeLocated")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWhereOfficeAddress, {
                children: migratedToMarkdown ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledJobOfferLongText, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MarkdownComponent["default"], {
                        content: companyAddress || ""
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    dangerouslySetInnerHTML: {
                        __html: companyAddress || ""
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWhereOfficeLink, {
                href: googleMaps,
                target: "_blank",
                rel: "noreferrer noopener",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                        icon: pro_solid_svg_icons/* faMapMarkerAlt */.FGq
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        dangerouslySetInnerHTML: {
                            __html: t("where.googleMaps") || ""
                        }
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var where_WhereOffice = (WhereOffice);

;// CONCATENATED MODULE: ./components/jobOffer/where/WherePerks.styled.js

function WherePerks_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n"
    ]);
    WherePerks_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function WherePerks_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  max-width: 14rem;\n  margin: ",
        " ",
        ";\n  color: ",
        ";\n  font-weight: ",
        ";\n"
    ]);
    WherePerks_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function WherePerks_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  width: ",
        ";\n  height: ",
        ";\n  margin-bottom: ",
        ";\n"
    ]);
    WherePerks_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function WherePerks_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  line-height: 1;\n  font-weight: ",
        ";\n  text-transform: uppercase;\n  margin-top: 0;\n  margin-bottom: ",
        ";\n  color: ",
        ";\n"
    ]);
    WherePerks_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var StyledWherePerks = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4bb7e3c7-0"
})(WherePerks_styled_templateObject());
var StyledWherePerksItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4bb7e3c7-1"
})(WherePerks_styled_templateObject1(), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("md"), (0,theme/* color */.$_)("text_subtle"), (0,theme/* fontWeight */.Ue)("medium"));
var StyledWherePerksItemIcon = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-4bb7e3c7-2"
})(WherePerks_styled_templateObject2(), (0,theme/* spacing */.W0)("xl3"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* spacing */.W0)("xs"));
var StyledWherePerksItemTitle = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-4bb7e3c7-3"
})(WherePerks_styled_templateObject3(), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* color */.$_)("text_default"));

;// CONCATENATED MODULE: ./components/jobOffer/where/WherePerks.tsx




var WherePerks = function(param) {
    var officePerks = param.officePerks;
    var t = (0,useI18n/* useI18n */.Q)("job-offer").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jobOffer_JobOfferSubsection, {
        title: t("where.interesting"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWherePerks, {
            children: officePerks.map(function(perk, i) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWherePerksItem, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWherePerksItemIcon, {
                            src: perk.type.icon
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWherePerksItemTitle, {
                            children: perk.type.text
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: perk.text
                        })
                    ]
                }, i);
            })
        })
    });
};
/* harmony default export */ var where_WherePerks = (WherePerks);

;// CONCATENATED MODULE: ./components/jobOffer/where/WhereSection.styled.js

function WhereSection_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n  text-align: center;\n"
    ]);
    WhereSection_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function WhereSection_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.6;\n  margin: auto;\n  \n  ul,\n  ol,\n  p {\n    margin-top: ",
        ";\n    margin-bottom: 0;\n    \n    &:first-child {\n      margin-top: 0;\n    }\n  }\n"
    ]);
    WhereSection_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function WhereSection_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-template-columns: 1fr minmax(0, 1fr);\n  column-gap: ",
        ";\n  margin-top: ",
        ";\n  padding-top: ",
        ";\n  position: relative;\n\n  @media (min-width: ",
        ") {\n    display: grid;\n  }\n\n  &::before {\n    content: '';\n    display: block;\n    height: 1px;\n    width: ",
        ";\n    background-color: ",
        ";\n    position: absolute;\n    top: 0;\n    left: 50%;\n    transform: translateX(-50%);\n  }\n"
    ]);
    WhereSection_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var StyledWhereSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4b71aad8-0"
})(WhereSection_styled_templateObject(), (0,theme/* container */.nC)("lg"));
var StyledWhereInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4b71aad8-1"
})(WhereSection_styled_templateObject1(), (0,theme/* container */.nC)("md"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* spacing */.W0)("lg"));
var StyledWhereContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4b71aad8-2"
})(WhereSection_styled_templateObject2(), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* color */.$_)("midnight_200"));

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(90581);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(27805);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_inherits.mjs
var _inherits = __webpack_require__(21218);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_create_super.mjs + 3 modules
var _create_super = __webpack_require__(88673);
;// CONCATENATED MODULE: ./components/jobOffer/where/WhereSpaces.styled.js

function WhereSpaces_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-bottom: ",
        ";\n  background-color: ",
        ";\n  border-radius: ",
        ";\n  color: ",
        ";\n\n  .slick-slider {\n    padding-bottom: 0;\n  }\n\n  .slick-dots {\n    bottom: -",
        ";\n\n    li button {\n      background-color: ",
        ";\n      border-color: ",
        ";\n\n      &:hover {\n        border-color: ",
        ";\n      }\n    }\n\n    li.slick-active button {\n      border-color: ",
        ";\n      background-color: ",
        ";\n    }\n  }\n"
    ]);
    WhereSpaces_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function WhereSpaces_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-top-left-radius: ",
        ";\n  border-top-right-radius: ",
        ";\n  overflow: hidden;\n  margin: 0;\n  margin-top: -1px;\n"
    ]);
    WhereSpaces_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function WhereSpaces_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  border-top-left-radius: ",
        ";\n  border-top-right-radius: ",
        ";\n  height: 21rem;\n  width: 100%;\n  object-fit: cover;\n  margin-top: -0.5px;\n"
    ]);
    WhereSpaces_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function WhereSpaces_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.14;\n  padding: ",
        ";\n  display: flex;\n  text-align: left;\n\n  svg {\n    width: ",
        ";\n    height: ",
        ";\n    margin-right: ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    WhereSpaces_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var StyledWhereSpaces = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-509ae2e1-0"
})(WhereSpaces_styled_templateObject(), (0,theme/* spacing */.W0)("xl4"), (0,theme/* color */.$_)("midnight_900"), (0,theme/* radius */.q0)("lg"), (0,theme/* color */.$_)("text_default_inverse"), (0,theme/* spacing */.W0)("xl"), (0,theme/* color */.$_)("black"), (0,theme/* color */.$_)("midnight_700"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* color */.$_)("active"), (0,theme/* color */.$_)("active"));
var StyledWhereSpacesSlide = styled_components_browser_esm/* default.figure.withConfig */.ZP.figure.withConfig({
    componentId: "sc-509ae2e1-1"
})(WhereSpaces_styled_templateObject1(), (0,theme/* radius */.q0)("lg"), (0,theme/* radius */.q0)("lg"));
var StyledWhereSpacesSlideImg = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-509ae2e1-2"
})(WhereSpaces_styled_templateObject2(), (0,theme/* radius */.q0)("lg"), (0,theme/* radius */.q0)("lg"));
var StyledWhereSpacesSlideCaption = styled_components_browser_esm/* default.figcaption.withConfig */.ZP.figcaption.withConfig({
    componentId: "sc-509ae2e1-3"
})(WhereSpaces_styled_templateObject3(), (0,theme/* color */.$_)("midnight_850"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xs"), (0,theme/* color */.$_)("emerald_600"));

;// CONCATENATED MODULE: ./components/jobOffer/where/WhereSpaces.js












var WhereSpaces = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(WhereSpaces, Component);
    var _super = (0,_create_super/* default */.Z)(WhereSpaces);
    function WhereSpaces() {
        (0,_class_call_check/* default */.Z)(this, WhereSpaces);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(WhereSpaces, [
        {
            key: "render",
            value: function render() {
                var settings = {
                    dots: true,
                    arrows: false,
                    speed: 300,
                    slidesToShow: 1,
                    slidesToScroll: 1
                };
                var spacesSlides = this.props.spacesSlides;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWhereSpaces, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, settings), {
                        children: spacesSlides.map(function(s, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWhereSpacesSlide, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWhereSpacesSlideImg, {
                                        src: s.img,
                                        alt: ""
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWhereSpacesSlideCaption, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                icon: free_solid_svg_icons/* faInfoCircle */.sqG
                                            }),
                                            s.caption
                                        ]
                                    })
                                ]
                            }, i);
                        })
                    }))
                });
            }
        }
    ]);
    return WhereSpaces;
}(react.Component);
/* harmony default export */ var where_WhereSpaces = (WhereSpaces);

;// CONCATENATED MODULE: ./components/jobOffer/where/WhereSummary.styled.tsx

function WhereSummary_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-flex;\n  flex-wrap: wrap;\n  flex-direction: row;\n  justify-content: center;\n  min-width: ",
        ";\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n  border-top: 1px solid ",
        ";\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    WhereSummary_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function WhereSummary_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  padding-top: ",
        ";\n  padding-bottom: ",
        ";\n"
    ]);
    WhereSummary_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function WhereSummary_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  text-transform: uppercase;\n  line-height: 1;\n  color: ",
        ";\n  margin-top: 0;\n  margin-bottom: ",
        ";\n"
    ]);
    WhereSummary_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function WhereSummary_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  text-transform: uppercase;\n  line-height: 1;\n"
    ]);
    WhereSummary_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function WhereSummary_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-grow: 0;\n  font-family: ",
        ";\n  font-style: italic;\n  font-size: ",
        ";\n  color: ",
        ";\n  line-height: 1;\n  margin: 0 ",
        ";\n  padding-bottom: ",
        ";\n  align-self: flex-end;\n\n  @media (min-width: ",
        ") {\n    margin: 0 ",
        ";\n  }\n"
    ]);
    WhereSummary_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function WhereSummary_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n"
    ]);
    WhereSummary_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var StyledWhereSummary = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-642d15b2-0"
})(WhereSummary_styled_templateObject(), (0,theme/* container */.nC)("xs2"), (0,theme/* spacing */.W0)("sm"), (0,theme/* spacing */.W0)("lg"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* color */.$_)("midnight_200"));
var StyledWhereSummaryItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-642d15b2-1"
})(WhereSummary_styled_templateObject1(), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"));
var StyledWhereSummaryItemTitle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    componentId: "sc-642d15b2-2"
})(WhereSummary_styled_templateObject2(), (0,theme/* fontSize */.JB)("sm"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* color */.$_)("text_subtle"), (0,theme/* spacing */.W0)("xs2"));
var StyledWhereSummaryValue = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-642d15b2-3"
})(WhereSummary_styled_templateObject3(), (0,theme/* fontFamily */.I8)("display"), (0,theme/* fontSize */.JB)("xl4"), (0,theme/* fontWeight */.Ue)("light"));
var StyledWhereSummarySeparator = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-642d15b2-4"
})(WhereSummary_styled_templateObject4(), (0,theme/* fontFamily */.I8)("serif"), (0,theme/* fontSize */.JB)("xl2"), (0,theme/* color */.$_)("text_subtle"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl"));
var StyledSummaryRemoteWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-642d15b2-5"
})(WhereSummary_styled_templateObject5());

;// CONCATENATED MODULE: ./components/jobOffer/where/WhereSummary.tsx




var WhereSummary = function(param) {
    var jobLocationsSummary = param.jobLocationsSummary, jobRemote = param.jobRemote;
    var t = (0,useI18n/* useI18n */.Q)("job-offer").t;
    var hasLocations = jobLocationsSummary.trimmedCount > 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWhereSummary, {
        children: jobRemote === 100 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWhereSummaryItem, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWhereSummaryItemTitle, {
                            children: t("where.remote")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWhereSummaryValue, {
                            children: [
                                jobRemote,
                                "%"
                            ]
                        })
                    ]
                }),
                hasLocations && jobRemote < 100 && jobRemote > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWhereSummarySeparator, {
                    children: t("hero.and")
                }),
                hasLocations && jobRemote === 100 && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWhereSummarySeparator, {
                    children: t("hero.or")
                }),
                hasLocations && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWhereSummaryItem, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWhereSummaryItemTitle, {
                            children: t("where.presential")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWhereSummaryValue, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TrimmedOfferLocations/* TrimmedOfferLocations */.J, {
                                locationsSummary: jobLocationsSummary
                            })
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                hasLocations && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWhereSummaryItem, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWhereSummaryItemTitle, {
                            children: t("where.presential")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWhereSummaryValue, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TrimmedOfferLocations/* TrimmedOfferLocations */.J, {
                                locationsSummary: jobLocationsSummary
                            })
                        })
                    ]
                }),
                hasLocations && jobRemote < 100 && jobRemote > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWhereSummarySeparator, {
                    children: t("hero.and")
                }),
                hasLocations && jobRemote === 100 && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWhereSummarySeparator, {
                    children: t("hero.or")
                }),
                jobRemote !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWhereSummaryItem, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWhereSummaryItemTitle, {
                            children: t("where.remotework")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWhereSummaryValue, {
                            children: [
                                jobRemote,
                                "%"
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var where_WhereSummary = (WhereSummary);

;// CONCATENATED MODULE: ./components/jobOffer/where/WhereSection.tsx











var WhereSection = function(param) {
    var jobLocationsSummary = param.jobLocationsSummary, jobRemote = param.jobRemote, jobInfo = param.jobInfo, companyLogo = param.companyLogo, companyAddress = param.companyAddress, googleMaps = param.googleMaps, spacesSlides = param.spacesSlides, officePerks = param.officePerks, migratedToMarkdown = param.migratedToMarkdown, isFreelance = param.isFreelance;
    var t = (0,useI18n/* useI18n */.Q)("job-offer").t;
    var showWIPFeatures = (0,react.useContext)(wip_features_context/* default */.Z);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jobOffer_JobOfferSection, {
        name: "donde",
        title: t(isFreelance ? "titles.where_freelance" : "titles.where"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWhereSection, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(where_WhereSummary, {
                    jobLocationsSummary: jobLocationsSummary,
                    jobRemote: jobRemote
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(jobOffer_JobOfferLongText, {
                    isMarkdown: migratedToMarkdown,
                    children: jobInfo
                }),
                showWIPFeatures && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWhereContent, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(where_WhereOffice, {
                                    migratedToMarkdown: migratedToMarkdown,
                                    companyLogo: companyLogo,
                                    companyAddress: companyAddress,
                                    googleMaps: googleMaps
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(where_WhereSpaces, {
                                    spacesSlides: spacesSlides
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(where_WherePerks, {
                            officePerks: officePerks
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var where_WhereSection = (WhereSection);

// EXTERNAL MODULE: ./components/layout/Page.tsx + 13 modules
var Page = __webpack_require__(9092);
// EXTERNAL MODULE: ./context/manfredite-fields-status/index.ts
var manfredite_fields_status = __webpack_require__(11138);
// EXTERNAL MODULE: ./context/offer-apply-modal/offerapplymodal.context.tsx + 11 modules
var offerapplymodal_context = __webpack_require__(74353);
// EXTERNAL MODULE: ../../node_modules/next-i18next/dist/esm/index.js + 8 modules
var esm = __webpack_require__(7621);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./services/offer-application.service.ts
var offer_application_service = __webpack_require__(51859);
// EXTERNAL MODULE: ./services/ui/offer-og.service.ts
var offer_og_service = __webpack_require__(35779);
// EXTERNAL MODULE: ./services/ui/offer.service.ts
var offer_service = __webpack_require__(58630);
;// CONCATENATED MODULE: ./components/jobOffer/requirements/RequirementsEvolution.styled.js

function RequirementsEvolution_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        ";\n\n  @media (min-width: ",
        ") {\n    display: flex;\n    align-items: flex-start;\n  }\n"
    ]);
    RequirementsEvolution_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function RequirementsEvolution_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  margin-bottom: ",
        ";\n\n  &::before {\n    content: '';\n    position: absolute;\n    top: calc(",
        " * -1);\n    width: ",
        ";\n    height: ",
        ";\n    background-color: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    display: none;\n  }\n"
    ]);
    RequirementsEvolution_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function RequirementsEvolution_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n\n  @media (min-width: ",
        ") {\n    margin-right: ",
        ";\n    max-width: 610px;\n    width: 100%;\n  }\n\n  @media (max-width: ",
        ") {\n    svg {\n      display: none;\n    }\n  }\n"
    ]);
    RequirementsEvolution_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function RequirementsEvolution_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n\n  @media (max-width: ",
        ") {\n    padding-left: ",
        ";\n    padding-right: ",
        ";\n    position: relative;\n\n    &::before {\n      content: '';\n      position: absolute;\n      left: calc(",
        " + ",
        " / 2);\n      right: calc(",
        " + ",
        " / 2);\n      height: ",
        ";\n      background-color: ",
        ";\n      clip-path: polygon(0 50%, 100% 0, 100% 100%);\n    }\n\n    &[data-milestone='2']::before {\n      background-image: linear-gradient(\n        to right,\n        ",
        ",\n        ",
        " 25%,\n        transparent 50%\n      );\n    }\n\n    &[data-milestone='3']::before {\n      background-image: linear-gradient(\n        to right,\n        ",
        ",\n        ",
        " 50%,\n        transparent\n      );\n    }\n  }\n\n  @media (min-width: ",
        ") {\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n  }\n"
    ]);
    RequirementsEvolution_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function RequirementsEvolution_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  position: absolute;\n  max-width: 7rem;\n  max-height: 7rem;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n\n  @media (max-width: ",
        ") {\n    display: none;\n  }\n\n  @media (min-width: ",
        ") {\n    max-width: 9rem;\n    max-height: 9rem;\n  }\n"
    ]);
    RequirementsEvolution_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function RequirementsEvolution_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  width: ",
        ";\n  height: ",
        ";\n  border-radius: ",
        ";\n  background: radial-gradient(\n    circle at center,\n    ",
        " 0,\n    ",
        " ",
        ",\n    ",
        " ",
        "\n  );\n  border: 0;\n  box-shadow: 0 0 0 3px ",
        ";\n  position: relative;\n\n  @media (max-width: ",
        ") {\n    &.is-active {\n      background: radial-gradient(\n        circle at center,\n        ",
        " 0,\n        ",
        " ",
        ",\n        ",
        " ",
        "\n      );\n      box-shadow: 0 0 0 3px ",
        ";\n\n      &::before {\n        animation: none;\n      }\n\n      &::after {\n        color: ",
        ";\n      }\n    }\n  }\n\n  @media (min-width: ",
        ") {\n    position: absolute;\n  }\n\n  &::after {\n    content: attr(aria-label);\n    width: 5rem;\n    position: absolute;\n    top: 50%;\n    left: 1.25rem;\n    transform: translateY(-50%);\n    font-size: ",
        ";\n    font-weight: ",
        ";\n    color: ",
        ";\n    font-family: ",
        ";\n\n    @media (max-width: ",
        ") {\n      top: unset;\n      bottom: -1.5rem;\n      left: 50%;\n      transform: translateX(-50%);\n    }\n  }\n\n  &::before {\n    content: '';\n    display: block;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: ",
        ";\n    height: ",
        ";\n    margin: -1.5rem auto auto -1.5rem;\n    transform-origin: 50% 50%;\n    border-radius: 50%;\n    border: 1px solid ",
        ";\n    opacity: 0;\n    animation: pulsate 3s ease-out infinite;\n  }\n\n  &:hover {\n    cursor: pointer;\n\n    &::before {\n      animation: none;\n    }\n  }\n\n  &:active,\n  &:focus {\n    outline: 0;\n\n    &::before {\n      animation: stop-pulsate 0.3s;\n    }\n  }\n\n  @keyframes pulsate {\n    0% {\n      transform: scale(1);\n      opacity: 0.8;\n    }\n    45% {\n      transform: scale(1.75);\n      opacity: 0;\n    }\n  }\n\n  @keyframes stop-pulsate {\n    from {\n      opacity: 0.4;\n    }\n    to {\n      transform: scale(2);\n      opacity: 0;\n    }\n  }\n\n  &.is-month-one {\n    @media (min-width: ",
        ") {\n      top: 19%;\n      left: 65%;\n    }\n  }\n\n  &.is-month-three {\n    @media (min-width: ",
        ") {\n      top: 48%;\n      left: 82%;\n    }\n\n    &::after {\n      @media (min-width: ",
        ") {\n        left: 1.5rem;\n      }\n    }\n  }\n\n  &.is-month-six {\n    @media (min-width: ",
        ") {\n      top: 82%;\n      left: 48%;\n    }\n\n    &::after {\n      @media (min-width: ",
        ") {\n        left: 50%;\n        top: 1.75rem;\n        transform: translateX(-50%);\n      }\n    }\n  }\n"
    ]);
    RequirementsEvolution_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function RequirementsEvolution_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 7.5%;\n  left: 50%;\n  transform: translateX(-50%);\n  background: ",
        ";\n  color: ",
        ";\n  border-radius: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.33;\n  font-weight: ",
        ";\n  text-align: center;\n  padding: ",
        ";\n\n  &::before {\n    content: '';\n    position: absolute;\n    bottom: -6px;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 0px;\n    height: 0px;\n    border-left: 6px solid transparent;\n    border-right: 6px solid transparent;\n    border-top: 6px solid ",
        ";\n  }\n\n  @media (max-width: ",
        ") {\n    display: none;\n  }\n"
    ]);
    RequirementsEvolution_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function RequirementsEvolution_styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: ",
        ";\n\n  @media (min-width: ",
        ") {\n    max-width: 15rem;\n  }\n\n  @media (min-width: ",
        ") {\n    padding-top: 15%;\n    max-width: 20rem;\n  }\n"
    ]);
    RequirementsEvolution_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function RequirementsEvolution_styled_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media (min-width: ",
        ") {\n    max-height: 30em;\n    overflow: auto;\n  }\n  ",
        " {\n    margin-bottom: ",
        ";\n\n    @media (max-width: ",
        ") {\n      display: none;\n    }\n  }\n\n  ul {\n    margin-left: ",
        ";\n  }\n\n  ul li {\n    list-style-type: disc;\n  }\n"
    ]);
    RequirementsEvolution_styled_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function RequirementsEvolution_styled_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin-bottom: ",
        ";\n\n  @media (max-width: ",
        ") {\n    display: none;\n  }\n\n  button {\n    width: ",
        ";\n    height: ",
        ";\n    background: transparent;\n    border: 0;\n    padding: 0;\n    color: ",
        ";\n    margin-right: ",
        ";\n    cursor: pointer;\n    transition: 0.3s;\n\n    &:hover {\n      color: ",
        ";\n    }\n\n    &[disabled] {\n      color: ",
        ";\n      pointer-events: none;\n    }\n\n    svg {\n      width: ",
        " !important;\n      height: ",
        ";\n    }\n  }\n"
    ]);
    RequirementsEvolution_styled_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}



var StyledRequirementsEvolution = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ad1ed341-0"
})(RequirementsEvolution_styled_templateObject(), (0,theme/* spacing */.W0)("xl3"), (0,theme/* screen */.sp)("md"));
var StyledRequirementsEvolutionTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography/* Heading3 */.aC).withConfig({
    componentId: "sc-ad1ed341-1"
})(RequirementsEvolution_styled_templateObject1(), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("sm"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* color */.$_)("mint_900"), (0,theme/* screen */.sp)("md"));
var StyledRequirementsEvolutionContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ad1ed341-2"
})(RequirementsEvolution_styled_templateObject2(), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl"), (0,theme/* screen */.sp)("mdMax"));
var StyledRequirementsEvolutionContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ad1ed341-3"
})(RequirementsEvolution_styled_templateObject3(), (0,theme/* screen */.sp)("mdMax"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("lg"), (0,theme/* color */.$_)("sand_150"), (0,theme/* color */.$_)("text_active"), (0,theme/* color */.$_)("text_active"), (0,theme/* color */.$_)("text_active"), (0,theme/* color */.$_)("text_active"), (0,theme/* screen */.sp)("md"));
var StyledRequirementsEvolutionClient = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-ad1ed341-4"
})(RequirementsEvolution_styled_templateObject4(), (0,theme/* screen */.sp)("mdMax"), (0,theme/* screen */.sp)("lg"));
var StyledRequirementsEvolutionTrigger = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-ad1ed341-5"
})(RequirementsEvolution_styled_templateObject5(), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("lg"), (0,theme/* radius */.q0)("full"), (0,theme/* color */.$_)("sand_500"), (0,theme/* color */.$_)("sand_500"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* color */.$_)("white"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* color */.$_)("sand_150"), (0,theme/* screen */.sp)("mdMax"), (0,theme/* color */.$_)("active"), (0,theme/* color */.$_)("active"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* color */.$_)("white"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* color */.$_)("emerald_150"), (0,theme/* color */.$_)("text_active"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontWeight */.Ue)("extraBold"), (0,theme/* color */.$_)("text_default"), (0,theme/* fontFamily */.I8)("sans"), (0,theme/* screen */.sp)("mdMax"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* color */.$_)("sand_500"), (0,theme/* screen */.sp)("md"), (0,theme/* screen */.sp)("md"), (0,theme/* screen */.sp)("md"), (0,theme/* screen */.sp)("md"), (0,theme/* screen */.sp)("md"));
var StyledRequirementsEvolutionDay0 = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ad1ed341-6"
})(RequirementsEvolution_styled_templateObject6(), (0,theme/* color */.$_)("midnight_800"), (0,theme/* color */.$_)("text_default_inverse"), (0,theme/* radius */.q0)("sm"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* spacing */.W0)("sm"), (0,theme/* color */.$_)("midnight_800"), (0,theme/* screen */.sp)("mdMax"));
var StyledRequirementsMilestonesContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ad1ed341-7"
})(RequirementsEvolution_styled_templateObject7(), (0,theme/* spacing */.W0)("xl"), (0,theme/* screen */.sp)("md"), (0,theme/* screen */.sp)("lg"));
var StyledRequirementsMilestone = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ad1ed341-8"
})(RequirementsEvolution_styled_templateObject8(), (0,theme/* screen */.sp)("md"), Typography/* Heading4 */.k8, (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("mdMax"), (0,theme/* spacing */.W0)("lg"));
var StyledRequirementsMilestonesArrows = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ad1ed341-9"
})(RequirementsEvolution_styled_templateObject9(), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("mdMax"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl"), (0,theme/* color */.$_)("midnight_800"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* color */.$_)("midnight_600"), (0,theme/* color */.$_)("midnight_150"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl"));

;// CONCATENATED MODULE: ./components/jobOffer/requirements/RequirementsEvolutionGraphic.styled.tsx

function RequirementsEvolutionGraphic_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  --evolution-fill-default: ",
        ";\n  display: block;\n  max-width: 100%;\n  height: auto;\n\n  &[data-milestone='1'] {\n    .month1 {\n      fill: var(--client-primary, var(--evolution-fill-default));\n      opacity: 0.25;\n    }\n    .month3 {\n      stroke: transparent;\n    }\n    .month6 {\n      stroke: transparent;\n    }\n  }\n  &[data-milestone='2'] {\n    .month1 {\n      fill: var(--client-primary, var(--evolution-fill-default));\n      opacity: 0.25;\n    }\n    .month3 {\n      fill: var(--client-primary, var(--evolution-fill-default));\n      opacity: 0.5;\n    }\n    .month6 {\n      stroke: transparent;\n    }\n  }\n\n  &[data-milestone='3'] {\n    .month1 {\n      fill: var(--client-primary, var(--evolution-fill-default));\n      opacity: 0.25;\n    }\n    .month3 {\n      fill: var(--client-primary, var(--evolution-fill-default));\n      opacity: 0.5;\n    }\n    .month6 {\n      fill: var(--client-primary, var(--evolution-fill-default));\n    }\n  }\n"
    ]);
    RequirementsEvolutionGraphic_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledRequirementsEvolutionGraphic = styled_components_browser_esm/* default.svg.withConfig */.ZP.svg.withConfig({
    componentId: "sc-2162f4d-0"
})(RequirementsEvolutionGraphic_styled_templateObject(), (0,theme/* color */.$_)("mint_900"));

;// CONCATENATED MODULE: ./components/jobOffer/requirements/RequirementsEvolutionGraphic.tsx


var RequirementsEvolutionGraphic = function(param) {
    var dataMilestone = param.dataMilestone;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledRequirementsEvolutionGraphic, {
        width: "610",
        height: "610",
        viewBox: "0 0 610 610",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-milestone": dataMilestone,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "305",
                cy: "305",
                r: "304",
                fill: "url(#paint0_radial)",
                stroke: "#EBE8DF",
                strokeLinecap: "round",
                strokeDasharray: "24 24"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "305",
                cy: "305",
                r: "208",
                fill: "white",
                fillOpacity: "0.25",
                stroke: "#EBE8DF",
                strokeWidth: "2",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "305",
                cy: "305",
                r: "144",
                fill: "url(#paint1_radial)",
                stroke: "#EBE8DF",
                strokeWidth: "3",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M305 97C341.477 97 377.312 106.593 408.911 124.815L376.937 180.258C355.062 167.643 330.253 161.002 305 161.002L305 97Z",
                fill: "transparent",
                stroke: "#DED9CC",
                strokeWidth: "2",
                strokeLinecap: "round",
                className: "month1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M408.876 124.795C440.531 143.042 466.821 169.306 485.1 200.942C503.379 232.579 513.002 268.472 513 305.01L448.998 305.007C449 279.712 442.338 254.863 429.683 232.961C417.029 211.059 398.828 192.877 376.914 180.244L408.876 124.795Z",
                fill: "transparent",
                stroke: "#DED9CC",
                strokeWidth: "2",
                strokeLinecap: "round",
                className: "month3"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M513 305C513 332.315 507.62 359.362 497.167 384.598C486.714 409.834 471.393 432.764 452.078 452.078C432.764 471.393 409.834 486.714 384.598 497.167C359.362 507.62 332.315 513 305 513L305 449.006C323.911 449.006 342.637 445.281 360.109 438.044C377.58 430.807 393.455 420.199 406.827 406.827C420.199 393.455 430.807 377.58 438.044 360.109C445.281 342.637 449.006 323.911 449.006 305H513Z",
                fill: "transparent",
                stroke: "#DED9CC",
                strokeWidth: "2",
                strokeLinecap: "round",
                className: "month6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M305 449C384.529 449 449 384.529 449 305C449 225.471 384.529 161 305 161",
                stroke: "#353241",
                strokeWidth: "4",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                filter: "url(#filter0_dd)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: "305",
                        cy: "305",
                        r: "100",
                        fill: "url(#paint2_angular)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: "305",
                        cy: "305",
                        r: "100",
                        stroke: "#EBE8DF",
                        strokeWidth: "4"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M293 449L305 442.072L305 455.928L293 449Z",
                fill: "#353241"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "510",
                cy: "191",
                r: "3",
                fill: "#DED9CC",
                stroke: "white",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "69",
                cy: "161",
                r: "5.5",
                fill: "#EBE8DF",
                stroke: "white",
                strokeWidth: "3"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "115",
                cy: "441",
                r: "5.5",
                fill: "#EBE8DF",
                stroke: "white",
                strokeWidth: "3"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "233",
                cy: "403",
                r: "7.5",
                fill: "#C4B9A7",
                stroke: "white",
                strokeWidth: "3"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "509",
                cy: "117",
                r: "5.5",
                fill: "#EBE8DF",
                stroke: "white",
                strokeWidth: "3"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "55",
                cy: "216",
                r: "3",
                fill: "#AA9987",
                stroke: "white",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "123",
                cy: "292",
                r: "3",
                fill: "#AA9987",
                stroke: "white",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "113",
                cy: "175",
                r: "3",
                fill: "#DED9CC",
                stroke: "white",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "167",
                cy: "481",
                r: "3",
                fill: "#5A443D",
                stroke: "white",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                        id: "filter0_dd",
                        x: "171",
                        y: "171",
                        width: "268",
                        height: "268",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                stdDeviation: "2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.14902 0 0 0 0 0.101961 0 0 0 0 0.0980392 0 0 0 0.05 0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                stdDeviation: "16"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.14902 0 0 0 0 0.101961 0 0 0 0 0.0980392 0 0 0 0.1 0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in2: "effect1_dropShadow",
                                result: "effect2_dropShadow"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect2_dropShadow",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("radialGradient", {
                        id: "paint0_radial",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(305 305) rotate(90) scale(304)",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.838542",
                                stopColor: "white",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "white",
                                stopOpacity: "0.5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("radialGradient", {
                        id: "paint1_radial",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(305 305) rotate(90) scale(144)",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.244792",
                                stopColor: "#8F7A6A"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "white",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("radialGradient", {
                        id: "paint2_angular",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(305 305) rotate(90) scale(113.5)",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#F8F7F3"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.739583",
                                stopColor: "#C4B9A7"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#5A443D"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var requirements_RequirementsEvolutionGraphic = (RequirementsEvolutionGraphic);

;// CONCATENATED MODULE: ./components/jobOffer/requirements/RequirementsEvolution.tsx









var RequirementsEvolution = function(param) {
    var companyLogo = param.companyLogo, companyName = param.companyName, evolution = param.evolution, migratedToMarkdown = param.migratedToMarkdown;
    var setMilestone = function setMilestone(milestoneNumber) {
        setActiveMilestone(milestoneNumber);
    };
    var nextMilestone = function nextMilestone() {
        if (activeMilestone < 3) {
            setActiveMilestone(activeMilestone + 1);
        }
    };
    var prevMilestone = function prevMilestone() {
        if (activeMilestone !== 1) {
            setActiveMilestone(activeMilestone - 1);
        }
    };
    var t = (0,useI18n/* useI18n */.Q)("job-offer").t;
    var ref = (0,react.useState)(1), activeMilestone = ref[0], setActiveMilestone = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledRequirementsEvolution, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRequirementsEvolutionTitle, {
                children: t("requisites.evolution.yourEvolution")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledRequirementsEvolutionContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(requirements_RequirementsEvolutionGraphic, {
                        dataMilestone: activeMilestone
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledRequirementsEvolutionContent, {
                        "data-milestone": activeMilestone,
                        children: [
                            companyLogo && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRequirementsEvolutionClient, {
                                src: companyLogo,
                                alt: companyName
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRequirementsEvolutionDay0, {
                                children: t("requisites.day0")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRequirementsEvolutionTrigger, {
                                className: "is-month-one ".concat(activeMilestone === 1 ? "is-active" : ""),
                                "aria-label": t("requisites.evolution.1month"),
                                onClick: function() {
                                    return setMilestone(1);
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRequirementsEvolutionTrigger, {
                                className: "is-month-three ".concat(activeMilestone === 2 ? "is-active" : ""),
                                "aria-label": t("requisites.evolution.3months"),
                                onClick: function() {
                                    return setMilestone(2);
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRequirementsEvolutionTrigger, {
                                className: "is-month-six ".concat(activeMilestone === 3 ? "is-active" : ""),
                                "aria-label": t("requisites.evolution.6months"),
                                onClick: function() {
                                    return setMilestone(3);
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledRequirementsMilestonesContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledRequirementsMilestonesArrows, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                type: "button",
                                onClick: function() {
                                    return prevMilestone();
                                },
                                "aria-label": t("requisites.evolution.prev"),
                                id: "requirements-evolution-prev",
                                disabled: activeMilestone === 1,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    "aria-hidden": "true",
                                    icon: pro_light_svg_icons/* faArrowSquareLeft */.jqM
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                type: "button",
                                onClick: function() {
                                    return nextMilestone();
                                },
                                disabled: activeMilestone === 3,
                                id: "requirements-evolution-next",
                                "aria-label": t("requisites.evolution.next"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    "aria-hidden": "true",
                                    icon: pro_light_svg_icons/* faArrowSquareRight */.dbF
                                })
                            })
                        ]
                    }),
                    activeMilestone === 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledRequirementsMilestone, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading4 */.k8, {
                                children: t("requisites.evolution.1month")
                            }),
                            migratedToMarkdown ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MarkdownComponent["default"], {
                                content: evolution.month1 || ""
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                dangerouslySetInnerHTML: {
                                    __html: evolution.month1 || ""
                                }
                            })
                        ]
                    }),
                    activeMilestone === 2 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledRequirementsMilestone, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading4 */.k8, {
                                children: t("requisites.evolution.3months")
                            }),
                            migratedToMarkdown ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MarkdownComponent["default"], {
                                content: evolution.month3 || ""
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                dangerouslySetInnerHTML: {
                                    __html: evolution.month3 || ""
                                }
                            })
                        ]
                    }),
                    activeMilestone === 3 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledRequirementsMilestone, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading4 */.k8, {
                                children: t("requisites.evolution.6months")
                            }),
                            migratedToMarkdown ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MarkdownComponent["default"], {
                                content: evolution.month6 || ""
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                dangerouslySetInnerHTML: {
                                    __html: evolution.month6 || ""
                                }
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var requirements_RequirementsEvolution = (RequirementsEvolution);

;// CONCATENATED MODULE: ./components/jobOffer/requirements/RequirementsResponsabilities.styled.js

function RequirementsResponsabilities_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n\n  margin-left: auto;\n  margin-right: auto;\n"
    ]);
    RequirementsResponsabilities_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function RequirementsResponsabilities_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        ";\n\n  @media (min-width: ",
        ") {\n    margin-top: ",
        ";\n  }\n"
    ]);
    RequirementsResponsabilities_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function RequirementsResponsabilities_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  && {\n    margin-bottom: ",
        ";\n    \n    &::before {\n      left: 0;\n      transform: translateX(0);\n    }\n  }\n"
    ]);
    RequirementsResponsabilities_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function RequirementsResponsabilities_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: ",
        ";\n  display: flex;\n  font-weight: ",
        ";\n  line-height: 1.2;\n\n  p {\n    margin-top: 0;\n  }\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  svg {\n    width: 1.25rem !important;\n    height: 1.25rem;\n    margin-right: ",
        ";\n    color: ",
        ";\n    flex: 0 0 auto;\n\n    @media (min-width: ",
        ") {\n      width: ",
        " !important;\n      height: ",
        ";\n    }\n  }\n"
    ]);
    RequirementsResponsabilities_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var StyledRequirementsResponsabilitiesContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-beb7db7d-0"
})(RequirementsResponsabilities_styled_templateObject(), (0,theme/* container */.nC)("md"));
var StyledRequirementsResponsabilities = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-beb7db7d-1"
})(RequirementsResponsabilities_styled_templateObject1(), (0,theme/* spacing */.W0)("xl"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl3"));
var StyledRequirementsResponsabilitiesTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography/* Heading3 */.aC).withConfig({
    componentId: "sc-beb7db7d-2"
})(RequirementsResponsabilities_styled_templateObject2(), (0,theme/* spacing */.W0)("lg"));
var StyledRequirementsResponsabilitiesItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-beb7db7d-3"
})(RequirementsResponsabilities_styled_templateObject3(), (0,theme/* spacing */.W0)("md"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* spacing */.W0)("sm"), (0,theme/* color */.$_)("midnight_300"), (0,theme/* screen */.sp)("lg"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("lg"));

;// CONCATENATED MODULE: ./components/jobOffer/requirements/RequirementsResponsabilities.tsx






var RequirementsResponsabilities_RequirementsEvolution = function(param) {
    var responsabilities = param.responsabilities, migratedToMarkdown = param.migratedToMarkdown;
    var t = (0,useI18n/* useI18n */.Q)("job-offer").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRequirementsResponsabilitiesContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledRequirementsResponsabilities, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRequirementsResponsabilitiesTitle, {
                    editorial: true,
                    children: t("requisites.responsibilities")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    children: responsabilities.map(function(r) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledRequirementsResponsabilitiesItem, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    icon: pro_light_svg_icons/* faCheckCircle */.f8k
                                }),
                                migratedToMarkdown ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MarkdownComponent["default"], {
                                    content: r.item || ""
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    dangerouslySetInnerHTML: {
                                        __html: r.item || ""
                                    }
                                })
                            ]
                        }, r.id);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var RequirementsResponsabilities = (RequirementsResponsabilities_RequirementsEvolution);

;// CONCATENATED MODULE: ./components/jobOffer/requirements/RequirementsSection.styled.js

function RequirementsSection_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    RequirementsSection_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var StyledRequirementsSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3eeeabaf-0"
})(RequirementsSection_styled_templateObject());

;// CONCATENATED MODULE: ./components/jobOffer/requirements/RequirementsSection.tsx







var RequirementsSection = function(props) {
    var ref;
    var t = (0,useI18n/* useI18n */.Q)("job-offer").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jobOffer_JobOfferSection, {
        name: "requisitos",
        sectionBg: "alt",
        title: t("titles.requisites"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledRequirementsSection, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(jobOffer_JobOfferLongText, {
                    isMarkdown: props.migratedToMarkdown,
                    children: props.requirementsIntro
                }),
                !props.isFreelance && /*#__PURE__*/ (0,jsx_runtime.jsx)(requirements_RequirementsEvolution, {
                    companyLogo: props.companyLogo,
                    companyName: props.companyName,
                    evolution: props.evolution,
                    migratedToMarkdown: props.migratedToMarkdown
                }),
                ((ref = props.responsabilities) === null || ref === void 0 ? void 0 : ref.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(RequirementsResponsabilities, {
                    responsabilities: props.responsabilities,
                    migratedToMarkdown: props.migratedToMarkdown
                })
            ]
        })
    });
};
/* harmony default export */ var requirements_RequirementsSection = (RequirementsSection);

;// CONCATENATED MODULE: ./components/jobOffer/JobOfferComponent.tsx






























var ShareModal = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9011).then(__webpack_require__.bind(__webpack_require__, 9011));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9011)
            ];
        }
    },
    ssr: false
});
var JobOfferComponent = function(param) {
    var offer = param.offer, origin = param.origin;
    var canUserApplyToOffers = function canUserApplyToOffers() {
        return userCanApplyToOffers;
    };
    var openShareModal = function openShareModal() {
        setShareModalIsOpen(true);
    };
    var closeShareModal = function closeShareModal() {
        setShareModalIsOpen(false);
    };
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var t = (0,useI18n/* useI18n */.Q)("job-offer").t;
    var ref7 = (0,react.useContext)(loggeduser_context/* LoggedUserContext */.Vi), user = ref7.user, refreshUserData = ref7.refreshUserData;
    var router = (0,client_router.useRouter)();
    var openOfferAplyModal = (0,react.useContext)(offerapplymodal_context/* OfferApplyModalContext */.u).openOfferAplyModal;
    var userCanApplyToOffers = (0,react.useContext)(manfredite_fields_status/* ManfrediteFieldsStatusContext */.T).userCanApplyToOffers;
    var ref8 = (0,react.useState)(false), shareModalIsOpen = ref8[0], setShareModalIsOpen = ref8[1];
    var onlyAvailableIn = ((ref = offer.languages) === null || ref === void 0 ? void 0 : ref.length) === 1 ? offer.languages[0].code : null;
    var migratedToMarkdown = offer.migratedToMarkdown, footerData = offer.footerData, heroSectionData = offer.heroSectionData, requirementsSectionData = offer.requirementsSectionData, howSectionData = offer.howSectionData, whenSectionData = offer.whenSectionData, whereSectionData = offer.whereSectionData, teamSectionData = offer.teamSectionData, skillsSectionData = offer.skillsSectionData, offerSectionData = offer.offerSectionData, faqsSectionData = offer.faqsSectionData, bottombarData = offer.bottombarData;
    var hasFaqs = ((ref1 = offer.faqsSectionData.faqs) === null || ref1 === void 0 ? void 0 : ref1.length) > 0;
    var offerSections = [
        {
            section: "inicio",
            tooltip: t("titles.home")
        },
        {
            section: "requisitos",
            tooltip: t("titles.requisites")
        },
        {
            section: "como",
            tooltip: t("titles.how")
        },
        {
            section: "horario",
            tooltip: t(offer.isFreelance ? "titles.schedule_freelance" : "titles.schedule")
        },
        {
            section: "donde",
            tooltip: t(offer.isFreelance ? "titles.where_freelance" : "titles.where")
        },
        {
            section: "equipo",
            tooltip: t(offer.isFreelance ? "titles.team_freelance" : "titles.team")
        },
        {
            section: "skills",
            tooltip: t("titles.skills")
        },
        {
            section: "oferta",
            tooltip: t("titles.offer")
        }
    ];
    if (hasFaqs) {
        offerSections.push();
    }
    var handleApplyClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        if (!!canUserApplyToOffers()) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            offer_application_service/* default.storeApplicationAttempt */.Z.storeApplicationAttempt(offer.id)
                        ];
                    case 1:
                        _state.sent();
                        refreshUserData({
                            attempt: {
                                id: offer.id,
                                position: {
                                    ES: offer.heroSectionData.jobTitle || "",
                                    EN: offer.heroSectionData.jobTitle || ""
                                },
                                slug: {
                                    ES: offer.slug,
                                    EN: offer.slug
                                },
                                companyName: offer.heroSectionData.companyName || ""
                            }
                        });
                        router.push((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.portalV2Dashboard */.uu.portalV2Dashboard, router.locale));
                        return [
                            3,
                            3
                        ];
                    case 2:
                        openOfferAplyModal({
                            offerId: offer.id,
                            offer: offer
                        });
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleApplyClick(e) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        var offerURL = window.location.href;
        var urlParams = new URLSearchParams(window.location.search);
        service_event_tracking/* default.track */.Z.track({
            type: "Offers - Offer Viewed",
            properties: {
                offerCompany: bottombarData.companyName,
                offerName: bottombarData.internalCode,
                offerURL: offerURL,
                pageLanguage: router.locale,
                urlParams: urlParams.toString() || undefined,
                utmCampaign: urlParams.get("utm_campaign") || undefined,
                utmContent: urlParams.get("utm_content") || undefined,
                utmId: urlParams.get("utm_id") || undefined,
                utmMedium: urlParams.get("utm_medium") || undefined,
                utmSource: urlParams.get("utm_source") || undefined,
                utmTerm: urlParams.get("utm_term") || undefined
            }
        });
    }, []);
    (0,react.useEffect)(function() {
        var ref, ref1;
        if ((user === null || user === void 0 ? void 0 : (ref = user.offers) === null || ref === void 0 ? void 0 : ref.attempt) && canUserApplyToOffers() && (router === null || router === void 0 ? void 0 : (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.action) === "apply") {
            openOfferAplyModal({
                offerId: user.offers.attempt.offerId,
                offer: offer
            });
        }
    }, [
        user,
        canUserApplyToOffers
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page/* default */.ZP, {
        className: "has-bottombar",
        sections: offerSections,
        offerFooter: /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_OfferFooter, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, footerData), {
            openShareModal: openShareModal,
            handleApplyClick: handleApplyClick,
            userApplied: user === null || user === void 0 ? void 0 : (ref2 = user.offers) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.applications) === null || ref3 === void 0 ? void 0 : ref3.includes(offer.id)
        })),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(hero_HeroSection, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, heroSectionData), {
                onlyAvailableInLang: onlyAvailableIn,
                migratedToMarkdown: migratedToMarkdown
            })),
            (((ref4 = requirementsSectionData.responsabilities) === null || ref4 === void 0 ? void 0 : ref4.length) > 0 || requirementsSectionData.requirementsIntro) && /*#__PURE__*/ (0,jsx_runtime.jsx)(requirements_RequirementsSection, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, requirementsSectionData), {
                migratedToMarkdown: migratedToMarkdown
            })),
            (howSectionData.howIntro || howSectionData.howItems.length > 0) && /*#__PURE__*/ (0,jsx_runtime.jsx)(how_HowSection, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, howSectionData), {
                migratedToMarkdown: migratedToMarkdown
            })),
            whenSectionData.whenIntro && /*#__PURE__*/ (0,jsx_runtime.jsx)(when_WhenSection, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, whenSectionData), {
                migratedToMarkdown: migratedToMarkdown
            })),
            whereSectionData.jobInfo && /*#__PURE__*/ (0,jsx_runtime.jsx)(where_WhereSection, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, whereSectionData), {
                migratedToMarkdown: migratedToMarkdown
            })),
            teamSectionData.teamInfo && /*#__PURE__*/ (0,jsx_runtime.jsx)(team_TeamSection, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, teamSectionData), {
                migratedToMarkdown: migratedToMarkdown
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(skills_SkillsSection, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, skillsSectionData), {
                migratedToMarkdown: migratedToMarkdown
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(offer_OfferSection, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, offerSectionData), {
                migratedToMarkdown: migratedToMarkdown
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(faqs_FaqsSection, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, faqsSectionData), {
                migratedToMarkdown: migratedToMarkdown
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(bottomBar_OfferBottomBar, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, bottombarData), {
                sections: offerSections,
                openShareModal: openShareModal,
                handleApplyClick: handleApplyClick,
                userApplied: user === null || user === void 0 ? void 0 : (ref5 = user.offers) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.applications) === null || ref6 === void 0 ? void 0 : ref6.includes(offer.id),
                migratedToMarkdown: migratedToMarkdown
            })),
            shareModalIsOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareModal, {
                isOpened: shareModalIsOpen,
                close: closeShareModal,
                url: (0,offer_service/* getCanonicalUrl */.Z2)(origin, offer, router.locale),
                emailSubject: (0,offer_og_service/* getOfferOGTitle */.sh)(offer, t, router.locale),
                twitterMessage: t("share.text.twitter"),
                telegramMessage: t("share.text.telegram"),
                whatsappMessage: t("share.text.whatsapp"),
                emailMessage: t("share.text.email")
            })
        ]
    });
};
/* harmony default export */ var jobOffer_JobOfferComponent = ((0,esm/* withTranslation */.Zh)([
    "common",
    "job-offer",
    "apply-modal",
    "topbar",
    "footer"
])(JobOfferComponent));


/***/ }),

/***/ 94125:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ jobOffer_JobOfferPageHead; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./hooks/useI18n/index.ts + 1 modules
var useI18n = __webpack_require__(39105);
// EXTERNAL MODULE: ../../node_modules/next-i18next/dist/esm/index.js + 8 modules
var esm = __webpack_require__(7621);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./services/ui/offer-og.service.ts
var offer_og_service = __webpack_require__(35779);
// EXTERNAL MODULE: ./services/ui/offer.service.ts
var offer_service = __webpack_require__(58630);
// EXTERNAL MODULE: ./utils/config.ts
var config = __webpack_require__(75339);
// EXTERNAL MODULE: ../../node_modules/next/script.js
var script = __webpack_require__(45847);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./components/jobOffer/JobOfferJobPostingSchema.tsx


var JobOfferJobPostingSchema = function(param) {
    var offer = param.offer;
    return(// eslint-disable-next-line @next/next/no-before-interactive-script-outside-document
    /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
        id: "jobPostingSchema",
        strategy: "beforeInteractive",
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
            __html: offer.jsonld
        }
    }));
};
/* harmony default export */ var jobOffer_JobOfferJobPostingSchema = (JobOfferJobPostingSchema);

;// CONCATENATED MODULE: ./components/jobOffer/JobOfferPageHead.tsx








var JobOfferPageHead = function(param) {
    var offer = param.offer, locale = param.locale, origin = param.origin, preview = param.preview, url = param.url;
    var t = (0,useI18n/* useI18n */.Q)("job-offer").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("title", {
                        children: [
                            preview ? "[PREVIEW] " : "",
                            (0,offer_og_service/* getOfferOGTitle */.sh)(offer, t, locale)
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: (0,offer_service/* getCanonicalUrl */.Z2)(origin, offer, locale)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: (0,offer_og_service/* getOfferOGTitle */.sh)(offer, t, locale)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: offer.heroSectionData.companyPhoto
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: (0,offer_service/* getCanonicalUrl */.Z2)(origin, offer, locale)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: (0,offer_og_service/* getOfferOGDescription */.DJ)(offer, t, locale)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:site",
                        content: "@getmanfred"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:creator",
                        content: "@getmanfred"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: (0,offer_og_service/* getOfferOGTitle */.sh)(offer, t, locale)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: (0,offer_og_service/* getOfferOGDescription */.DJ)(offer, t, locale)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:image",
                        content: offer.heroSectionData.companyPhoto
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "robots",
                        content: "index,follow"
                    }),
                    Object.keys(url.langs).map(function(key) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                            rel: "alternate",
                            hrefLang: key,
                            href: "".concat(config/* config.appUrl */.v.appUrl).concat(url.langs[key], "/").concat(offer.id, "/").concat(offer.slug)
                        }, key);
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(jobOffer_JobOfferJobPostingSchema, {
                offer: offer,
                locale: locale
            })
        ]
    });
};
/* harmony default export */ var jobOffer_JobOfferPageHead = ((0,esm/* withTranslation */.Zh)([
    "common",
    "job-offer",
    "topbar",
    "footer"
])(JobOfferPageHead));


/***/ }),

/***/ 33246:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Av": function() { return /* binding */ StyledFaqs; },
/* harmony export */   "EU": function() { return /* binding */ StyledFaqsContent; },
/* harmony export */   "Eq": function() { return /* binding */ StyledFaqsIcon; },
/* harmony export */   "FG": function() { return /* binding */ StyledFaqsText; },
/* harmony export */   "LS": function() { return /* binding */ StyledFaqsButton; },
/* harmony export */   "qB": function() { return /* binding */ StyledFaqsQuestion; },
/* harmony export */   "zP": function() { return /* binding */ StyledFaqsTitle; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40286);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90408);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-top: 1px solid ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 0;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  display: flex;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  &::before {\n    counter-increment: faqs;\n    content: counter(faqs) '.';\n    color: ",
        ";\n    display: block;\n    margin-right: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  -webkit-appearance: none;\n  color: inherit;\n  cursor: pointer;\n  width: 100%;\n  padding-top: ",
        ";\n  padding-bottom: ",
        ";\n  padding-left: ",
        ";\n  display: flex;\n  align-items: center;\n  border: none;\n  background-color: transparent;\n  outline: none;\n  text-align: left;\n\n  &:focus-visible {\n    ",
        ":before {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-left: auto;\n  padding-left: ",
        ";\n\n  svg {\n    width: ",
        " !important;\n    height: ",
        ";\n    transition: transform 0.3s ease-in-out;\n\n    .is-active & {\n      transform: rotate(180deg);\n      transform-origin: center center;\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  overflow: hidden;\n  margin: 0;\n  transition: max-height 0.3s ease-in-out;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding-left: 2.5rem;\n  padding-bottom: ",
        ";\n\n  p {\n    margin: 0;\n    &:not(:first-child) {\n      margin-top: ",
        ";\n    }\n  }\n\n  ul, ol {\n    margin-left: 2rem;\n  }\n\n  li {\n    list-style-type: disc;\n    margin-top: ",
        ";\n  }\n\n  ol li {\n    list-style-type: decimal;\n  }\n\n  img {\n    display: block;\n    margin-top: ",
        ";\n    margin-left: auto;\n    margin-right: auto;\n    \n    &:not(:last-child){\n      margin-bottom: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}


var StyledFaqs = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fd443807-0"
})(_templateObject());
var StyledFaqsQuestion = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].dt.withConfig */ .ZP.dt.withConfig({
    componentId: "sc-fd443807-1"
})(_templateObject1(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_200"));
var StyledFaqsTitle = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
    componentId: "sc-fd443807-2"
})(_templateObject2(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("sans"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("black"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("text_placeholder"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs"));
var StyledFaqsButton = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-fd443807-3"
})(_templateObject3(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("sm"), StyledFaqsTitle, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("active"));
var StyledFaqsIcon = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fd443807-4"
})(_templateObject4(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"));
var StyledFaqsContent = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].dd.withConfig */ .ZP.dd.withConfig({
    componentId: "sc-fd443807-5"
})(_templateObject5());
var StyledFaqsText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fd443807-6"
})(_templateObject6(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"));


/***/ }),

/***/ 6791:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ StyledOfferFooterContainer; },
/* harmony export */   "NN": function() { return /* binding */ StyledOfferFooterScoutName; },
/* harmony export */   "O9": function() { return /* binding */ StyledOfferFooterScoutTitle; },
/* harmony export */   "U9": function() { return /* binding */ StyledOfferFooterScoutLabel; },
/* harmony export */   "V6": function() { return /* binding */ StyledOfferFooterTitle; },
/* harmony export */   "Vj": function() { return /* binding */ StyledOfferFooterText; },
/* harmony export */   "WD": function() { return /* binding */ StyledOfferFooter; },
/* harmony export */   "iP": function() { return /* binding */ StyledOfferFooterScout; },
/* harmony export */   "re": function() { return /* binding */ StyledOfferFooterActions; },
/* harmony export */   "xh": function() { return /* binding */ StyledOfferFooterLogo; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40286);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90408);
/* harmony import */ var _shared_Avatar_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11472);
/* harmony import */ var _shared_Typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99655);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n  padding: ",
        " ",
        ";\n  border-top: 1px solid ",
        ";\n  border-bottom: 1px solid ",
        ";\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  img{ \n    display: block;\n    max-height: 8rem;\n    max-width: 15rem;\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n  margin-bottom: ",
        ";\n  > * {\n    margin-left: ",
        ";\n    margin-right: ",
        ";\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: ",
        ";\n  line-height: 1.25;\n  color: ",
        ";\n  max-width: ",
        ";\n  margin-top: 0;\n  margin-bottom: ",
        ";\n\n  strong {\n    font-weight: ",
        ";\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  text-transform: uppercase;\n  line-height: 1.33;\n  margin-top: 0;\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: left;\n\n  ",
        " {\n    margin-right: ",
        ";\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: block;\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  text-transform: uppercase;\n  line-height: 1.33;\n  color: ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: block;\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  line-height: 1.14;\n  color: ",
        ";\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}




var StyledOfferFooter = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].aside.withConfig */ .ZP.aside.withConfig({
    componentId: "sc-42dd8dc8-0"
})(_templateObject(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl"));
var StyledOfferFooterContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-42dd8dc8-1"
})(_templateObject1(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .container */ .nC)("xl"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_700"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_700"));
var StyledOfferFooterLogo = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-42dd8dc8-2"
})(_templateObject2(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("lg"));
var StyledOfferFooterTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_shared_Typography__WEBPACK_IMPORTED_MODULE_3__/* .Heading4 */ .k8).withConfig({
    componentId: "sc-42dd8dc8-3"
})(_templateObject3(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("lg"));
var StyledOfferFooterActions = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-42dd8dc8-4"
})(_templateObject4(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs"));
var StyledOfferFooterText = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    componentId: "sc-42dd8dc8-5"
})(_templateObject5(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("medium"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("text_subtle_inverse"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .container */ .nC)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("extraBold"));
var StyledOfferFooterScoutTitle = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].h5.withConfig */ .ZP.h5.withConfig({
    componentId: "sc-42dd8dc8-6"
})(_templateObject6(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xs"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("black"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs"));
var StyledOfferFooterScout = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-42dd8dc8-7"
})(_templateObject7(), _shared_Avatar_styled__WEBPACK_IMPORTED_MODULE_2__/* .StyledAvatar */ .b, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs"));
var StyledOfferFooterScoutLabel = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-42dd8dc8-8"
})(_templateObject8(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xs"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("bold"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("text_subtle_inverse"));
var StyledOfferFooterScoutName = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    componentId: "sc-42dd8dc8-9"
})(_templateObject9(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("bold"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("link_inverse"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"));


/***/ }),

/***/ 11472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ StyledAvatar; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40286);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90408);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      width: ",
        ";\n      height: ",
        ";\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  width: 2.5rem;\n  height: 2.5rem;\n  border: 0;\n  border-radius: ",
        ";\n  transition: 0.3s;\n\n  img {\n    display: block;\n    object-fit: cover;\n    border-radius: 50%;\n    height: 100%;\n    width: 100%;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var sizeVariants = {
    sm: {
        width: (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl"),
        height: (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl")
    },
    lg: {
        width: (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl4"),
        height: (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl4")
    }
};
var StyledAvatar = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7188bb60-0"
})(_templateObject1(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .radius */ .q0)("full"), function(param) {
    var sizes = param.sizes;
    return sizes && sizeVariants[sizes] && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), sizeVariants[sizes].width, sizeVariants[sizes].height);
});


/***/ }),

/***/ 6937:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _Avatar_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11472);





var Avatar = function(_param) {
    var avatarImg = _param.avatarImg, avatarAlt = _param.avatarAlt, className = _param.className, sizes = _param.sizes, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "avatarImg",
        "avatarAlt",
        "className",
        "sizes"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: avatarImg && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Avatar_styled__WEBPACK_IMPORTED_MODULE_1__/* .StyledAvatar */ .b, {
            className: className,
            sizes: sizes,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest), {
                width: 40,
                height: 40,
                src: decodeURI(avatarImg),
                alt: avatarAlt
            }))
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Avatar);


/***/ }),

/***/ 55952:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* reexport safe */ _Badge_styled__WEBPACK_IMPORTED_MODULE_0__.C; }
/* harmony export */ });
/* harmony import */ var _Badge_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71487);



/***/ }),

/***/ 670:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ StyledMarkdown; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40286);
/* harmony import */ var theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90408);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ul,\n  ol {\n    padding-left: ",
        " !important;\n\n    li {\n      margin-bottom: ",
        ";\n      margin-top: 0 !important;\n    }\n  }\n\n  ul {\n    li {\n      list-style-type: disc;\n    }\n  }\n\n  ol {\n    li {\n      list-style-type: numeric;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledMarkdown = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-da6035b2-0"
})(_templateObject(), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs"));


/***/ }),

/***/ 57792:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MarkdownComponent": function() { return /* binding */ MarkdownComponent; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84864);
/* harmony import */ var rehype_external_links__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78313);
/* harmony import */ var rehype_raw__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5636);
/* harmony import */ var _MarkdownComponent_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(670);





var ALLOWED_ELEMENTS = [
    "p",
    "strong",
    "ul",
    "ol",
    "li",
    "em",
    "a",
    "br",
    "img",
    "u",
    "blockquote"
];
var MarkdownComponent = function(param) {
    var content = param.content;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_MarkdownComponent_styled__WEBPACK_IMPORTED_MODULE_1__/* .StyledMarkdown */ .F, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_markdown__WEBPACK_IMPORTED_MODULE_2__/* .ReactMarkdown */ .D, {
            allowedElements: ALLOWED_ELEMENTS,
            rehypePlugins: [
                [
                    rehype_external_links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
                    {
                        target: "_blank"
                    }
                ],
                rehype_raw__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z
            ],
            children: content
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (MarkdownComponent);


/***/ }),

/***/ 45426:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jd": function() { return /* binding */ StyledRadioButtonIcon; },
/* harmony export */   "PA": function() { return /* binding */ StyledRadioButton; },
/* harmony export */   "WH": function() { return /* binding */ StyledRadioButtonLabel; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40286);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90408);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: ",
        ";\n  height: ",
        ";\n  border-radius: ",
        ";\n  border: 2px solid ",
        ";\n  position: relative;\n  transition: 0.3s;\n  flex-shrink: 0;\n\n  &::after {\n    content: '';\n    width: ",
        ";\n    height: ",
        ";\n    border-radius: ",
        ";\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background-color: ",
        ";\n    opacity: 0;\n    transition: 0.3s;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      input[type='radio'] {\n        & + label {\n          border: 1px solid ",
        ";\n          border-radius: ",
        ";\n          padding: ",
        ";\n          box-shadow: ",
        ";\n          cursor: pointer;\n\n          font-weight: ",
        ";\n        }\n\n        &:checked + label {\n          background: ",
        ";\n          border-color: ",
        ";\n        }\n      }\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n\n  input[type='radio'] {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    margin: -1px;\n    padding: 0;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    border: 0;\n\n    &:checked + label ",
        " {\n      background-color: ",
        ";\n      border-color: ",
        ";\n\n      &::after {\n        opacity: 1;\n      }\n    }\n\n    &:hover + label ",
        " {\n      border-color: ",
        ";\n    }\n\n    &:checked:hover + label ",
        " {\n      border-color: ",
        ";\n      background-color: ",
        ";\n    }\n\n    &:focus + label ",
        " {\n      outline: 0;\n      border-color: ",
        ";\n      box-shadow: 0 0 0 4px ",
        ";\n    }\n\n    &[disabled] {\n      pointer-events: none;\n\n      & + label {\n        color: ",
        ";\n        pointer-events: none;\n\n        ",
        " {\n          border-color: ",
        ";\n          background-color: ",
        ";\n        }\n      }\n\n      &:checked + label ",
        " {\n        border-color: ",
        ";\n        background-color: ",
        ";\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      flex-direction: row-reverse;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  line-height: 1;\n  vertical-align: text-bottom;\n  gap: ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var StyledRadioButtonIcon = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-17e359c5-0"
})(_templateObject(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .radius */ .q0)("full"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_200"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .radius */ .q0)("full"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_200"));
var StyledRadioButton = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-17e359c5-1"
})(_templateObject2(), StyledRadioButtonIcon, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_800"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_800"), StyledRadioButtonIcon, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_400"), StyledRadioButtonIcon, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_600"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_600"), StyledRadioButtonIcon, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_850"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_150"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("text_disabled"), StyledRadioButtonIcon, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("text-disabled"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_150"), StyledRadioButtonIcon, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_150"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_150"), function(param) {
    var isCard = param.isCard;
    return isCard && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_200"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .radius */ .q0)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .shadow */ .AF)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("extraBold"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("active"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("active"));
});
var StyledRadioButtonLabel = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].label.withConfig */ .ZP.label.withConfig({
    componentId: "sc-17e359c5-2"
})(_templateObject4(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs"), function(param) {
    var isLabelReversed = param.isLabelReversed;
    return isLabelReversed && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject3());
});


/***/ }),

/***/ 73273:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _RadioButton_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45426);





var RadioButton = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) /*#__PURE__*/ {
    var label = _param.label, id = _param.id, isLabelReversed = _param.isLabelReversed, _isCard = _param.isCard, isCard = _isCard === void 0 ? false : _isCard, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "label",
        "id",
        "isLabelReversed",
        "isCard"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_RadioButton_styled__WEBPACK_IMPORTED_MODULE_2__/* .StyledRadioButton */ .PA, {
        isCard: isCard,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                type: "radio",
                ref: ref,
                id: id
            }, other)),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_RadioButton_styled__WEBPACK_IMPORTED_MODULE_2__/* .StyledRadioButtonLabel */ .WH, {
                htmlFor: id,
                isLabelReversed: isLabelReversed,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_RadioButton_styled__WEBPACK_IMPORTED_MODULE_2__/* .StyledRadioButtonIcon */ .Jd, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: label
                    })
                ]
            })
        ]
    });
});
RadioButton.displayName = "RadioButton";
/* harmony default export */ __webpack_exports__["Z"] = (RadioButton);


/***/ }),

/***/ 99655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cd": function() { return /* reexport safe */ _Typography_styled__WEBPACK_IMPORTED_MODULE_0__.Cd; },
/* harmony export */   "XJ": function() { return /* reexport safe */ _Typography_styled__WEBPACK_IMPORTED_MODULE_0__.XJ; },
/* harmony export */   "aC": function() { return /* reexport safe */ _Typography_styled__WEBPACK_IMPORTED_MODULE_0__.aC; },
/* harmony export */   "by": function() { return /* reexport safe */ _Typography_styled__WEBPACK_IMPORTED_MODULE_0__.by; },
/* harmony export */   "k8": function() { return /* reexport safe */ _Typography_styled__WEBPACK_IMPORTED_MODULE_0__.k8; },
/* harmony export */   "nL": function() { return /* reexport safe */ _Typography_styled__WEBPACK_IMPORTED_MODULE_0__.nL; }
/* harmony export */ });
/* harmony import */ var _Typography_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90637);



/***/ }),

/***/ 90637:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cd": function() { return /* binding */ Heading6; },
/* harmony export */   "XJ": function() { return /* binding */ Heading2; },
/* harmony export */   "aC": function() { return /* binding */ Heading3; },
/* harmony export */   "by": function() { return /* binding */ Heading5; },
/* harmony export */   "k8": function() { return /* binding */ Heading4; },
/* harmony export */   "nL": function() { return /* binding */ Heading1; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40286);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90408);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      position: relative;\n\n      &::before {\n        content: '';\n        position: absolute;\n        top: calc(",
        " * -1);\n        left: 50%;\n        transform: translateX(-50%);\n        width: ",
        ";\n        height: ",
        ";\n        background-color: ",
        ";\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      margin-top: ",
        ";\n      user-select: none;\n\n      &::before {\n        left: 0;\n        transform: translateX(0);\n      }\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        &::before {\n          width: ",
        ";\n          height: ",
        ";\n        }\n      "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.17;\n  margin: 0;\n\n  ",
        "\n\n  ",
        "\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n\n    ",
        "\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      position: relative;\n\n      &::before {\n        content: '';\n        position: absolute;\n        top: calc(",
        " * -1);\n        left: 50%;\n        transform: translateX(-50%);\n        width: ",
        ";\n        height: ",
        ";\n        background-color: ",
        ";\n      }\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      margin-top: ",
        ";\n      user-select: none;\n\n      &::before {\n        left: 0;\n        transform: translateX(0);\n      }\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        &::before {\n          height: ",
        ";\n        }\n      "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.17;\n  margin: 0;\n\n  ",
        "\n  ",
        "\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n\n    ",
        "\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      position: relative;\n\n      &::before {\n        content: '';\n        position: absolute;\n        top: calc(",
        " * -1);\n        left: 50%;\n        transform: translateX(-50%);\n        width: ",
        ";\n        height: ",
        ";\n        background-color: ",
        ";\n      }\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      margin-top: ",
        ";\n      user-select: none;\n\n      &::before {\n        left: 0;\n        transform: translateX(0);\n      }\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.12;\n  margin: 0;\n\n  ",
        "\n\n  ",
        "\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.14;\n  margin: 0;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.14;\n  margin: 0;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.14;\n  margin: 0;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}


var Heading1 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h1.withConfig */ .ZP.h1.withConfig({
    componentId: "sc-f61a956f-0"
})(_templateObject3(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("serif"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("black"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl3"), function(param) {
    var editorial = param.editorial;
    return editorial && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl3"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("cyan_700"));
}, function(param) {
    var alignLeft = param.alignLeft;
    return alignLeft && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl4"));
}, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl4"), function(param) {
    var editorial = param.editorial;
    return editorial && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject2(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl4"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("sm"));
}, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl5"));
var Heading2 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h2.withConfig */ .ZP.h2.withConfig({
    componentId: "sc-f61a956f-1"
})(_templateObject7(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("serif"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("black"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl2"), function(param) {
    var editorial = param.editorial;
    return editorial && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject4(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl3"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("indigo_500"));
}, function(param) {
    var alignLeft = param.alignLeft;
    return alignLeft && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject5(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl4"));
}, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl3"), function(param) {
    var editorial = param.editorial;
    return editorial && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject6(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs"));
}, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl4"));
var Heading3 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
    componentId: "sc-f61a956f-2"
})(_templateObject10(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("serif"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("black"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl"), function(param) {
    var editorial = param.editorial;
    return editorial && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject8(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl3"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("mint_900"));
}, function(param) {
    var alignLeft = param.alignLeft;
    return alignLeft && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject9(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl4"));
}, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl2"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl3"));
var Heading4 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h4.withConfig */ .ZP.h4.withConfig({
    componentId: "sc-f61a956f-3"
})(_templateObject11(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("serif"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("bold"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl2"));
var Heading5 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h5.withConfig */ .ZP.h5.withConfig({
    componentId: "sc-f61a956f-4"
})(_templateObject12(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("serif"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("bold"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl"));
var Heading6 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h6.withConfig */ .ZP.h6.withConfig({
    componentId: "sc-f61a956f-5"
})(_templateObject13(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("serif"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("bold"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("lg"));


/***/ }),

/***/ 3111:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ct": function() { return /* binding */ StyledLevelCaption; },
/* harmony export */   "KT": function() { return /* binding */ StyledLevelLadderImage; },
/* harmony export */   "iB": function() { return /* binding */ StyledLevel; },
/* harmony export */   "tF": function() { return /* binding */ StyledLevelLadder; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40286);
/* harmony import */ var theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90408);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  --level1: ",
        ";\n  --level2: ",
        ";\n  --level3: ",
        ";\n  --level4: ",
        ";\n  --level-gradient: linear-gradient(\n    to right,\n    var(--level1),\n    var(--level1) ",
        ",\n    transparent ",
        ",\n    transparent calc(",
        " + ",
        "),\n    var(--level2) calc(",
        " + ",
        "),\n    var(--level2) calc(",
        " + ",
        " + ",
        "),\n    transparent calc(",
        " + ",
        " + ",
        "),\n    transparent\n      calc(\n        ",
        " + ",
        " + ",
        " +\n          ",
        "\n      ),\n    var(--level3)\n      calc(\n        ",
        " + ",
        " + ",
        " +\n          ",
        "\n      )\n  );\n  width: 3.5rem;\n  height: ",
        ";\n  clip-path: polygon(0 100%, 100% 0, 100% 100%);\n  background-image: var(--level-gradient);\n\n  &.level_1 {\n    --level1: ",
        ";\n  }\n  &.level_2 {\n    --level1: ",
        ";\n    --level2: ",
        ";\n  }\n  &.level_3 {\n    --level1: ",
        ";\n    --level2: ",
        ";\n    --level3: ",
        ";\n  }\n  &.level_4 {\n    --level1: ",
        ";\n    --level2: ",
        ";\n    --level3: ",
        ";\n    --level4: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n       {\n        min-width: 7rem;\n\n        ",
        " {\n          --level-gradient: linear-gradient(\n            to right,\n            var(--level1),\n            var(--level1) ",
        ",\n            transparent ",
        ",\n            transparent calc(",
        " + ",
        "),\n            var(--level2) calc(",
        " + ",
        "),\n            var(--level2)\n              calc(",
        " + ",
        " + ",
        "),\n            transparent\n              calc(",
        " + ",
        " + ",
        "),\n            transparent\n              calc(\n                ",
        " + ",
        " + ",
        " +\n                  ",
        "\n              ),\n            var(--level3)\n              calc(\n                ",
        " + ",
        " + ",
        " +\n                  ",
        "\n              ),\n            var(--level3)\n              calc(\n                ",
        " + ",
        " + ",
        " +\n                  ",
        " + ",
        "\n              ),\n            transparent\n              calc(\n                ",
        " + ",
        " + ",
        " +\n                  ",
        " + ",
        "\n              ),\n            transparent\n              calc(\n                ",
        " + ",
        " + ",
        " +\n                  ",
        " + ",
        " + ",
        "\n              ),\n            var(--level4)\n              calc(\n                ",
        " + ",
        " + ",
        " +\n                  ",
        " + ",
        " + ",
        "\n              )\n          );\n          width: 4.75rem;\n        }\n      }\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: ",
        ";\n  margin: 0;\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  text-transform: uppercase;\n  line-height: 1.333;\n  color: ",
        ";\n  text-align: right;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var StyledLevelLadderImage = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].img.withConfig */ .ZP.img.withConfig({
    componentId: "sc-6ff1bdd4-0"
})(_templateObject());
var StyledLevelLadder = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6ff1bdd4-1"
})(_templateObject1(), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("sand_150"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("sand_150"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("sand_150"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("sand_150"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("positive_500"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("positive_500"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("positive_500"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("positive_500"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("positive_500"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("positive_500"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("positive_500"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("positive_500"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("positive_500"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("positive_500"));
var StyledLevel = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].figure.withConfig */ .ZP.figure.withConfig({
    componentId: "sc-6ff1bdd4-2"
})(_templateObject3(), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), function(param) {
    var type = param.type;
    return type === "language" && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject2(), StyledLevelLadder, (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"));
});
var StyledLevelCaption = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].figcaption.withConfig */ .ZP.figcaption.withConfig({
    componentId: "sc-6ff1bdd4-3"
})(_templateObject4(), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("medium"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("text_subtle"));


/***/ }),

/***/ 18962:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var hooks_useI18n__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39105);
/* harmony import */ var utils_paths__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64516);
/* harmony import */ var _LevelLadder_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3111);




var LevelLadder = function(param) {
    var level = param.level, _type = param.type, type = _type === void 0 ? "language" : _type, _useImage = param.useImage, useImage = _useImage === void 0 ? false : _useImage;
    var t = (0,hooks_useI18n__WEBPACK_IMPORTED_MODULE_1__/* .useI18n */ .Q)("common").t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_LevelLadder_styled__WEBPACK_IMPORTED_MODULE_2__/* .StyledLevel */ .iB, {
        type: type,
        children: [
            useImage ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LevelLadder_styled__WEBPACK_IMPORTED_MODULE_2__/* .StyledLevelLadderImage */ .KT, {
                src: (0,utils_paths__WEBPACK_IMPORTED_MODULE_3__/* .getPublicPath */ .A)("/images/level-ladder/level_".concat(level, ".png"))
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LevelLadder_styled__WEBPACK_IMPORTED_MODULE_2__/* .StyledLevelLadder */ .tF, {
                className: "level_" + level
            }),
            type === "language" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_LevelLadder_styled__WEBPACK_IMPORTED_MODULE_2__/* .StyledLevelCaption */ .Ct, {
                children: [
                    level === 1 && t("language-selector.level.options.basic"),
                    level === 2 && t("language-selector.level.options.intermediate"),
                    level === 3 && t("language-selector.level.options.fluid"),
                    level === 4 && t("language-selector.level.options.native")
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LevelLadder);


/***/ }),

/***/ 84245:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

var WIPFeaturesContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(true);
/* harmony default export */ __webpack_exports__["Z"] = (WIPFeaturesContext);


/***/ }),

/***/ 35779:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DJ": function() { return /* binding */ getOfferOGDescription; },
/* harmony export */   "sh": function() { return /* binding */ getOfferOGTitle; }
/* harmony export */ });
/* unused harmony exports getOfferOGSalary, getOfferOGEquity, getOfferOGBonus */
/* harmony import */ var utils_i18n__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63898);
/* harmony import */ var _salary_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62420);


/**
 * Get offer title for OG metadata
 *
 * @param offer - (server-side model) to get the title from
 * @param locale - in which `Multilingual` server-side data will be retrieved
 * @returns  The offer title
 */ function getOfferOGTitle(offer, t, locale) {
    var ref, ref1;
    var companyName = (ref = offer.heroSectionData) === null || ref === void 0 ? void 0 : ref.companyName;
    var title = (ref1 = offer.heroSectionData) === null || ref1 === void 0 ? void 0 : ref1.jobTitle;
    var salary = getOfferOGSalary(offer);
    var equity = getOfferOGEquity(offer, locale);
    var bonus = getOfferOGBonus(offer);
    var salaryText = "[".concat(salary).concat(equity ? " + ".concat(equity) : "").concat(bonus ? " + ".concat(bonus) : "", "]");
    return t("offer-title", {
        title: title,
        salary: salaryText,
        company: companyName
    });
}
/**
 * Get the salary string of an `offer`
 *
 * @param offer - (server-side model) to get the salary from
 * @returns  The offer salary
 */ function getOfferOGSalary(offer) {
    var ref, ref1, ref2;
    return offer.isFreelance ? (0,_salary_service__WEBPACK_IMPORTED_MODULE_1__/* .getSalaryHourlyRate */ .BX)(offer) : (0,_salary_service__WEBPACK_IMPORTED_MODULE_1__/* .getSalaryRangeText */ .vg)({
        id: 0,
        min: ((ref = offer.heroSectionData) === null || ref === void 0 ? void 0 : ref.salaryMin) * 1000,
        max: ((ref1 = offer.heroSectionData) === null || ref1 === void 0 ? void 0 : ref1.salaryMax) * 1000,
        currency: (ref2 = offer.heroSectionData) === null || ref2 === void 0 ? void 0 : ref2.currency
    });
}
/**
 * Get the equity string of an `offer`
 *
 * @param offer - (server-side model) to get the equity from
 * @param i18n - i18n object to retrieve translations
 * @param locale - in which `Multilingual` server-side data will be retrieved
 * @returns  The offer equity
 */ function getOfferOGEquity(offer, locale) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var equity = (ref = offer.offerSectionData) === null || ref === void 0 ? void 0 : ref.offer.salaryExtra;
    if (!((ref1 = offer.bottombarData) === null || ref1 === void 0 ? void 0 : ref1.equityInf) && !((ref2 = offer.bottombarData) === null || ref2 === void 0 ? void 0 : ref2.equitySup)) {
        return null;
    }
    var equityText = (0,utils_i18n__WEBPACK_IMPORTED_MODULE_0__/* .getTranslation */ .i)("offer.equity", "job-offer", locale);
    if (!((ref3 = offer.bottombarData) === null || ref3 === void 0 ? void 0 : ref3.equityInf) && ((ref4 = offer.bottombarData) === null || ref4 === void 0 ? void 0 : ref4.equitySup) || ((ref5 = offer.bottombarData) === null || ref5 === void 0 ? void 0 : ref5.equityInf) && !((ref6 = offer.bottombarData) === null || ref6 === void 0 ? void 0 : ref6.equitySup)) {
        return equityText;
    }
    return equity ? "".concat(equity, "% ").concat(equityText) : null;
}
/**
 * Get the bonus string of an `offer`
 *
 * @param offer - (server-side model) to get the bonus from
 * @param locale - locale used to get data text
 * @returns  The offer bonus
 */ function getOfferOGBonus(offer, locale) {
    var ref, ref1, ref2;
    var bonus = ((ref = offer.heroSectionData) === null || ref === void 0 ? void 0 : ref.bonus) && +((ref1 = offer.heroSectionData) === null || ref1 === void 0 ? void 0 : ref1.bonus);
    return bonus ? "".concat((ref2 = offer.heroSectionData) === null || ref2 === void 0 ? void 0 : ref2.currency).concat(bonus, "K ").concat((0,utils_i18n__WEBPACK_IMPORTED_MODULE_0__/* .getTranslation */ .i)("offer.bonus", "job-offer", locale)) : null;
}
/**
 * Get the description for OG metadata
 *
 * @param offer - (server-side model) to get the title from
 * @param locale - in which `Multilingual` server-side data will be retrieved
 * @returns  The offer title
 */ function getOfferOGDescription(offer, t, locale) {
    var ref, ref1;
    var companyName = (ref = offer.heroSectionData) === null || ref === void 0 ? void 0 : ref.companyName;
    var title = (ref1 = offer.heroSectionData) === null || ref1 === void 0 ? void 0 : ref1.jobTitle;
    var salary = getOfferOGSalary(offer);
    var equity = getOfferOGEquity(offer, locale);
    var bonus = getOfferOGBonus(offer);
    var salaryText = "[".concat(salary).concat(equity ? " + ".concat(equity) : "").concat(bonus ? " + ".concat(bonus) : "", "]");
    return t("offer-desc", {
        title: title,
        salary: salaryText,
        company: companyName
    });
}


/***/ }),

/***/ 58630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jf": function() { return /* binding */ getOfferUrl; },
/* harmony export */   "Wl": function() { return /* binding */ getCityStringFromUIPlacesAutocompleteItem; },
/* harmony export */   "Z2": function() { return /* binding */ getCanonicalUrl; }
/* harmony export */ });
/* harmony import */ var utils_app_urls__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62177);

/**
 * Get the canonical `offer` URL for a given `origin` and `locale`
 *
 * @param origin - base URL for the canonical link
 * @param offer - (server-side model) to get the title from
 * @param locale - in which `Multilingual` server-side data will be retrieved
 * @returns  The offer canonical URL
 */ function getCanonicalUrl(origin, offer, locale) {
    return "".concat(origin, "/").concat(locale).concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_0__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_0__/* .APP_URLS.jobOffer */ .uu.jobOffer, locale)).concat(getOfferUrl(offer, locale));
}
/**
 * Get the `offer` URL for a given `locale`
 *

 * @param offer - (server-side model) to get the title from
 * @param locale - in which `Multilingual` server-side data will be retrieved
 * @returns  The offer  URL
 */ function getOfferUrl(offer, locale) {
    var slug = offer.slug;
    return "/".concat(offer.id, "/").concat(slug);
}
function cleanLocations(location) {
    return location.replace(", Espa\xf1a", "").replace(", Spain", "");
}
var LOCATIONS_SEPARATOR = ", ";
function getCityStringFromUIPlacesAutocompleteItem(locations, // eslint-disable-next-line @typescript-eslint/no-unused-vars
_locale) {
    return (locations === null || locations === void 0 ? void 0 : locations.map(function(location) {
        return (location === null || location === void 0 ? void 0 : location.displayName) || "";
    }).filter(Boolean).map(cleanLocations).join(LOCATIONS_SEPARATOR)) || "";
}


/***/ }),

/***/ 27805:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _createClass; }
/* harmony export */ });
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}


/***/ })

}]);